
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("iNYtG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4r9Ir = parcelRequire("4r9Ir");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $bQm3c = parcelRequire("bQm3c");


var $6UYek = parcelRequire("6UYek");


var $8i27m = parcelRequire("8i27m");


var $3mVfX = parcelRequire("3mVfX");


var $dkkKv = parcelRequire("dkkKv");


var $l5y3Y = parcelRequire("l5y3Y");


var $fHAwL = parcelRequire("fHAwL");


var $d3bcC = parcelRequire("d3bcC");


var $6mKj3 = parcelRequire("6mKj3");


var $NYiei = parcelRequire("NYiei");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $804Ue = parcelRequire("804Ue");


var $7S9uM = parcelRequire("7S9uM");


var $gRrX4 = parcelRequire("gRrX4");





var $9wGTI = parcelRequire("9wGTI");





var $kQekh = parcelRequire("kQekh");

/**
 * @generated SignedSource<<6878ec89ffd5ea66302061c0b988393f>>
 * @relayHash 4b2b231d2dc45d90f0e6c67f64d74442
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 59117d0e39c953fac3a300093542641681064ffbd898fae1d4fd06ea427e52d0
const $6a66bb9e87369108$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "commentId",
            "variableName": "commentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "ancestors",
        "plural": true,
        "selections": [
            v2 /*: any*/ 
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionType"
            }
        ],
        "type": "KnownUser"
    }, v9 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v10 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v9 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v11 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v12 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v9 /*: any*/ 
    }, v13 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v14 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v16 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v17 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v18 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v19 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v15 /*: any*/ ,
                    v16 /*: any*/ ,
                    v17 /*: any*/ ,
                    v18 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v20 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v15 /*: any*/ ,
                    v16 /*: any*/ ,
                    v17 /*: any*/ ,
                    v18 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v21 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v22 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v24 = {
        "kind": "ScalarField",
        "name": "number"
    }, v25 = {
        "kind": "ScalarField",
        "name": "when"
    }, v26 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ 
        ],
        "type": "KnownUser"
    }, v27 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            {
                "kind": "Variable",
                "name": "pageId",
                "variableName": "contentId"
            }
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v2 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v28 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ActivePageCommentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v26 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v27 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v12 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v21 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ActivePageCommentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v28 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v28 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v28 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v26 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v27 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v28 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v12 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v21 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "4b2b231d2dc45d90f0e6c67f64d74442",
            "id": "59117d0e39c953fac3a300093542641681064ffbd898fae1d4fd06ea427e52d0",
            "metadata": {},
            "name": "ActivePageCommentQuery",
            "operationKind": "query",
            "text": "query ActivePageCommentQuery($commentId:ID!,$contentId:ID!){comments(commentId:$commentId){nodes{id,ancestors{id},author{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId,permissionType}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{isDangling,resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}},...on FooterComment{commentResolveProperties{resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{friendlyWhen,number,when,by{__typename,type,displayName,...on KnownUser{accountId}}},reactionsSummary(pageId:$contentId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}},replies{id,author{__typename,type,...on KnownUser{accountId,permissionType}},createdAt{value},createdAtNonLocalized,parentId}}}}"
        }
    };
}();
$6a66bb9e87369108$var$node.hash = "74318b0c1a4a8927e074ad4bb12d4099";
var $6a66bb9e87369108$export$2e2bcd8739ae039 = $6a66bb9e87369108$var$node;


const $f35c50316f68c508$export$34ea693bdbe9d3f6 = (0, $6a66bb9e87369108$export$2e2bcd8739ae039);



var $e4kZB = parcelRequire("e4kZB");


var $lb2Lp = parcelRequire("lb2Lp");


var $c0rhi = parcelRequire("c0rhi");


var $b11gn = parcelRequire("b11gn");







const $406672c94379d4ab$export$5a1cd239009d83a6 = async (commentId, { contentId: contentId, isReactionsEnabled: isReactionsEnabled })=>{
    const query = isReactionsEnabled ? (0, $kQekh.CommentsSectionGetSingleCommentQuery) : (0, $kQekh.CommentsSectionGetSingleCommentWithoutReactionsQuery);
    const variables = isReactionsEnabled ? {
        commentId: commentId,
        contentId: contentId
    } : {
        commentId: commentId
    };
    // Query the single comment to update the cache
    (0, $c0rhi.queryInterop)({
        query: query,
        variables: variables,
        __callerPackage__: "@confluence/comments-pubsub"
    });
};
const $406672c94379d4ab$export$af4b8274c1b86043 = (reloader, addNewComment, commentData, currentUserId)=>reloader().then(()=>{
        setTimeout(()=>{
            // HACK: Give the comments section time to render the new comment
            commentData.forEach((data)=>{
                addNewComment({
                    newCommentId: data.commentId,
                    currentUserMadeComment: data.accountId === currentUserId
                });
            });
        }, 3000);
    }).catch((err)=>{
        throw err;
    });


const $ced40be9017d58cb$export$66752be9311cfe87 = async (contentId, commentId)=>{
    const queryVariables = {
        commentId: commentId,
        contentId: contentId
    };
    const commentDataResult = await (0, $c0rhi.queryInterop)({
        query: (0, $kQekh.CommentsSectionGetSingleCommentQuery),
        fetchPolicy: 'network-only',
        variables: queryVariables,
        __callerPackage__: "@confluence/comments-pubsub"
    });
    return commentDataResult.data;
};
const $ced40be9017d58cb$export$e02e3f365960f15 = async (contentId, commentId)=>{
    const queryVariables = {
        commentId: commentId,
        contentId: contentId
    };
    const commentDataResult = await (0, $c0rhi.queryInterop)({
        query: (0, $f35c50316f68c508$export$34ea693bdbe9d3f6),
        fetchPolicy: 'network-only',
        variables: queryVariables,
        __callerPackage__: "@confluence/comments-pubsub"
    });
    return commentDataResult.data;
};
const $ced40be9017d58cb$export$37a9d770052438a6 = async ({ commentId: commentId, contentId: contentId, addNewCommentThreads: addNewCommentThreads, addReplyToCommentThread: addReplyToCommentThread })=>{
    const commentThreadDataResult = await $ced40be9017d58cb$export$66752be9311cfe87(contentId, commentId ?? '');
    const comment = commentThreadDataResult?.comments?.nodes?.[0];
    if (comment) {
        const createdAt = comment.version.when;
        const commentLocation = comment.location;
        // Parent comment case
        if (!comment.parentId) addNewCommentThreads && addNewCommentThreads({
            general: {
                [comment.id]: {
                    ...comment,
                    isOpen: true,
                    wasRemovedByAnotherUser: false,
                    type: (0, $8i27m.CommentType).GENERAL,
                    replies: [],
                    // Newly created comments will never have replies
                    createdAt: {
                        value: createdAt
                    },
                    location: {
                        type: 'FOOTER',
                        commentResolveProperties: commentLocation.commentResolveProperties
                    },
                    links: {
                        webui: comment.links.webui,
                        editui: null
                    },
                    permissions: {
                        isEditable: comment.permissions.isEditable,
                        isRemovable: comment.permissions.isRemovable,
                        isResolvable: true
                    }
                }
            },
            inline: {}
        });
        else {
            const threadKey = comment.ancestors[comment.ancestors.length - 1]?.id ?? comment.id;
            addReplyToCommentThread && addReplyToCommentThread(threadKey, {
                ...comment,
                isOpen: true,
                wasRemovedByAnotherUser: false,
                type: (0, $8i27m.CommentType).GENERAL,
                createdAt: {
                    value: createdAt
                },
                location: {
                    type: 'FOOTER',
                    commentResolveProperties: commentLocation.commentResolveProperties
                },
                links: {
                    webui: comment.links.webui,
                    editui: null
                },
                permissions: {
                    isEditable: comment.permissions.isEditable,
                    isRemovable: comment.permissions.isRemovable,
                    isResolvable: true
                }
            }, (0, $8i27m.CommentType).GENERAL);
        }
    }
};
const $ced40be9017d58cb$export$9cc4fc7c59ab4b10 = async ({ commentId: commentId, contentId: contentId, updateCommentBody: updateCommentBody })=>{
    const commentThreadDataResult = await $ced40be9017d58cb$export$66752be9311cfe87(contentId, commentId ?? '');
    const comment = commentThreadDataResult?.comments?.nodes?.[0];
    if (comment) {
        const threadKey = comment.ancestors[comment.ancestors.length - 1]?.id ?? comment.id;
        updateCommentBody && updateCommentBody(comment.id, threadKey, comment.body.value, (0, $8i27m.CommentType).GENERAL, comment.version?.by?.displayName);
    }
};
const $ced40be9017d58cb$export$4d3ff641e060619d = async ({ commentId: commentId, contentId: contentId, updateRemovedCommentIdsMap: updateRemovedCommentIdsMap })=>{
    const commentThreadDataResult = await $ced40be9017d58cb$export$66752be9311cfe87(contentId, commentId ?? '');
    const comment = commentThreadDataResult?.comments?.nodes?.[0];
    if (comment && // @ts-expect-error
    comment.location.__typename === 'FooterComment' && comment.location.commentResolveProperties && (0, $9wGTI.fg)('confluence_gen_comments_resolve_pubsub')) updateRemovedCommentIdsMap && updateRemovedCommentIdsMap({
        threadKey: comment.id,
        commentId: comment.id,
        commentActionType: (0, $8i27m.CommentActionType).RESOLVE_COMMENT_THREAD,
        isReply: !!comment.parentId,
        commentType: (0, $8i27m.CommentType).GENERAL,
        resolvedProperties: comment.location.commentResolveProperties
    });
    else if (comment) updateRemovedCommentIdsMap && updateRemovedCommentIdsMap({
        threadKey: comment.id,
        commentId: comment.id,
        commentActionType: (0, $8i27m.CommentActionType).RESOLVE_COMMENT_THREAD,
        isReply: !!comment.parentId,
        commentType: (0, $8i27m.CommentType).GENERAL
    });
};
const $ced40be9017d58cb$export$bbee85055c5ba3c6 = async ({ commentId: commentId, contentId: contentId, addNewCommentThreads: addNewCommentThreads, getCurrentCommentsPanelState: getCurrentCommentsPanelState })=>{
    if (!getCurrentCommentsPanelState) return;
    const { commentsDataMap: commentsDataMap } = getCurrentCommentsPanelState();
    // Use the new ActivePageCommentQuery
    const commentThreadDataResult = await $ced40be9017d58cb$export$e02e3f365960f15(contentId, commentId ?? '');
    const comment = commentThreadDataResult?.comments?.nodes?.[0];
    if (comment && commentsDataMap) {
        const commentsDataMapClone = {
            ...commentsDataMap
        };
        const commentInMap = commentsDataMapClone[(0, $8i27m.CommentType).GENERAL][comment.id];
        if (commentInMap) {
            commentInMap.isOpen = true;
            commentInMap.wasRemovedByAnotherUser = false;
            addNewCommentThreads && addNewCommentThreads(commentsDataMapClone);
        }
    }
    return comment;
};
const $ced40be9017d58cb$var$handleUnreadCommentsForReopenedComment = ({ comment: comment, userId: userId, viewedComments: viewedComments, updateUnreadCommentIDSet: updateUnreadCommentIDSet })=>{
    const validUnreadCommentIds = new Set();
    // Validate the main comment
    const commentForValidation = (0, $e4kZB.buildValidationObjectFromProps)({
        commentId: comment.id,
        userId: comment.author?.__typename === 'KnownUser' ? comment.author.accountId : undefined,
        createdAt: comment.createdAt?.value || undefined,
        commentType: 'FOOTER',
        // Page comments are always FOOTER type
        resolveProperties: {
            resolved: false
        } // reopened comment = resolved false
    });
    if ((0, $e4kZB.isValidUnreadComment)({
        comment: commentForValidation,
        currentUserId: userId,
        viewedComments: viewedComments
    })) validUnreadCommentIds.add(comment.id);
    // Validate replies if they exist
    if (comment.replies) comment.replies.forEach((reply)=>{
        const replyForValidation = (0, $e4kZB.buildValidationObjectFromProps)({
            commentId: reply.id,
            userId: reply.author?.__typename === 'KnownUser' ? reply.author.accountId : undefined,
            createdAt: reply.createdAt?.value || undefined,
            commentType: 'FOOTER',
            // Page comments are always FOOTER type
            resolveProperties: {
                resolved: false
            } // reopened comment = resolved false
        });
        if ((0, $e4kZB.isValidUnreadComment)({
            comment: replyForValidation,
            currentUserId: userId,
            viewedComments: viewedComments
        })) validUnreadCommentIds.add(reply.id);
    });
    updateUnreadCommentIDSet(validUnreadCommentIds, 'add');
};
const $ced40be9017d58cb$export$d4b860510819f61b = async ({ commentId: commentId, updateRemovedCommentIdsMap: updateRemovedCommentIdsMap, getCurrentCommentsPanelState: getCurrentCommentsPanelState })=>{
    if (commentId) {
        // Default to code to delete the top-level comment
        let threadKey = commentId;
        let isReply = false;
        // This should always be true, but if it isn't don't break
        // This case handles removing replies in the panel
        if (getCurrentCommentsPanelState) {
            const { commentsDataMap: commentsDataMap } = getCurrentCommentsPanelState();
            // If the comment is not in the general map, it's a reply
            // That means we need to loop through the flat arrays of replies for each parent comment to find our id
            // It's not fast since it potentially checks every comment on the page, but it's better than a network call
            if (!commentsDataMap[(0, $8i27m.CommentType).GENERAL][commentId]) {
                const allGeneralComments = commentsDataMap[(0, $8i27m.CommentType).GENERAL];
                for (const parentComment of Object.values(allGeneralComments))if (parentComment.replies) {
                    for (const reply of parentComment.replies)if (reply.id === commentId) {
                        threadKey = parentComment.id;
                        isReply = true;
                        break;
                    }
                }
            }
        }
        updateRemovedCommentIdsMap && updateRemovedCommentIdsMap({
            threadKey: threadKey,
            commentId: commentId,
            commentActionType: (0, $8i27m.CommentActionType).DELETE_COMMENT,
            isReply: isReply,
            commentType: (0, $8i27m.CommentType).GENERAL
        });
    }
};
const $ced40be9017d58cb$export$4d067148c1e8c84d = ({ userId: userId, contentId: contentId, reloader: reloader, addNewComment: addNewComment, removeComment: removeComment, updateQueryVariables: updateQueryVariables, addNewCommentThreads: addNewCommentThreads, addReplyToCommentThread: addReplyToCommentThread, updateCommentBody: updateCommentBody, updateRemovedCommentIdsMap: updateRemovedCommentIdsMap, reopenParentComment: reopenParentComment, getCurrentCommentsPanelState: getCurrentCommentsPanelState, getViewedCommentsCacheOnly: getViewedCommentsCacheOnly, updateUnreadCommentIDSet: updateUnreadCommentIDSet, addCommentInCache: addCommentInCache, deleteCommentInCache: deleteCommentInCache, clearReplyIfRemoved: clearReplyIfRemoved })=>(event, payload)=>{
        if (!event) return;
        let commentRequestBody;
        const { accountId: accountId } = payload;
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) commentRequestBody = payload?.[event];
        else commentRequestBody = payload.commentRequestBody;
        const { commentId: commentId } = commentRequestBody;
        // We don't need to respond to events that the current user has initiated
        if (userId === accountId) return;
        const { start: startCommentsPubSubExperience, succeed: succeedCommentsPubSubExperience, fail: failCommentsPubSubExperience } = (0, $b11gn.createCommentsPubSubExperienceTracker)((0, $b11gn.CommentsPubSubSource).PageCommentsPubSub);
        startCommentsPubSubExperience(event);
        try {
            switch(event){
                case 'commentCreated':
                case 'avi:confluence:created:comment':
                    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                        if (addCommentInCache && commentId) (0, $lb2Lp.fetchCommentById)({
                            commentId: commentId,
                            contentId: contentId,
                            fetchPolicy: 'network-only'
                        }).then((comment)=>{
                            if (comment) addCommentInCache({
                                newComment: comment,
                                onError: failCommentsPubSubExperience
                            });
                        }).then(()=>{
                            succeedCommentsPubSubExperience();
                        }).catch((err)=>{
                            failCommentsPubSubExperience(err);
                        });
                        else failCommentsPubSubExperience(new Error('commentCreated: addCommentInCache or commentId is not defined'));
                    } else if (!reloader || !addNewComment) failCommentsPubSubExperience(new Error('commentCreated: reloader or addNewComment is not defined'));
                    else Promise.all([
                        $ced40be9017d58cb$export$37a9d770052438a6({
                            commentId: commentId,
                            contentId: contentId,
                            addNewCommentThreads: addNewCommentThreads,
                            addReplyToCommentThread: addReplyToCommentThread
                        }),
                        (0, $406672c94379d4ab$export$af4b8274c1b86043)(reloader, addNewComment, [
                            {
                                commentId: commentId,
                                accountId: accountId
                            }
                        ], userId)
                    ]).then(()=>{
                        succeedCommentsPubSubExperience();
                    }).catch((err)=>{
                        failCommentsPubSubExperience(err);
                    });
                    if (updateUnreadCommentIDSet) updateUnreadCommentIDSet(new Set([
                        commentId
                    ]), 'add');
                    break;
                case 'commentResolved':
                case 'avi:confluence:resolved:comment':
                    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                        if (commentId) // fetchCommentById implicitly updates useAllCommentsDataQuery cache
                        (0, $lb2Lp.fetchCommentById)({
                            commentId: commentId,
                            contentId: contentId,
                            fetchPolicy: 'network-only'
                        }).then(()=>{
                            clearReplyIfRemoved?.({
                                commentId: commentId
                            });
                            // Handle unread comments after fetchCommentById completes
                            const { replies: replies = [] } = commentRequestBody;
                            if (updateUnreadCommentIDSet) updateUnreadCommentIDSet(new Set([
                                commentId,
                                ...replies
                            ]), 'remove');
                        }).then(()=>{
                            succeedCommentsPubSubExperience();
                        }).catch((err)=>{
                            failCommentsPubSubExperience(err);
                        });
                        else failCommentsPubSubExperience(new Error('commentResolved: commentId is not defined'));
                        // When cc_comments_new_comments_data_manager is enabled, only commentActionType and commentId are used
                        // The rest of the variables here are defaults
                        if (updateRemovedCommentIdsMap && commentId) updateRemovedCommentIdsMap({
                            threadKey: commentId,
                            commentId: commentId,
                            commentActionType: (0, $8i27m.CommentActionType).RESOLVE_COMMENT_THREAD,
                            isReply: false,
                            commentType: (0, $8i27m.CommentType).GENERAL
                        });
                    } else if (reloader) reloader().then(()=>$ced40be9017d58cb$export$4d3ff641e060619d({
                            commentId: commentId,
                            contentId: contentId,
                            updateRemovedCommentIdsMap: updateRemovedCommentIdsMap
                        }).then(()=>{
                            // Handle unread comments after reloader completes
                            const { replies: replies = [] } = commentRequestBody;
                            if (updateUnreadCommentIDSet) updateUnreadCommentIDSet(new Set([
                                commentId,
                                ...replies
                            ]), 'remove');
                        })).then(()=>{
                        succeedCommentsPubSubExperience();
                    }).catch((err)=>{
                        failCommentsPubSubExperience(err);
                    });
                    else failCommentsPubSubExperience(new Error('commentResolved: reloader is not defined'));
                    break;
                case 'commentDeleted':
                case 'avi:confluence:deleted:comment':
                    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                        if (deleteCommentInCache && commentId) {
                            const deletionSuccessful = deleteCommentInCache({
                                commentId: commentId,
                                onError: failCommentsPubSubExperience
                            });
                            if (deletionSuccessful) clearReplyIfRemoved?.({
                                commentId: commentId
                            });
                        }
                        if (updateUnreadCommentIDSet) updateUnreadCommentIDSet(new Set([
                            commentId
                        ]), 'remove');
                        // When cc_comments_new_comments_data_manager is enabled, only commentActionType and commentId are used
                        // The rest of the variables here are defaults
                        if (updateRemovedCommentIdsMap && commentId) updateRemovedCommentIdsMap({
                            threadKey: commentId,
                            commentId: commentId,
                            commentActionType: (0, $8i27m.CommentActionType).DELETE_COMMENT,
                            isReply: false,
                            commentType: (0, $8i27m.CommentType).GENERAL
                        });
                        succeedCommentsPubSubExperience();
                    } else if (!reloader) failCommentsPubSubExperience(new Error('commentDeleted: reloader is not defined'));
                    else Promise.all([
                        $ced40be9017d58cb$export$d4b860510819f61b({
                            commentId: commentId,
                            updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
                            getCurrentCommentsPanelState: getCurrentCommentsPanelState
                        }),
                        reloader().then(()=>{
                            removeComment && removeComment(commentId);
                            if (updateUnreadCommentIDSet) updateUnreadCommentIDSet(new Set([
                                commentId
                            ]), 'remove');
                        })
                    ]).then(()=>{
                        succeedCommentsPubSubExperience();
                    }).catch((err)=>{
                        failCommentsPubSubExperience(err);
                    });
                    break;
                case 'commentReopened':
                case 'avi:confluence:reopen:comment':
                    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                        if (commentId) // fetchCommentById implicitly updates useAllCommentsDataQuery cache
                        (0, $lb2Lp.fetchCommentById)({
                            commentId: commentId,
                            contentId: contentId,
                            fetchPolicy: 'network-only'
                        }).then((commentData)=>{
                            // Handle unread comments with the fetched comment data
                            if (updateUnreadCommentIDSet && commentData && userId && getViewedCommentsCacheOnly) {
                                const viewedCommentsResult = getViewedCommentsCacheOnly();
                                if (viewedCommentsResult.success && viewedCommentsResult.data) $ced40be9017d58cb$var$handleUnreadCommentsForReopenedComment({
                                    comment: commentData,
                                    userId: userId,
                                    viewedComments: viewedCommentsResult.data,
                                    updateUnreadCommentIDSet: updateUnreadCommentIDSet
                                });
                            }
                        }).then(()=>{
                            succeedCommentsPubSubExperience();
                        }).catch((err)=>{
                            failCommentsPubSubExperience(err);
                        });
                        else failCommentsPubSubExperience(new Error('commentReopened: commentId is not defined'));
                    } else if (reloader) reloader().then(async ()=>{
                        const comment = await $ced40be9017d58cb$export$bbee85055c5ba3c6({
                            commentId: commentId,
                            contentId: contentId,
                            addNewCommentThreads: addNewCommentThreads,
                            getCurrentCommentsPanelState: getCurrentCommentsPanelState
                        });
                        // Handle unread comments with the existing comment data
                        if (updateUnreadCommentIDSet && comment && userId && getViewedCommentsCacheOnly) {
                            const viewedCommentsResult = getViewedCommentsCacheOnly();
                            if (viewedCommentsResult.success && viewedCommentsResult.data) $ced40be9017d58cb$var$handleUnreadCommentsForReopenedComment({
                                comment: comment,
                                userId: userId,
                                viewedComments: viewedCommentsResult.data,
                                updateUnreadCommentIDSet: updateUnreadCommentIDSet
                            });
                        }
                    }).then(()=>{
                        succeedCommentsPubSubExperience();
                    }).catch((err)=>{
                        failCommentsPubSubExperience(err);
                    });
                    else failCommentsPubSubExperience(new Error('commentReopened: reloader is not defined'));
                    // Remove from commentThreadsRemovedByOtherUsers when reopened
                    if (commentId && reopenParentComment) reopenParentComment({
                        threadKey: commentId,
                        commentType: (0, $8i27m.CommentType).GENERAL,
                        parentCommentId: commentId
                    });
                    break;
                case 'commentUpdated':
                case 'avi:confluence:updated:comment':
                    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                        if (commentId) // fetchCommentById implicitly updates useAllCommentsDataQuery cache
                        (0, $lb2Lp.fetchCommentById)({
                            commentId: commentId,
                            contentId: contentId,
                            fetchPolicy: 'network-only'
                        }).then(()=>{
                            succeedCommentsPubSubExperience();
                        }).catch((err)=>{
                            failCommentsPubSubExperience(err);
                        });
                        else failCommentsPubSubExperience(new Error('commentUpdated: commentId is not defined'));
                    } else if (updateQueryVariables) Promise.all([
                        $ced40be9017d58cb$export$9cc4fc7c59ab4b10({
                            commentId: commentId,
                            contentId: contentId,
                            updateCommentBody: updateCommentBody
                        }),
                        (0, $406672c94379d4ab$export$5a1cd239009d83a6)(commentId, updateQueryVariables)
                    ]).then(()=>{
                        succeedCommentsPubSubExperience();
                    }).catch((err)=>{
                        failCommentsPubSubExperience(err);
                    });
                    else failCommentsPubSubExperience(new Error('commentUpdated: updateQueryVariables is not defined'));
                    break;
                default:
                    failCommentsPubSubExperience(new Error(`Unhandled comments pubsub event: ${event}`));
                    break;
            }
        } catch (error) {
            failCommentsPubSubExperience(error);
            throw error;
        }
    };
const $ced40be9017d58cb$export$c542af303309df99 = ({ contentId: contentId, contentType: contentType, userId: userId, reloader: reloader, addNewComment: addNewComment, removeComment: removeComment, queryArgs: { isReactionsEnabled: isReactionsEnabled }, addNewCommentThreads: addNewCommentThreads, addReplyToCommentThread: addReplyToCommentThread, updateCommentBody: updateCommentBody, updateRemovedCommentIdsMap: updateRemovedCommentIdsMap, reopenParentComment: reopenParentComment, getCurrentCommentsPanelState: getCurrentCommentsPanelState, addSubscriber: addSubscriber, setContentType: setContentType, setContentId: setContentId, updateUnreadCommentIDSet: updateUnreadCommentIDSet, getViewedCommentsCacheOnly: getViewedCommentsCacheOnly, addCommentInCache: addCommentInCache, deleteCommentInCache: deleteCommentInCache, clearReplyIfRemoved: clearReplyIfRemoved })=>{
    const pubSubResourceType = contentType || 'page';
    const subscriberIds = [];
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) {
        if (!addSubscriber || !setContentType || !setContentId) return;
        setContentType(pubSubResourceType);
        setContentId(contentId);
        const subscribers = [
            {
                subscriberId: 'pageCommentsPubSubCommentCreated',
                onSubscriptionData: $ced40be9017d58cb$export$4d067148c1e8c84d({
                    userId: userId,
                    contentId: contentId,
                    reloader: reloader,
                    addNewComment: addNewComment,
                    addNewCommentThreads: addNewCommentThreads,
                    addReplyToCommentThread: addReplyToCommentThread,
                    updateUnreadCommentIDSet: updateUnreadCommentIDSet,
                    addCommentInCache: addCommentInCache
                }),
                delta: 'commentCreated'
            },
            {
                subscriberId: 'pageCommentsPubSubCommentResolved',
                onSubscriptionData: $ced40be9017d58cb$export$4d067148c1e8c84d({
                    userId: userId,
                    contentId: contentId,
                    reloader: reloader,
                    addNewComment: addNewComment,
                    updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
                    updateUnreadCommentIDSet: updateUnreadCommentIDSet,
                    clearReplyIfRemoved: clearReplyIfRemoved
                }),
                delta: 'commentResolved'
            },
            {
                subscriberId: 'pageCommentsPubSubCommentDeleted',
                onSubscriptionData: $ced40be9017d58cb$export$4d067148c1e8c84d({
                    userId: userId,
                    contentId: contentId,
                    reloader: reloader,
                    removeComment: removeComment,
                    updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
                    getCurrentCommentsPanelState: getCurrentCommentsPanelState,
                    updateUnreadCommentIDSet: updateUnreadCommentIDSet,
                    deleteCommentInCache: deleteCommentInCache,
                    clearReplyIfRemoved: clearReplyIfRemoved
                }),
                delta: 'commentDeleted'
            },
            {
                subscriberId: 'pageCommentsPubSubCommentReopened',
                onSubscriptionData: $ced40be9017d58cb$export$4d067148c1e8c84d({
                    userId: userId,
                    contentId: contentId,
                    reloader: reloader,
                    addNewComment: addNewComment,
                    addNewCommentThreads: addNewCommentThreads,
                    reopenParentComment: reopenParentComment,
                    getCurrentCommentsPanelState: getCurrentCommentsPanelState,
                    getViewedCommentsCacheOnly: getViewedCommentsCacheOnly,
                    updateUnreadCommentIDSet: updateUnreadCommentIDSet
                }),
                delta: 'commentReopened'
            },
            {
                subscriberId: 'pageCommentsPubSubCommentUpdated',
                onSubscriptionData: $ced40be9017d58cb$export$4d067148c1e8c84d({
                    userId: userId,
                    contentId: contentId,
                    updateQueryVariables: {
                        contentId: contentId,
                        isReactionsEnabled: isReactionsEnabled
                    },
                    updateCommentBody: updateCommentBody
                }),
                delta: 'commentUpdated'
            }
        ];
        for (const subscriber of subscribers)subscriberIds.push({
            subscriberId: addSubscriber(subscriber),
            delta: subscriber.delta
        });
        return subscriberIds;
    } else (0, $gRrX4.getPubSubClient)().then((client)=>{
        client.joinChannel(pubSubResourceType, contentId).finally(()=>{
            client.subscribe((0, $7S9uM.eventToAvi)('created:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
                userId: userId,
                contentId: contentId,
                reloader: reloader,
                addNewComment: addNewComment,
                addNewCommentThreads: addNewCommentThreads,
                addReplyToCommentThread: addReplyToCommentThread,
                updateUnreadCommentIDSet: updateUnreadCommentIDSet,
                addCommentInCache: addCommentInCache
            }));
            client.subscribe((0, $7S9uM.eventToAvi)('resolved:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
                userId: userId,
                contentId: contentId,
                reloader: reloader,
                addNewComment: addNewComment,
                updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
                updateUnreadCommentIDSet: updateUnreadCommentIDSet
            }));
            client.subscribe((0, $7S9uM.eventToAvi)('deleted:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
                userId: userId,
                contentId: contentId,
                reloader: reloader,
                removeComment: removeComment,
                updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
                getCurrentCommentsPanelState: getCurrentCommentsPanelState,
                updateUnreadCommentIDSet: updateUnreadCommentIDSet,
                deleteCommentInCache: deleteCommentInCache
            }));
            client.subscribe((0, $7S9uM.eventToAvi)('reopen:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
                userId: userId,
                contentId: contentId,
                reloader: reloader,
                addNewComment: addNewComment,
                addNewCommentThreads: addNewCommentThreads,
                reopenParentComment: reopenParentComment,
                getCurrentCommentsPanelState: getCurrentCommentsPanelState,
                getViewedCommentsCacheOnly: getViewedCommentsCacheOnly,
                updateUnreadCommentIDSet: updateUnreadCommentIDSet
            }));
            client.subscribe((0, $7S9uM.eventToAvi)('updated:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
                userId: userId,
                contentId: contentId,
                updateQueryVariables: {
                    contentId: contentId,
                    isReactionsEnabled: isReactionsEnabled
                },
                updateCommentBody: updateCommentBody
            }));
        }).catch((error)=>{
            throw new Error(`Unable to joinChannel ${JSON.stringify(error)}`);
        });
    });
};
const $ced40be9017d58cb$export$f6e2e9a186163b28 = ({ contentId: contentId, contentType: contentType, userId: userId, reloader: reloader, addNewComment: addNewComment, removeComment: removeComment, queryArgs: { isReactionsEnabled: isReactionsEnabled }, removeSubscriber: removeSubscriber, subscriptions: subscriptions, getViewedCommentsCacheOnly: getViewedCommentsCacheOnly })=>{
    const pubSubResourceType = contentType || 'page';
    const eventsToUnsubscribe = [
        'commentCreated',
        'commentDeleted',
        'commentUpdated'
    ];
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) {
        if (!removeSubscriber || !subscriptions?.length) return;
        for (const subscriber of subscriptions)if (eventsToUnsubscribe.includes(subscriber.delta)) removeSubscriber(subscriber);
    } else (0, $gRrX4.getPubSubClient)().then((client)=>{
        client.leaveChannel(pubSubResourceType, contentId);
        client.unsubscribe((0, $7S9uM.eventToAvi)('created:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
            userId: userId,
            contentId: contentId,
            reloader: reloader,
            addNewComment: addNewComment,
            getViewedCommentsCacheOnly: getViewedCommentsCacheOnly
        }));
        client.unsubscribe((0, $7S9uM.eventToAvi)('deleted:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
            userId: userId,
            contentId: contentId,
            reloader: reloader,
            removeComment: removeComment,
            getViewedCommentsCacheOnly: getViewedCommentsCacheOnly
        }));
        client.unsubscribe((0, $7S9uM.eventToAvi)('updated:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
            userId: userId,
            contentId: contentId,
            updateQueryVariables: {
                contentId: contentId,
                isReactionsEnabled: isReactionsEnabled
            },
            getViewedCommentsCacheOnly: getViewedCommentsCacheOnly
        }));
    });
};



const $d9d12cfcf38f06b2$export$ae25147d30bdeffa = ({ contentId: contentId, contentType: contentType })=>{
    const isReactionsEnabled = (0, $l5y3Y.useIsReactionsEnabled)(contentId);
    const { addNewComment: addNewComment, removeComment: removeComment, clearNewComments: clearNewComments } = (0, $42omo.useContext)((0, $4r9Ir.NewCommentsContext));
    const { addSubscriber: addSubscriber, removeSubscriber: removeSubscriber, setContentType: setContentType, setContentId: setContentId } = (0, $6UYek.useSubscriptionsDispatchContext)() || {};
    const subscriptions = (0, $42omo.useRef)([]);
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { updateUnreadCommentIDSet: updateUnreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsActions)();
    const { getViewedCommentsCacheOnly: getViewedCommentsCacheOnly } = (0, $d3bcC.useViewedComments)({
        pageId: contentId
    });
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { addReplyToCommentThread: addReplyToCommentThread, addNewCommentThreads: addNewCommentThreads, getCurrentCommentsPanelState: getCurrentCommentsPanelState, updateCommentBody: updateCommentBody, updateRemovedCommentIdsMap: updateRemovedCommentIdsMap, reopenParentComment: reopenParentComment } = (0, $8i27m.useCommentsDataActions)();
    const { setReplyToCommentId: setReplyToCommentId, getCommentsPanelState: getCommentsPanelState } = (0, $3mVfX.useCommentsPanelActions)();
    const clearReplyIfRemoved = (0, $42omo.useCallback)(({ commentId: commentId })=>{
        const { replyToCommentId: replyToCommentId } = getCommentsPanelState();
        if (replyToCommentId === commentId) setReplyToCommentId();
    }, [
        getCommentsPanelState,
        setReplyToCommentId
    ]);
    // Control skip state - start with true to prevent query on mount, set to false when events are detected
    const [shouldSkipQuery, setShouldSkipQuery] = (0, $42omo.useState)(true);
    // Reset skip state when contentId changes (new page)
    (0, $42omo.useEffect)(()=>{
        setShouldSkipQuery(true);
    }, [
        contentId
    ]);
    const { deleteCommentInCache: deleteCommentInCache, addCommentInCache: addCommentInCache } = (0, $NYiei.useAllCommentsData)({
        contentId: contentId,
        options: {
            skip: true // Only using write operations, no need to fetch data
        }
    });
    // Implementation using ActiveCommentsQuery
    // Skip is controlled by state - starts as true, set to false when handleEventFetchSuccess is called
    const { refetch: activeCommentsRefetch } = (0, $dkkKv.useActiveCommentsQuery)({
        pageId: contentId,
        type: 'FOOTER',
        skip: shouldSkipQuery || !contentId,
        fetchPolicy: 'cache-and-network'
    });
    const subscribeToPageCommentsPubSub = (0, $42omo.useCallback)(()=>{
        // Early return if pageMode is Edit - do not setup pubsub for edit pages
        if (pageMode === (0, $cD1qu.PageMode).EDIT) return;
        if (subscriptions.current.length > 0 && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return;
        const queryArgs = {
            isReactionsEnabled: isReactionsEnabled
        };
        subscriptions.current = (0, $ced40be9017d58cb$export$c542af303309df99)({
            contentId: contentId,
            contentType: contentType,
            userId: userId,
            reloader: activeCommentsRefetch,
            addNewComment: addNewComment,
            removeComment: removeComment,
            queryArgs: queryArgs,
            addNewCommentThreads: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? ()=>{} : addNewCommentThreads,
            addReplyToCommentThread: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? ()=>{} : addReplyToCommentThread,
            updateCommentBody: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? ()=>{} : updateCommentBody,
            updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
            reopenParentComment: reopenParentComment,
            getCurrentCommentsPanelState: getCurrentCommentsPanelState,
            addSubscriber: addSubscriber,
            setContentType: setContentType,
            setContentId: setContentId,
            updateUnreadCommentIDSet: updateUnreadCommentIDSet,
            getViewedCommentsCacheOnly: getViewedCommentsCacheOnly,
            addCommentInCache: addCommentInCache,
            deleteCommentInCache: deleteCommentInCache,
            clearReplyIfRemoved: clearReplyIfRemoved
        }) ?? [];
    }, [
        contentId,
        contentType,
        userId,
        activeCommentsRefetch,
        addNewComment,
        removeComment,
        isReactionsEnabled,
        addNewCommentThreads,
        addReplyToCommentThread,
        updateCommentBody,
        updateRemovedCommentIdsMap,
        reopenParentComment,
        getCurrentCommentsPanelState,
        addSubscriber,
        setContentType,
        setContentId,
        updateUnreadCommentIDSet,
        getViewedCommentsCacheOnly,
        addCommentInCache,
        deleteCommentInCache,
        pageMode,
        clearReplyIfRemoved
    ]);
    const unsubscribeFromPageCommentsPubSub = (0, $42omo.useCallback)(()=>{
        // Early return if pageMode is Edit - no pubsub was set up for edit pages
        if (pageMode === (0, $cD1qu.PageMode).EDIT) return;
        if (subscriptions.current.length === 0 && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return;
        const queryArgs_0 = {
            isReactionsEnabled: isReactionsEnabled
        };
        (0, $ced40be9017d58cb$export$f6e2e9a186163b28)({
            contentId: contentId,
            contentType: contentType,
            userId: userId,
            reloader: activeCommentsRefetch,
            addNewComment: addNewComment,
            removeComment: removeComment,
            queryArgs: queryArgs_0,
            updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
            removeSubscriber: removeSubscriber,
            subscriptions: subscriptions.current,
            getViewedCommentsCacheOnly: getViewedCommentsCacheOnly
        });
        if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) subscriptions.current = [];
    }, [
        contentId,
        contentType,
        userId,
        activeCommentsRefetch,
        addNewComment,
        removeComment,
        isReactionsEnabled,
        updateRemovedCommentIdsMap,
        removeSubscriber,
        getViewedCommentsCacheOnly,
        pageMode
    ]);
    const handleEventFetchSuccess = (0, $42omo.useCallback)((data)=>{
        if (data && data.contentId === contentId) {
            // Enable the query so refetch can work
            setShouldSkipQuery(false);
            if (data.commentEvents.length) {
                const commentData = data.commentEvents.map((event)=>{
                    return {
                        commentId: event.id,
                        accountId: event.accountId
                    };
                });
                (0, $406672c94379d4ab$export$af4b8274c1b86043)(activeCommentsRefetch, addNewComment, commentData, userId);
            }
        }
    }, [
        contentId,
        addNewComment,
        activeCommentsRefetch,
        userId
    ]);
    if (!userId || pageMode === (0, $cD1qu.PageMode).EDIT && (0, $6mKj3.expValEquals)('confluence_comments_get_document_version_number', 'isEnabled', true)) return null;
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).COLLABORATION
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $804Ue.MissedPubSubCommentEventsHandler), {
        contentId: contentId,
        eventType: (0, $804Ue.CommentEventType).FOOTER,
        subscribeToPubSubEvents: subscribeToPageCommentsPubSub,
        unsubscribeFromPubSubEvents: unsubscribeFromPageCommentsPubSub,
        onEventFetchSuccess: handleEventFetchSuccess,
        onDocumentReturn: clearNewComments,
        isAutoReloadPageComments: true
    }));
};
module.exports["PageCommentsPubSubHandler"] = $d9d12cfcf38f06b2$export$ae25147d30bdeffa;

});

parcelRegister("2xS8W", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");


var $1Whri = parcelRequire("1Whri");


var $1d2ww = parcelRequire("1d2ww");


var $3mVfX = parcelRequire("3mVfX");


var $aHcFH = parcelRequire("aHcFH");


var $6mKj3 = parcelRequire("6mKj3");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $fNzRA = parcelRequire("fNzRA");


var $ep3mz = parcelRequire("ep3mz");


var $jAfH5 = parcelRequire("jAfH5");


var $aOKRX = parcelRequire("aOKRX");


var $niTts = parcelRequire("niTts");








var $aXWIB = parcelRequire("aXWIB");


var $fVUfS = parcelRequire("fVUfS");

const $656c656df397599d$var$styles = {
    draftComment: "_2rko12b0 _1yt4u2gc _189ee4h9 _1dqonqa1 _1h6d1l7x _1bsb1osq _4t3i14no _1e0c1txw _4cvr1h6o _1bah1yb4 _syaz1rpy _bfhk1j9a"
};
const $656c656df397599d$var$i18n = (0, $aXWIB.defineMessages)({
    unsavedDraftComment: {
        id: "object-comments.draft-comment-box.text",
        defaultMessage: "Comment in progress - select to continue"
    }
});
const $656c656df397599d$export$82fe65228be9eec = (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { testId: t1, expandPageCommentEditorHandler: expandPageCommentEditorHandler } = t0;
    const testId = t1 === undefined ? "draft-comment-box" : t1;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t2;
    if ($[0] !== formatMessage) {
        t2 = formatMessage($656c656df397599d$var$i18n.unsavedDraftComment);
        $[0] = formatMessage;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== expandPageCommentEditorHandler || $[3] !== t2 || $[4] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
            xcss: $656c656df397599d$var$styles.draftComment,
            testId: testId,
            onClick: expandPageCommentEditorHandler
        }, t2);
        $[2] = expandPageCommentEditorHandler;
        $[3] = t2;
        $[4] = testId;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
};



var $dL5YQ = parcelRequire("dL5YQ");

const $e3138de675756a06$var$styles = {
    stickyDraftViewPageWrapper: "_kqsw1if8 _1pbykb7n",
    stickyDraftLivePageWrapper: "_kqsw1n9t _1pbybfng",
    hiddenStyles: "_1e0cglyw",
    visibleStyles: "_1e0c1txw",
    commonStyle: "_4cvr1h6o _1bah1h6o _94n5ze3t _bfhkvuon",
    childWrapperStyle: "_1yt4pxbi _19pkidpf _2hwx1wug _otyridpf _18u01wug _1h6d1l7x _uwhke4h9 _15a5nqa1",
    zIndexStyle: "_1pby1kze _1ltvze3t _1bsb1osq"
};
const $e3138de675756a06$export$d2696a038fec0750 = (t0)=>{
    const $ = (0, $frIzR.c)(54);
    const { pageWidthType: pageWidthType } = t0;
    const { expanded: expanded, isObjectCommentWrapperVisible: isObjectCommentWrapperVisible, footerEditorEntry: footerEditorEntry } = (0, $fNzRA.useObjectCommentContext)();
    const { expandCommentContainer: expandCommentContainer, setWrapperWidth: setWrapperWidth, setIsObjectCommentWrapperVisible: setIsObjectCommentWrapperVisible, setFooterEditorEntry: setFooterEditorEntry } = (0, $fNzRA.useObjectCommentDispatchContext)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [objectCommentWrapperDimensions, setObjectCommentWrapperDimensions] = (0, $42omo.useState)(null);
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const isViewPage = pageMode === (0, $cD1qu.PageMode).VIEW;
    const { width: pageContentWidth, left: pageContentLeft, right: pageContentRight } = (0, $aOKRX.usePageContentDimensions)();
    const { hasRecs: hasRecs } = (0, $jAfH5.usePageRecommendationData)();
    const { addFooterCommentAdf: addFooterCommentAdf } = (0, $3mVfX.useCommentsPanelState)();
    let t1;
    let t2;
    if ($[0] !== expandCommentContainer || $[1] !== expanded || $[2] !== isObjectCommentWrapperVisible || $[3] !== setFooterEditorEntry) {
        t1 = ()=>{
            if (isObjectCommentWrapperVisible && expanded) {
                expandCommentContainer();
                setFooterEditorEntry((0, $3mVfX.AddFooterCommentMode).FOOTER);
            }
        };
        t2 = [
            isObjectCommentWrapperVisible,
            expandCommentContainer,
            expanded,
            setFooterEditorEntry
        ];
        $[0] = expandCommentContainer;
        $[1] = expanded;
        $[2] = isObjectCommentWrapperVisible;
        $[3] = setFooterEditorEntry;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[6] !== isViewPage || $[7] !== setIsObjectCommentWrapperVisible || $[8] !== setWrapperWidth) {
        t3 = ()=>{
            let intersectionObserver = null;
            let resizeObserver = null;
            const calculateObjectCommentWrapperWidth = ()=>{
                const objectCommentWrapper = document.querySelector("[data-testid=\"object-comment-wrapper\"]");
                if (objectCommentWrapper) {
                    const rect = objectCommentWrapper.getBoundingClientRect();
                    setObjectCommentWrapperDimensions({
                        width: rect.width
                    });
                    setWrapperWidth(rect.width);
                }
            };
            const setupObservers = ()=>{
                const commentWrapper = document.querySelector("[data-testid=\"object-comment-wrapper\"]");
                if (!commentWrapper) {
                    setIsObjectCommentWrapperVisible(false);
                    return;
                }
                if (!intersectionObserver) {
                    intersectionObserver = new IntersectionObserver((t4)=>{
                        const [entry] = t4;
                        setIsObjectCommentWrapperVisible(entry.isIntersecting);
                    }, {
                        rootMargin: "0px"
                    });
                    intersectionObserver.observe(commentWrapper);
                }
                if (!resizeObserver) {
                    resizeObserver = new ResizeObserver(()=>{
                        calculateObjectCommentWrapperWidth();
                    });
                    resizeObserver.observe(commentWrapper);
                }
                calculateObjectCommentWrapperWidth();
            };
            setupObservers();
            const mutationObserver = new MutationObserver(()=>{
                const commentWrapper_0 = document.querySelector("[data-testid=\"object-comment-wrapper\"]");
                if (commentWrapper_0 && (!intersectionObserver || !isViewPage && !resizeObserver)) setupObservers();
            });
            mutationObserver.observe(document.body, {
                childList: true,
                subtree: true
            });
            return ()=>{
                if (intersectionObserver) intersectionObserver.disconnect();
                if (resizeObserver) resizeObserver.disconnect();
                mutationObserver.disconnect();
            };
        };
        $[6] = isViewPage;
        $[7] = setIsObjectCommentWrapperVisible;
        $[8] = setWrapperWidth;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== contentId || $[11] !== isViewPage || $[12] !== setIsObjectCommentWrapperVisible || $[13] !== setWrapperWidth) {
        t4 = [
            isViewPage,
            setWrapperWidth,
            setIsObjectCommentWrapperVisible,
            contentId
        ];
        $[10] = contentId;
        $[11] = isViewPage;
        $[12] = setIsObjectCommentWrapperVisible;
        $[13] = setWrapperWidth;
        $[14] = t4;
    } else t4 = $[14];
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[15] !== pageContentLeft || $[16] !== pageContentRight || $[17] !== pageContentWidth) {
        t5 = {
            width: pageContentWidth,
            left: pageContentLeft,
            right: pageContentRight
        };
        $[15] = pageContentLeft;
        $[16] = pageContentRight;
        $[17] = pageContentWidth;
        $[18] = t5;
    } else t5 = $[18];
    const pageContentDimensions = t5;
    let t6;
    if ($[19] !== pageWidthType) {
        t6 = ()=>{
            if (pageWidthType === undefined) return "100%";
            return JSON.parse(pageWidthType) === (0, $1d2ww.ContentAppearanceType).DEFAULT ? "1000px" : "unset";
        };
        $[19] = pageWidthType;
        $[20] = t6;
    } else t6 = $[20];
    const getMaxWidth = t6;
    let t7;
    if ($[21] !== getMaxWidth || $[22] !== hasRecs || $[23] !== isViewPage || $[24] !== objectCommentWrapperDimensions || $[25] !== pageMode || $[26] !== pageWidthType) {
        t7 = ()=>{
            if (isViewPage && (0, $6mKj3.expValEquals)("confluence_unify_footer_comments_space_width", "isEnabled", true)) {
                const computedWidths = (0, $aHcFH.getWidthAndMaxWidth)({
                    pageMode: pageMode,
                    pageWidthType: pageWidthType,
                    hasEndOfPageRecommendations: hasRecs ?? false
                });
                return {
                    width: computedWidths.width,
                    maxWidth: computedWidths.maxWidth
                };
            }
            return {
                maxWidth: isViewPage ? getMaxWidth() : "100%",
                width: !isViewPage && objectCommentWrapperDimensions ? `${objectCommentWrapperDimensions.width}px` : "100%"
            };
        };
        $[21] = getMaxWidth;
        $[22] = hasRecs;
        $[23] = isViewPage;
        $[24] = objectCommentWrapperDimensions;
        $[25] = pageMode;
        $[26] = pageWidthType;
        $[27] = t7;
    } else t7 = $[27];
    const getStyle = t7;
    const showStickyDraft = !isObjectCommentWrapperVisible && (addFooterCommentAdf || expanded) && footerEditorEntry !== (0, $3mVfX.AddFooterCommentMode).STICKY_DRAFT;
    let t8;
    if ($[28] !== expandCommentContainer || $[29] !== setFooterEditorEntry) {
        t8 = ()=>{
            expandCommentContainer();
            setFooterEditorEntry((0, $3mVfX.AddFooterCommentMode).STICKY_DRAFT);
        };
        $[28] = expandCommentContainer;
        $[29] = setFooterEditorEntry;
        $[30] = t8;
    } else t8 = $[30];
    const expandEditorHandler = t8;
    if (!showStickyDraft) return;
    const t9 = isViewPage ? $e3138de675756a06$var$styles.stickyDraftViewPageWrapper : $e3138de675756a06$var$styles.stickyDraftLivePageWrapper;
    const t10 = showStickyDraft ? $e3138de675756a06$var$styles.visibleStyles : $e3138de675756a06$var$styles.hiddenStyles;
    const t11 = !isViewPage && $e3138de675756a06$var$styles.zIndexStyle;
    let t12;
    if ($[31] !== t10 || $[32] !== t11 || $[33] !== t9) {
        t12 = (0, $1Whri.cx)(t9, t10, $e3138de675756a06$var$styles.commonStyle, t11);
        $[31] = t10;
        $[32] = t11;
        $[33] = t9;
        $[34] = t12;
    } else t12 = $[34];
    let t13;
    if ($[35] !== pageContentDimensions || $[36] !== pageMode) {
        t13 = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $niTts.hideWhiteSpace)({
            shouldRenderFixedStyle: true,
            pageContentDimensions: pageContentDimensions
        }) : undefined;
        $[35] = pageContentDimensions;
        $[36] = pageMode;
        $[37] = t13;
    } else t13 = $[37];
    let t14;
    if ($[38] !== getStyle) {
        t14 = getStyle();
        $[38] = getStyle;
        $[39] = t14;
    } else t14 = $[39];
    const t15 = !showStickyDraft ? $e3138de675756a06$var$styles.hiddenStyles : $e3138de675756a06$var$styles.visibleStyles;
    let t16;
    if ($[40] !== t15) {
        t16 = (0, $1Whri.cx)(t15);
        $[40] = t15;
        $[41] = t16;
    } else t16 = $[41];
    let t17;
    if ($[42] !== expandEditorHandler) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $656c656df397599d$export$82fe65228be9eec), {
            expandPageCommentEditorHandler: expandEditorHandler
        });
        $[42] = expandEditorHandler;
        $[43] = t17;
    } else t17 = $[43];
    let t18;
    if ($[44] !== t16 || $[45] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dL5YQ.ObjectAddCommentProfileWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: t16
        }, t17)));
        $[44] = t16;
        $[45] = t17;
        $[46] = t18;
    } else t18 = $[46];
    let t19;
    if ($[47] !== t14 || $[48] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $e3138de675756a06$var$styles.childWrapperStyle,
            style: t14
        }, t18);
        $[47] = t14;
        $[48] = t18;
        $[49] = t19;
    } else t19 = $[49];
    let t20;
    if ($[50] !== t12 || $[51] !== t13 || $[52] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: t12,
            testId: "sticky-draft-comment-box",
            id: "addCommentButton-draft",
            style: t13
        }, t19);
        $[50] = t12;
        $[51] = t13;
        $[52] = t19;
        $[53] = t20;
    } else t20 = $[53];
    return t20;
};
module.exports["StickyDraftCommentContainer"] = $e3138de675756a06$export$d2696a038fec0750;

});

parcelRegister("jAfH5", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $jtuBN = parcelRequire("jtuBN");


var $ep3mz = parcelRequire("ep3mz");


var $2HQyh = parcelRequire("2HQyh");


var $8dbvt = parcelRequire("8dbvt");

const $7e53ce3ad8fd4fef$export$1d93f080b8c40251 = (skip = false)=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const baseOptions = {
        variables: {
            type: 'page',
            id: contentId ?? '',
            exp: 'end_of_page_v5',
            key: spaceKey ?? '',
            keyString: spaceKey ?? ''
        },
        context: {
            single: true
        },
        errorPolicy: 'all',
        skip: skip
    };
    const { error: error, loading: loading, data: data } = (0, $6mKj3.expValEquals)('confluence_frontend_stop_watching_queries', 'isEnabled', true) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $2HQyh.default), baseOptions) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)((0, $2HQyh.default), {
        ...baseOptions,
        __callerPackage__: "@confluence/page-recommendations"
    });
    const pageCardData = (0, $42omo.useMemo)(()=>(0, $8dbvt.transformAndOrderRecs)(data?.getRecommendedPages?.recommendedPages), [
        data
    ]);
    if (error || skip) return {
        loading: false,
        error: error,
        data: undefined,
        hasRecs: false
    };
    return {
        loading: loading,
        error: error,
        data: pageCardData,
        hasRecs: pageCardData && pageCardData.length > 2
    };
};
module.exports["usePageRecommendationData"] = $7e53ce3ad8fd4fef$export$1d93f080b8c40251;

});

parcelRegister("aOKRX", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $b6b1455842ddb08b$export$d0606705f36ae70a = ()=>{
    const $ = (0, $frIzR.c)(6);
    const [pageContentWidth, setPageContentWidth] = (0, $42omo.useState)(0);
    const [pageContentLeft, setPageContentLeft] = (0, $42omo.useState)(0);
    const [pageContentRight, setPageContentRight] = (0, $42omo.useState)(0);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            let resizeObserver = null;
            let mutationObserver = null;
            let pageContentOnly = null;
            const updateDimensions = ()=>{
                if (!pageContentOnly) return;
                const rect = pageContentOnly.getBoundingClientRect();
                setPageContentWidth(rect.width);
                setPageContentLeft(rect.left);
                setPageContentRight(rect.right);
            };
            const handleWindowResize = ()=>{
                updateDimensions();
            };
            window.addEventListener("resize", handleWindowResize);
            const setupObservers = (element)=>{
                pageContentOnly = element;
                if (resizeObserver) resizeObserver.disconnect();
                resizeObserver = new ResizeObserver(()=>{
                    updateDimensions();
                });
                resizeObserver.observe(element);
                updateDimensions();
            };
            const existingElement = document.querySelector("[data-testid='page-content-only']");
            if (existingElement) setupObservers(existingElement);
            mutationObserver = new MutationObserver(()=>{
                const newPageContentOnly = document.querySelector("[data-testid='page-content-only']");
                if (newPageContentOnly && newPageContentOnly !== pageContentOnly) setupObservers(newPageContentOnly);
            });
            mutationObserver.observe(document.body, {
                childList: true,
                subtree: true
            });
            return ()=>{
                if (resizeObserver) resizeObserver.disconnect();
                window.removeEventListener("resize", handleWindowResize);
                if (mutationObserver) mutationObserver.disconnect();
            };
        };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $42omo.useEffect)(t0, t1);
    let t2;
    if ($[2] !== pageContentLeft || $[3] !== pageContentRight || $[4] !== pageContentWidth) {
        t2 = {
            width: pageContentWidth,
            left: pageContentLeft,
            right: pageContentRight
        };
        $[2] = pageContentLeft;
        $[3] = pageContentRight;
        $[4] = pageContentWidth;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
};
module.exports["usePageContentDimensions"] = $b6b1455842ddb08b$export$d0606705f36ae70a;

});

parcelRegister("70pcM", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3mVfX = parcelRequire("3mVfX");


var $jmjWc = parcelRequire("jmjWc");

var $398ES = parcelRequire("398ES");


var $5CNGn = parcelRequire("5CNGn");


const $21986f05fdcd4f3c$var$ObjectCommentContainerLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "zDMTR",
    name: "ObjectCommentContainerLoader",
    loader: async ()=>(await Promise.resolve((parcelRequire("5CNGn")))).ObjectCommentContainer
});
const $21986f05fdcd4f3c$export$5a58d81bd405c4ec = ({ showGeneralComment: showGeneralComment, pageWidthType: pageWidthType, loadingPriority: loadingPriority, showLabels: showLabels, hasReactions: hasReactions, editorIsUserOffline: editorIsUserOffline })=>{
    const { setShowGeneralComments: setShowGeneralComments } = (0, $3mVfX.useCommentsPanelActions)();
    (0, $42omo.useEffect)(()=>{
        setShowGeneralComments(showGeneralComment);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- we only want to set the comment type once on the comment mount
    }, []);
    return loadingPriority === (0, $398ES.LoadingPriority).PAINT ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21986f05fdcd4f3c$var$ObjectCommentContainerLoader, {
        pageWidthType: pageWidthType,
        showLabels: showLabels,
        hasReactions: hasReactions,
        editorIsUserOffline: editorIsUserOffline
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5CNGn.ObjectCommentContainer), {
        pageWidthType: pageWidthType,
        showLabels: showLabels,
        hasReactions: hasReactions,
        editorIsUserOffline: editorIsUserOffline
    });
};
module.exports["ObjectCommentWrapper"] = $21986f05fdcd4f3c$export$5a58d81bd405c4ec;

});

parcelRegister("5CNGn", function(module, exports) {

var $1ydBT = parcelRequire("1ydBT");


var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");

var $1GzhS = parcelRequire("1GzhS");

var $ecnYn = parcelRequire("ecnYn");


var $l1uFv = parcelRequire("l1uFv");


var $kgNLQ = parcelRequire("kgNLQ");


var $4L9ve = parcelRequire("4L9ve");


var $aqBZ0 = parcelRequire("aqBZ0");


var $6Hogt = parcelRequire("6Hogt");


var $deTj5 = parcelRequire("deTj5");


var $8SCD6 = parcelRequire("8SCD6");


var $fNzRA = parcelRequire("fNzRA");

/**
 * @generated SignedSource<<2dc351f144bf2a77f9653485f07a85ea>>
 * @relayHash 765a0e8684153a74a9625d61eb5a36c9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bd7425461154d822e729902b362c9b0dcb31cef6f2130a55b0aa812185fa407c
const $29a5cbc606375ce1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "commentId",
            "variableName": "commentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v6 = {
        "kind": "ScalarField",
        "name": "type"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "resolved"
                    }
                ]
            }
        ],
        "type": "FooterComment"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ObjectCommentQueryParamsListenerObjectCommentQueryParamsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ObjectCommentQueryParamsListenerObjectCommentQueryParamsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "765a0e8684153a74a9625d61eb5a36c9",
            "id": "bd7425461154d822e729902b362c9b0dcb31cef6f2130a55b0aa812185fa407c",
            "metadata": {},
            "name": "ObjectCommentQueryParamsListenerObjectCommentQueryParamsQuery",
            "operationKind": "query",
            "text": "query ObjectCommentQueryParamsListenerObjectCommentQueryParamsQuery($commentId:ID!){comments(commentId:$commentId){nodes{id,parentId,author{__typename,displayName,...on KnownUser{accountId}},location{__typename,type,...on FooterComment{commentResolveProperties{resolved}}}}}}"
        }
    };
}();
$29a5cbc606375ce1$var$node.hash = "414c0e80c6879acd5ff83647527d3be3";
var $29a5cbc606375ce1$export$2e2bcd8739ae039 = $29a5cbc606375ce1$var$node;






var $8i27m = parcelRequire("8i27m");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $lb2Lp = parcelRequire("lb2Lp");








var $aSsfA = parcelRequire("aSsfA");


var $9FoVw = parcelRequire("9FoVw");


var $5fMeR = parcelRequire("5fMeR");


var $i6UMJ = parcelRequire("i6UMJ");


var $3mVfX = parcelRequire("3mVfX");


var $7W8i8 = parcelRequire("7W8i8");


var $ep3mz = parcelRequire("ep3mz");


var $dPJCf = parcelRequire("dPJCf");


var $eTcMK = parcelRequire("eTcMK");


var $jMyy4 = parcelRequire("jMyy4");


var $ifBRq = parcelRequire("ifBRq");

const $90365d58d6587547$var$ObjectCommentQueryParamsListenerObjectCommentQueryParamsQuery = (0, $29a5cbc606375ce1$export$2e2bcd8739ae039);
const $90365d58d6587547$var$logger = (0, $7W8i8.getLogger)('inline-comments:query-param-listener');
const $90365d58d6587547$var$useFocusedCommentIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('focusedCommentId');
const $90365d58d6587547$var$useReplyToCommentQueryParam = (0, $dPJCf.createSingleQueryParamHook)('replyToComment');
// Maximum wait time for scroll operations (in milliseconds)
const $90365d58d6587547$var$SCROLL_TIMEOUT_MS = 4000;
// Minimum time page must be stable before scrolling (in milliseconds)
const $90365d58d6587547$var$PAGE_STABILITY_DELAY_MS = 500;
// Wait for document height to stabilize (tables may have async layout)
const $90365d58d6587547$var$HEIGHT_STABILITY_CHECK_MS = 150;
// If there is a link to non-existent (probably deleted) comment, we don't want to show an error
const $90365d58d6587547$var$expectedErrorCodes = [
    404
];
const $90365d58d6587547$var$isExpectedError = (error)=>error.graphQLErrors.some((e)=>$90365d58d6587547$var$expectedErrorCodes.includes(e?.extensions?.statusCode));
const $90365d58d6587547$var$ObjectCommentQueryParamsListenerComponent = ({ hasLoadedObjectComments: hasLoadedObjectComments, allObjectCommentsRendered: allObjectCommentsRendered, commentBatchRendered: commentBatchRendered, commentBatchCount: commentBatchCount, setForceLoadComments: setForceLoadComments })=>{
    const [hasScrolledToFocusedComment, setHasScrolledToFocusedComment] = (0, $42omo.useState)(false);
    const [hasScrolledToReplyComment, setHasScrolledToReplyComment] = (0, $42omo.useState)(false);
    const mutationObserverRef = (0, $42omo.useRef)(null);
    const scrollTimeoutRef = (0, $42omo.useRef)(null);
    const lastMutationTimeRef = (0, $42omo.useRef)(0);
    // Helper function to clear scroll timeout/callback
    const clearScrollTimeout = ()=>{
        if (scrollTimeoutRef.current !== null) {
            if (typeof scrollTimeoutRef.current === 'number') // requestIdleCallback ID
            {
                if (typeof window !== 'undefined' && 'cancelIdleCallback' in window && typeof window.cancelIdleCallback === 'function') window.cancelIdleCallback(scrollTimeoutRef.current);
            } else // setTimeout ID
            clearTimeout(scrollTimeoutRef.current);
            scrollTimeoutRef.current = null;
        }
    };
    // Helper function to clean up MutationObserver
    const cleanupMutationObserver = ()=>{
        if (mutationObserverRef.current) {
            mutationObserverRef.current.disconnect();
            mutationObserverRef.current = null;
        }
    };
    // Helper function to clean up both observer and timeout (only if they were set up)
    const cleanupScrollResources = (0, $42omo.useCallback)(()=>{
        if (mutationObserverRef.current) cleanupMutationObserver();
        if (scrollTimeoutRef.current !== null) clearScrollTimeout();
    }, []); // Empty deps: only uses refs which don't change
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    const { commentsDataMap: commentsDataMap } = (0, $8i27m.useCommentsDataState)();
    const focusedCommentId = $90365d58d6587547$var$useFocusedCommentIdQueryParam();
    const replyToComment = $90365d58d6587547$var$useReplyToCommentQueryParam();
    const commentId = focusedCommentId || replyToComment;
    // NEW FLOW: Use useCommentById when experiment is enabled
    const { comment: comment, error: commentError } = (0, $lb2Lp.useCommentById)({
        commentId: commentId || '',
        contentId: contentId || '',
        contentStatus: (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode),
        options: {
            skip: !commentId || !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)
        }
    });
    // OLD FLOW: Direct GraphQL query (fallback when experiment is disabled)
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)($90365d58d6587547$var$ObjectCommentQueryParamsListenerObjectCommentQueryParamsQuery, {
        variables: {
            commentId: commentId
        },
        skip: !commentId || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false),
        __callerPackage__: "@confluence/comments-query-param-handlers"
    });
    if (error && !$90365d58d6587547$var$isExpectedError(error)) $90365d58d6587547$var$logger.error`An error occurred when querying the focused object comment status; ${error}`;
    let isResolved = undefined;
    let parentId = undefined;
    // Extract resolved status and parentId from either new or old flow
    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) // NEW FLOW: Extract from useCommentById
    {
        if (comment && !commentError) {
            const location = comment.location;
            isResolved = Boolean(location?.commentResolveProperties?.resolved);
            parentId = comment.parentId;
        }
    } else // OLD FLOW: Extract from GraphQL query
    // If the commentId is not present, error is defined and isResolved will be undefined
    if (data && !error) {
        const location_0 = data?.comments?.nodes?.[0]?.location;
        isResolved = Boolean(location_0?.commentResolveProperties?.resolved);
        parentId = data?.comments?.nodes?.[0]?.parentId;
    }
    // Get comment data for replyToComment handling (with author)
    const rawCommentForReply = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? comment : data?.comments?.nodes?.[0] || null;
    // Handle scrolling to focused comment or replyToComment after the data is loaded
    (0, $42omo.useEffect)(()=>{
        // Determine if we have data from new or old flow
        const hasData = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? comment && !commentError : data && !error;
        // Update currentlySelectedThreadKey to root comment ID when data becomes available
        // This runs even after scroll has happened to ensure correct thread highlighting
        if (parentId && (hasScrolledToFocusedComment || hasScrolledToReplyComment) && (0, $6mKj3.expValEquals)('confluence_comment_deeplink_thread_selection', 'isEnabled', true)) {
            let rootCommentId;
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                if (processedCommentsData.isDataProcessed && processedCommentsData.allComments.length > 0) {
                    const rootComment = (0, $kgNLQ.findRootCommentForReply)(processedCommentsData.allComments, parentId);
                    rootCommentId = rootComment?.id;
                }
            } else {
                const legacyFooterComments = Object.values(commentsDataMap.general);
                if (legacyFooterComments.length > 0) {
                    const rootComment_0 = (0, $kgNLQ.findRootCommentForReply)(legacyFooterComments, parentId);
                    rootCommentId = rootComment_0?.id;
                }
            }
            if (rootCommentId && rootCommentId !== parentId) setCurrentlySelectedThreadKey(rootCommentId);
        }
        // Early return if comment type is INLINE - this component only handles footer/object comments
        if (hasData && commentId && (0, $6mKj3.expValEquals)('confluence_comment_deeplink_queryparam_selection', 'isEnabled', true)) {
            const location_1 = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? comment?.location : data?.comments?.nodes?.[0]?.location;
            if (location_1 && 'type' in location_1 && location_1.type === 'INLINE') return;
        }
        if (// Note that if the commentId is not found, the query will return an error and we don't
        // have to scroll to the comment
        commentId && hasData && hasLoadedObjectComments && allObjectCommentsRendered && !hasScrolledToFocusedComment && !hasScrolledToReplyComment) {
            if (isResolved) {
                showCommentsPanel({
                    openWithView: (0, $3mVfX.ViewValues).RESOLVED
                });
                setCurrentlySelectedThreadKey(commentId, (0, $8i27m.CommentType).GENERAL);
                if (focusedCommentId) setHasScrolledToFocusedComment(true);
                else setHasScrolledToReplyComment(true);
            } else {
                const commentElementId = `footer-comment-thread-${commentId}-container`;
                const replyCommentElementId = `footer-comment-thread-${commentId}-replies`;
                const commentElement = document.getElementById(commentElementId);
                const replyCommentElement = document.getElementById(replyCommentElementId);
                const element = commentElement || replyCommentElement;
                // When experiment is enabled, select the root thread (for replies) or the comment itself
                // This ensures the entire thread is highlighted when deep-linking to a reply
                let threadToBeSelected = commentId;
                if (parentId && (0, $6mKj3.expValEquals)('confluence_comment_deeplink_thread_selection', 'isEnabled', true)) {
                    // Try to find the root comment ID from available data sources
                    let rootCommentId_0;
                    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                        if (processedCommentsData.isDataProcessed && processedCommentsData.allComments.length > 0) {
                            const rootComment_1 = (0, $kgNLQ.findRootCommentForReply)(processedCommentsData.allComments, parentId);
                            rootCommentId_0 = rootComment_1?.id;
                        }
                    } else {
                        const legacyFooterComments_0 = Object.values(commentsDataMap.general);
                        if (legacyFooterComments_0.length > 0) {
                            const rootComment_2 = (0, $kgNLQ.findRootCommentForReply)(legacyFooterComments_0, parentId);
                            rootCommentId_0 = rootComment_2?.id;
                        }
                    }
                    threadToBeSelected = rootCommentId_0 ?? parentId;
                }
                // Use unified navigation for scrolling
                if (commentId) {
                    if ((0, $6mKj3.expValEquals)('confluence_comment_deeplink_delay_scroll', 'isEnabled', true)) {
                        if (replyToComment) {
                            setCurrentlySelectedThreadKey(threadToBeSelected);
                            // Get author information from comment data
                            const commentWithAuthor = rawCommentForReply;
                            const author = commentWithAuthor?.author;
                            setReplyToCommentId((0, $eTcMK.createReplyToCommentParams)(replyToComment, (0, $i6UMJ.LocationValue).FOOTER, author, (0, $6mKj3.expValEquals)('confluence_comment_expand_reply_editor', 'isEnabled', true)));
                            setHasScrolledToReplyComment(true);
                            return;
                        }
                        // Use MutationObserver to watch for when the element is ready
                        // Clean up any existing observer first
                        cleanupMutationObserver();
                        const getDocumentScrollHeight = ()=>Math.max(document.documentElement?.scrollHeight ?? 0, document.body?.scrollHeight ?? 0);
                        const scrollToComment = ()=>{
                            const element_0 = document.getElementById(commentElementId) || document.getElementById(replyCommentElementId);
                            if (element_0 && (0, $9wGTI.fg)('confluence_comment_footer_scrolling_fix')) {
                                element_0.offsetTop;
                                getDocumentScrollHeight();
                            }
                            (0, $9FoVw.handleFooterCommentsNavigation)({
                                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                                block: 'center',
                                inline: 'center',
                                commentId: commentId,
                                navigationContext: parentId ? (0, $9FoVw.NavigationContext).REPLY : undefined
                            });
                            setHasScrolledToFocusedComment(true);
                            setCurrentlySelectedThreadKey(threadToBeSelected);
                            cleanupMutationObserver();
                        };
                        // Perform scroll; when FG on: double rAF + force reflow for correct layout
                        const performScrollAndCleanup = ()=>{
                            clearScrollTimeout();
                            if ((0, $9wGTI.fg)('confluence_comment_footer_scrolling_fix')) requestAnimationFrame(()=>{
                                requestAnimationFrame(scrollToComment);
                            });
                            else scrollToComment();
                        };
                        // When FG on: check document height stable (tables may have async layout)
                        const checkHeightStabilityThenScroll = ()=>{
                            if (!(0, $9wGTI.fg)('confluence_comment_footer_scrolling_fix')) {
                                performScrollAndCleanup();
                                return;
                            }
                            const h1 = getDocumentScrollHeight();
                            scrollTimeoutRef.current = setTimeout(()=>{
                                scrollTimeoutRef.current = null;
                                const h2 = getDocumentScrollHeight();
                                if (h1 === h2) performScrollAndCleanup();
                                else scheduleScroll();
                            }, $90365d58d6587547$var$HEIGHT_STABILITY_CHECK_MS);
                        };
                        // Schedule scroll when page is idle/stable
                        const scheduleScroll = ()=>{
                            clearScrollTimeout();
                            // Track when we detected the element is ready
                            lastMutationTimeRef.current = Date.now();
                            // Use requestIdleCallback if available, otherwise fallback to setTimeout
                            if (typeof window !== 'undefined' && 'requestIdleCallback' in window) scrollTimeoutRef.current = window.requestIdleCallback(()=>{
                                const checkStabilityAndScroll = ()=>{
                                    const timeSinceLastMutation = Date.now() - lastMutationTimeRef.current;
                                    if (timeSinceLastMutation >= $90365d58d6587547$var$PAGE_STABILITY_DELAY_MS) // Mutations stable - when FG on: check height stable, then scroll
                                    checkHeightStabilityThenScroll();
                                    else // Not stable yet - wait and re-check (don't scroll blindly)
                                    scrollTimeoutRef.current = setTimeout(()=>{
                                        scrollTimeoutRef.current = null;
                                        checkStabilityAndScroll();
                                    }, $90365d58d6587547$var$PAGE_STABILITY_DELAY_MS - timeSinceLastMutation);
                                };
                                checkStabilityAndScroll();
                            });
                            else // Fallback for browsers without requestIdleCallback (e.g., Safari)
                            scrollTimeoutRef.current = setTimeout(()=>{
                                scrollTimeoutRef.current = null;
                                checkHeightStabilityThenScroll();
                            }, $90365d58d6587547$var$SCROLL_TIMEOUT_MS);
                        };
                        // Check if element exists and is ready (has content and is visible)
                        const getElementAndCheckReady = ()=>{
                            const foundElement = document.getElementById(commentElementId) || document.getElementById(replyCommentElementId);
                            if (!foundElement) return {
                                element: null,
                                isReady: false
                            };
                            const rect = foundElement.getBoundingClientRect();
                            const elementIsReady = foundElement.offsetHeight > 0 && foundElement.offsetWidth > 0 && rect.height > 0 && rect.width > 0;
                            return {
                                element: foundElement,
                                isReady: elementIsReady
                            };
                        };
                        const { element: currentElement, isReady: isReady } = getElementAndCheckReady();
                        // If element exists and is already ready, schedule scroll with delay
                        if (currentElement && isReady) scheduleScroll();
                        else {
                            // Set up MutationObserver to watch for when element appears or becomes ready
                            mutationObserverRef.current = new MutationObserver(()=>{
                                // Update last mutation time when DOM changes
                                lastMutationTimeRef.current = Date.now();
                                const { element: foundElement_0, isReady: foundIsReady } = getElementAndCheckReady();
                                if (foundElement_0 && foundIsReady) scheduleScroll();
                            });
                            // If element exists, observe it and its parent
                            if (currentElement) {
                                mutationObserverRef.current.observe(currentElement, {
                                    childList: true,
                                    subtree: true,
                                    attributes: true,
                                    attributeFilter: [
                                        'style',
                                        'class'
                                    ]
                                });
                                const parentContainer = currentElement.parentElement;
                                if (parentContainer) mutationObserverRef.current.observe(parentContainer, {
                                    childList: true,
                                    subtree: true
                                });
                            } else // If element doesn't exist yet, observe document.body to detect when it appears
                            mutationObserverRef.current.observe(document.body, {
                                childList: true,
                                subtree: true
                            });
                            // Fallback timeout in case MutationObserver doesn't detect changes
                            setTimeout(()=>{
                                if (mutationObserverRef.current) checkHeightStabilityThenScroll();
                            }, $90365d58d6587547$var$SCROLL_TIMEOUT_MS);
                        }
                    } else // Experiment disabled - scroll immediately if element exists
                    if (element) {
                        (0, $9FoVw.handleFooterCommentsNavigation)({
                            scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                            block: 'center',
                            inline: 'center',
                            commentId: commentId,
                            navigationContext: parentId ? (0, $9FoVw.NavigationContext).REPLY : undefined
                        });
                        setHasScrolledToFocusedComment(true);
                        setCurrentlySelectedThreadKey(threadToBeSelected);
                    }
                }
            }
        }
    }, [
        data,
        error,
        comment,
        commentError,
        hasLoadedObjectComments,
        commentId,
        focusedCommentId,
        replyToComment,
        allObjectCommentsRendered,
        commentBatchRendered,
        commentBatchCount,
        setCurrentlySelectedThreadKey,
        setReplyToCommentId,
        isResolved,
        showCommentsPanel,
        hasScrolledToFocusedComment,
        hasScrolledToReplyComment,
        rawCommentForReply,
        parentId,
        processedCommentsData,
        commentsDataMap
    ]);
    // Reset scroll tracking when focusedCommentId or replyToComment changes
    (0, $42omo.useEffect)(()=>{
        setHasScrolledToFocusedComment(false);
        setHasScrolledToReplyComment(false);
        // Clean up scroll resources when comment ID changes (only if they were set up)
        cleanupScrollResources();
    }, [
        focusedCommentId,
        replyToComment,
        cleanupScrollResources
    ]);
    // Clean up MutationObserver and timeout on unmount
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            cleanupScrollResources();
        };
    }, [
        cleanupScrollResources
    ]);
    // Force load comments if focusedCommentId or replayToComment is present
    (0, $42omo.useEffect)(()=>{
        if ((focusedCommentId || replyToComment) && !hasLoadedObjectComments) setForceLoadComments(true);
    }, [
        focusedCommentId,
        replyToComment,
        hasLoadedObjectComments,
        setForceLoadComments
    ]);
    return null;
};
const $90365d58d6587547$var$withObjectCommentQueryParamUnification = (Component)=>(props)=>{
        if ((0, $9wGTI.fg)('confluence_comment_param_unification')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ifBRq.CommentQueryParamsListener), props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, props);
    };
const $90365d58d6587547$export$1e65952d87b47593 = $90365d58d6587547$var$withObjectCommentQueryParamUnification($90365d58d6587547$var$ObjectCommentQueryParamsListenerComponent);



var $dkkKv = parcelRequire("dkkKv");








var $6lAIr = parcelRequire("6lAIr");





var $aHcFH = parcelRequire("aHcFH");


var $lFkRf = parcelRequire("lFkRf");


var $FBfum = parcelRequire("FBfum");


var $isEtk = parcelRequire("isEtk");


var $5vi32 = parcelRequire("5vi32");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");








var $7aRa9 = parcelRequire("7aRa9");


var $1kHsc = parcelRequire("1kHsc");


var $gtj7V = parcelRequire("gtj7V");


var $irVI7 = parcelRequire("irVI7");





var $htsj6 = parcelRequire("htsj6");


var $cD1qu = parcelRequire("cD1qu");





var $jAfH5 = parcelRequire("jAfH5");





var $e4o8D = parcelRequire("e4o8D");


var $fHAwL = parcelRequire("fHAwL");


var $b0EGa = parcelRequire("b0EGa");


var $aOKRX = parcelRequire("aOKRX");


var $niTts = parcelRequire("niTts");


var $frIzR = parcelRequire("frIzR");





var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");








var $en1dX = parcelRequire("en1dX");











var $ln0hx = parcelRequire("ln0hx");


var $8Ss4E = parcelRequire("8Ss4E");








var $jmjWc = parcelRequire("jmjWc");





var $bQm3c = parcelRequire("bQm3c");











var $3gadb = parcelRequire("3gadb");





var $famWw = parcelRequire("famWw");





var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");

const $c5b321ea0eb33bcf$var$i18n = (0, $aXWIB.defineMessages)({
    addCommentTooltip: {
        id: "object-comments.footer.add-button-tooltip",
        defaultMessage: "Add comment"
    }
});
const $c5b321ea0eb33bcf$export$ba63fdcb08237d72 = (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { onClick: onClick, autofocusRef: autofocusRef } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            shortcut: (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR)
        };
        $[0] = t1;
    } else t1 = $[0];
    const addCommentShortcutStrings = (0, $4tOXV.useShortcutStrings)(t1);
    const buttonRef = (0, $42omo.useRef)(null);
    let t2;
    let t3;
    if ($[1] !== autofocusRef) {
        t2 = ()=>{
            if (autofocusRef.current) {
                buttonRef.current?.focus({
                    preventScroll: true
                });
                autofocusRef.current = false;
            }
        };
        t3 = [
            autofocusRef
        ];
        $[1] = autofocusRef;
        $[2] = t2;
        $[3] = t3;
    } else {
        t2 = $[2];
        t3 = $[3];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[4] !== formatMessage) {
        t4 = (0, $6mKj3.expValEquals)("confluence_comments_cohiti_footer_tooltips", "isEnabled", true) ? formatMessage($c5b321ea0eb33bcf$var$i18n.addCommentTooltip) : undefined;
        $[4] = formatMessage;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== autofocusRef || $[7] !== onClick) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $famWw.AddCommentPromptButton), {
            onClick: onClick,
            autofocusRef: autofocusRef,
            testId: "add-comment-button"
        });
        $[6] = autofocusRef;
        $[7] = onClick;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== addCommentShortcutStrings || $[10] !== t4 || $[11] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: t4,
            shortcut: addCommentShortcutStrings,
            position: "top"
        }, t5));
        $[9] = addCommentShortcutStrings;
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
};












var $4FHTF = parcelRequire("4FHTF");


var $1NF8X = parcelRequire("1NF8X");


var $3FlVr = parcelRequire("3FlVr");


var $9sGCn = parcelRequire("9sGCn");





var $7QM6o = parcelRequire("7QM6o");




const $2c779d914e38fe28$var$i18n = (0, $aXWIB.defineMessages)({
    addNew: {
        id: "object-comments.page.reactions.add.new",
        defaultMessage: "Add new"
    },
    addReaction: {
        id: "object-comments.page.reactions.add.reaction",
        defaultMessage: "Add reaction"
    }
});
const $2c779d914e38fe28$export$3b5f3f6ec721f20a = (t0)=>{
    const $ = (0, $frIzR.c)(18);
    const { isOffline: t1, optimisticReactions: t2 } = t0;
    const isOffline = t1 === undefined ? false : t1;
    const optimisticReactions = t2 === undefined ? false : t2;
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { isReactionsEnabled: isReactionsEnabled } = (0, $42omo.useContext)((0, $8SCD6.ReactionsContext));
    let t3;
    if ($[0] !== contentId) {
        t3 = (0, $9sGCn.getCachedPageData)(contentId);
        $[0] = contentId;
        $[1] = t3;
    } else t3 = $[1];
    const { subType: subType } = t3;
    let t4;
    if ($[2] !== formatMessage) {
        t4 = formatMessage($2c779d914e38fe28$var$i18n.addReaction);
        $[2] = formatMessage;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4FHTF))), {
            testId: "emoji-add-icon",
            color: "var(--ds-icon-subtle, #505258)",
            label: t4
        });
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    const customIcon = t5;
    const t6 = contentId || "";
    const t7 = contentType === "blogpost" ? (0, $3FlVr.ReactionLocation).OBJECT_COMMENT_FOOTER_BLOGPOST : (0, $3FlVr.ReactionLocation).OBJECT_COMMENT_FOOTER_PAGE;
    const t8 = spaceId || "";
    let t9;
    if ($[6] !== formatMessage) {
        t9 = formatMessage($2c779d914e38fe28$var$i18n.addNew);
        $[6] = formatMessage;
        $[7] = t9;
    } else t9 = $[7];
    const t10 = isReactionsEnabled ? customIcon : undefined;
    let t11;
    if ($[8] !== customIcon || $[9] !== isOffline || $[10] !== optimisticReactions || $[11] !== subType || $[12] !== t10 || $[13] !== t6 || $[14] !== t7 || $[15] !== t8 || $[16] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1NF8X.ReactionsLoader), {
            contentId: t6,
            location: t7,
            containerId: t8,
            containerType: (0, $3FlVr.ReactionContainerType).SPACE,
            contentSubType: subType,
            summaryViewEnabled: true,
            summaryViewThreshold: 1,
            allowSelectFromSummaryView: true,
            useButtonAlignmentStyling: true,
            summaryViewPlacement: "bottom-end",
            readOnly: isOffline,
            isViewOnly: isOffline,
            isSubtle: true,
            reactionPickerTriggerIcon: customIcon,
            reactionPickerTriggerText: t9,
            useDefaultStyledContainer: false,
            hidePlaceholder: Boolean(window.__SSR_RENDERED__),
            noRelativeContainer: false,
            noFlexWrap: false,
            hoverableSummaryView: true,
            reactionPickerPlacement: "bottom-end",
            summaryButtonIconAfter: t10,
            optimisticallyLoadSummaryEmojis: optimisticReactions,
            renderParticleEffectOnSummaryView: true
        });
        $[8] = customIcon;
        $[9] = isOffline;
        $[10] = optimisticReactions;
        $[11] = subType;
        $[12] = t10;
        $[13] = t6;
        $[14] = t7;
        $[15] = t8;
        $[16] = t9;
        $[17] = t11;
    } else t11 = $[17];
    return t11;
};



const $2998c7377d5266d6$var$FooterLabelsLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "zM3y-",
    name: "FooterLabelsLoader",
    loader: async ()=>(await (parcelRequire("7aqgU"))).FooterLabels
});
const $2998c7377d5266d6$var$styles = {
    oldAddCommentContainerStyles: "_1yt4pxbi _x3doia51 _kqsw1if8 _94n5ze3t _1e0c1txw _1bsb1osq _bfhk1j9a",
    addCommentContainerStyles: "_1yt4pxbi _x3doia51 _kqsw1if8 _94n5ze3t _1e0c1txw _1bsb1osq _bfhkvuon",
    addCommentClosedContainerStyles: "_1bsb1osq _1e0c1txw _1bah1yb4 _4cvr1h6o _1o9zidpf",
    hideStyle: "_1e0cglyw",
    addCommentReactionsContainerStyles: "_1e0c1txw _4cvr1h6o _1bahesu3",
    rightButtonContainerStyles: "_4cvr1h6o"
};
const $2998c7377d5266d6$export$5ed9c7f27c15b7fe = (t0)=>{
    const $ = (0, $frIzR.c)(15);
    const { showReactions: showReactions, showLabels: showLabels, isOffline: isOffline, optimisticReactions: t1 } = t0;
    const optimisticReactions = t1 === undefined ? false : t1;
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const shouldAutofocusPromptRef = (0, $42omo.useRef)(false);
    const { expandCommentContainer: expandCommentContainer, setFooterEditorEntry: setFooterEditorEntry } = (0, $fNzRA.useObjectCommentDispatchContext)();
    const { expanded: expanded } = (0, $fNzRA.useObjectCommentContext)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    let t2;
    if ($[0] !== edition || $[1] !== expandCommentContainer || $[2] !== setFooterEditorEntry) {
        t2 = ()=>{
            if (!(0, $9wGTI.fg)("confluence_fe_add_page_comment_exp_coverage")) (0, $8Ss4E.startEditorExperiences)({
                name: (0, $irVI7.ADD_PAGE_COMMENT_EXPERIENCE),
                attributes: {
                    ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                    editor: "FABRIC",
                    isSingleExperience: true,
                    edition: edition,
                    source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER
                }
            }, {
                name: (0, $irVI7.ADD_PAGE_COMMENT_LOAD_EXPERIENCE)
            }, {
                name: (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE)
            });
            expandCommentContainer({
                entryPoint: "pageFooter"
            });
            setFooterEditorEntry((0, $3mVfX.AddFooterCommentMode).FOOTER);
        };
        $[0] = edition;
        $[1] = expandCommentContainer;
        $[2] = setFooterEditorEntry;
        $[3] = t2;
    } else t2 = $[3];
    const handleExpandCommentContainer = t2;
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $1Whri.cx)((0, $9wGTI.fg)("confluence_frontend_content_wrapper") && $2998c7377d5266d6$var$styles.addCommentContainerStyles, !(0, $9wGTI.fg)("confluence_frontend_content_wrapper") && $2998c7377d5266d6$var$styles.oldAddCommentContainerStyles);
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== contentId || $[6] !== expanded || $[7] !== handleExpandCommentContainer || $[8] !== isOffline || $[9] !== optimisticReactions || $[10] !== showLabels || $[11] !== showReactions) {
        t4 = !expanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $2998c7377d5266d6$var$styles.addCommentClosedContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c5b321ea0eb33bcf$export$ba63fdcb08237d72), {
            onClick: handleExpandCommentContainer,
            autofocusRef: shouldAutofocusPromptRef
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            gap: "space.050",
            testId: "objectAddCommentContainer-rightButtonContainer",
            xcss: $2998c7377d5266d6$var$styles.rightButtonContainerStyles
        }, showLabels && (0, $9wGTI.fg)("confluence_frontend_labels_in_footer") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
            id: contentId,
            name: (0, $irVI7.VIEW_PAGE_LABELS_IN_FOOTER_EXPERIENCE)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2998c7377d5266d6$var$FooterLabelsLoader, null)), showReactions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $2998c7377d5266d6$var$styles.addCommentReactionsContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2c779d914e38fe28$export$3b5f3f6ec721f20a), {
            isOffline: isOffline,
            optimisticReactions: optimisticReactions
        }))));
        $[5] = contentId;
        $[6] = expanded;
        $[7] = handleExpandCommentContainer;
        $[8] = isOffline;
        $[9] = optimisticReactions;
        $[10] = showLabels;
        $[11] = showReactions;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            id: "addCommentButton",
            xcss: t3,
            testId: "addCommentButton"
        }, t4));
        $[13] = t4;
        $[14] = t5;
    } else t5 = $[14];
    return t5;
};
const $2998c7377d5266d6$export$f3a35a1c0e5d2996 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).COMMENTS
})($2998c7377d5266d6$export$5ed9c7f27c15b7fe);






var $gMc0m = parcelRequire("gMc0m");





var $3cu4A = parcelRequire("3cu4A");


var $7qvmT = parcelRequire("7qvmT");













var $bUlM5 = parcelRequire("bUlM5");

var $5dK2X = parcelRequire("5dK2X");




var $8jHAi = parcelRequire("8jHAi");








var $cAdj8 = parcelRequire("cAdj8");


var $dANtQ = parcelRequire("dANtQ");


var $3ejfs = parcelRequire("3ejfs");














var $i8TeS = parcelRequire("i8TeS");


var $cZRYC = parcelRequire("cZRYC");








var $7wP5b = parcelRequire("7wP5b");


var $ibqdE = parcelRequire("ibqdE");

/**
 * @generated SignedSource<<77c075c1a35684ed43d6a03130494611>>
 * @relayHash 9fe996eb874f5dede5dfc631ede9be23
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2fa3189beb0d12f2e99399a53106adbbd4a876cdd3959a0dd45b206edfab8006
const $db736b7a8747d643$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentIdToDelete"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "deleteFrom"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentIdToDelete",
                    "variableName": "commentIdToDelete"
                },
                {
                    "kind": "Variable",
                    "name": "deleteFrom",
                    "variableName": "deleteFrom"
                }
            ],
            "kind": "ScalarField",
            "name": "deleteComment"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ObjectCommentDeleteGeneralCommentMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ObjectCommentDeleteGeneralCommentMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "9fe996eb874f5dede5dfc631ede9be23",
            "id": "2fa3189beb0d12f2e99399a53106adbbd4a876cdd3959a0dd45b206edfab8006",
            "metadata": {},
            "name": "ObjectCommentDeleteGeneralCommentMutation",
            "operationKind": "mutation",
            "text": "mutation ObjectCommentDeleteGeneralCommentMutation($commentIdToDelete:ID!,$deleteFrom:CommentDeletionLocation){deleteComment(commentIdToDelete:$commentIdToDelete,deleteFrom:$deleteFrom)}"
        }
    };
}();
$db736b7a8747d643$var$node.hash = "70583226681dc587971b709a0fb5f1db";
var $db736b7a8747d643$export$2e2bcd8739ae039 = $db736b7a8747d643$var$node;


/**
 * @generated SignedSource<<b73e743fb543d99475940b76037103ea>>
 * @relayHash b4e5556f7ff0caaaa5f1f415e0fac219
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e9fa83969df6abf4d4b492477645bde3a26b2e75d7cfa9ff354ba53793c159bf
const $c485e89730d7822c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commentId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "commentId",
            "variableName": "commentId"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "concreteType": "ConfluenceCommentResolutionState",
        "kind": "LinkedField",
        "name": "commentResolutionStates",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "commentId"
            },
            {
                "kind": "ScalarField",
                "name": "status"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "errorType"
            },
            {
                "kind": "ScalarField",
                "name": "statusCode"
            }
        ],
        "type": "ReopenCommentsMutationErrorExtension"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ObjectCommentReopenCommentMutation",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "ConfluenceReopenCommentPayload",
                    "kind": "LinkedField",
                    "name": "confluence_reopenComment",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ObjectCommentReopenCommentMutation",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "ConfluenceReopenCommentPayload",
                    "kind": "LinkedField",
                    "name": "confluence_reopenComment",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b4e5556f7ff0caaaa5f1f415e0fac219",
            "id": "e9fa83969df6abf4d4b492477645bde3a26b2e75d7cfa9ff354ba53793c159bf",
            "metadata": {},
            "name": "ObjectCommentReopenCommentMutation",
            "operationKind": "mutation",
            "text": "mutation ObjectCommentReopenCommentMutation($commentId:ID!,$cloudId:ID!){confluence_reopenComment(commentId:$commentId,cloudId:$cloudId){success,commentResolutionStates{commentId,status},errors{message,extensions{...on ReopenCommentsMutationErrorExtension{errorType,statusCode},__typename,...on BulkMutationErrorExtension{id}}}}}"
        }
    };
}();
$c485e89730d7822c$var$node.hash = "08b0a438d17f5dfc7506b876a28c3269";
var $c485e89730d7822c$export$2e2bcd8739ae039 = $c485e89730d7822c$var$node;


/**
 * @generated SignedSource<<eaed9865a7e88310fd4236f4e49f68f8>>
 * @relayHash a8f662ea3948cbf66f23cd060b8803dd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2ccc5bea86cc33406aa32467d323c904c73f7bdc731e44dfb1f2b74b491a4c92
const $b2dfa720986474e4$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commentIds"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "commentIds",
            "variableName": "commentIds"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "concreteType": "ConfluenceCommentResolutionState",
        "kind": "LinkedField",
        "name": "commentResolutionStates",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "commentId"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "resolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "resolvedTime"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "resolvedUser"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "resolvedFriendlyDate"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "status"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "errorType"
            },
            {
                "kind": "ScalarField",
                "name": "statusCode"
            }
        ],
        "type": "ResolveCommentsMutationErrorExtension"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ObjectCommentResolveCommentMutation",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "ConfluenceResolveCommentsPayload",
                    "kind": "LinkedField",
                    "name": "confluence_resolveComments",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ObjectCommentResolveCommentMutation",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "ConfluenceResolveCommentsPayload",
                    "kind": "LinkedField",
                    "name": "confluence_resolveComments",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "a8f662ea3948cbf66f23cd060b8803dd",
            "id": "2ccc5bea86cc33406aa32467d323c904c73f7bdc731e44dfb1f2b74b491a4c92",
            "metadata": {},
            "name": "ObjectCommentResolveCommentMutation",
            "operationKind": "mutation",
            "text": "mutation ObjectCommentResolveCommentMutation($commentIds:[ID]!,$cloudId:ID!){confluence_resolveComments(commentIds:$commentIds,cloudId:$cloudId){success,commentResolutionStates{commentId,resolveProperties{resolvedTime,resolvedUser,resolvedFriendlyDate},status},errors{message,extensions{...on ResolveCommentsMutationErrorExtension{errorType,statusCode},__typename,...on BulkMutationErrorExtension{id}}}}}"
        }
    };
}();
$b2dfa720986474e4$var$node.hash = "b22b5ff3d19850498d8af166b371db75";
var $b2dfa720986474e4$export$2e2bcd8739ae039 = $b2dfa720986474e4$var$node;









var $inPa6 = parcelRequire("inPa6");


var $3ZsvI = parcelRequire("3ZsvI");





var $NYiei = parcelRequire("NYiei");


var $jbF1h = parcelRequire("jbF1h");











var $bSvtO = parcelRequire("bSvtO");





var $auGhu = parcelRequire("auGhu");


var $kEmgx = parcelRequire("kEmgx");


var $isdzP = parcelRequire("isdzP");

var $8dA1U = parcelRequire("8dA1U");





var $3s9yq = parcelRequire("3s9yq");


var $9rE3H = parcelRequire("9rE3H");


var $b1hSc = parcelRequire("b1hSc");


var $liGyh = parcelRequire("liGyh");


var $7aw3q = parcelRequire("7aw3q");

















var $9CnRS = parcelRequire("9CnRS");


var $87CZC = parcelRequire("87CZC");














var $fy5yb = parcelRequire("fy5yb");











var $6tkbf = parcelRequire("6tkbf");





var $308Wd = parcelRequire("308Wd");

const $972174ea64671f70$var$ObjectCommentResolveCommentMutation = (0, $b2dfa720986474e4$export$2e2bcd8739ae039);
const $972174ea64671f70$var$ObjectCommentReopenCommentMutation = (0, $c485e89730d7822c$export$2e2bcd8739ae039);
const $972174ea64671f70$var$ObjectCommentDeleteGeneralCommentMutation = (0, $db736b7a8747d643$export$2e2bcd8739ae039);
const $972174ea64671f70$var$i18n = (0, $aXWIB.defineMessages)({
    commentReopenedFlagTitle: {
        id: "object-comments.comment.reopened.flag.title",
        defaultMessage: "Comment reopened"
    },
    commentReopenFailedFlagTitle: {
        id: "object-comments.comment.reopen.failed.flag.title",
        defaultMessage: "Failed to reopen comment"
    },
    commentReopenCacheUpdateFailedFlagTitle: {
        id: "object-comments.comment.reopen.cache-update.failed.flag.title",
        defaultMessage: "Failed to update reopened comment. Please refresh the page."
    },
    retryCTA: {
        id: "object-comments.comment.reopen.failed.flag.cta.retry",
        defaultMessage: "Retry now"
    }
});
const $972174ea64671f70$var$logger = (0, $7W8i8.getLogger)('page-comments-queries');
const $972174ea64671f70$export$f8aa7c43d6421d1d = ({ comment: comment, supportedTopLevelActions: supportedTopLevelActions, pageMode: pageMode, pageInfo: pageInfo, isUnread: isUnread = false, isHovered: isHovered, threadKey: threadKey, flags: flags, adjustForNestedReplies: adjustForNestedReplies = false, hideBranchingStyle: hideBranchingStyle = false, canAddComments: canAddComments = true, isThreadHovered: isThreadHovered, isParentCommentOpen: isParentCommentOpen, adjustForFooterNestedReplies: adjustForFooterNestedReplies = false, topLevelParentCommentId: topLevelParentCommentId, commentHasChildren: commentHasChildren = false, isLastNestedFooterReply: isLastNestedFooterReply = false, isOffline: isOffline = false, showRepliesWithCurvedBorders: showRepliesWithCurvedBorders, replyHasNestedObjects: replyHasNestedObjects = false })=>{
    // Store stable references to break circular dependency in useCallback
    const handleResolveCommentRef = (0, $42omo.useRef)(null);
    const handleReopenCommentRef = (0, $42omo.useRef)(null);
    const { isReactionsEnabled: isReactionsEnabled } = (0, $42omo.useContext)((0, $8SCD6.ReactionsContext));
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const [contentId = ''] = (0, $ep3mz.usePageContentId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [{ commentsDataMap: legacyCommentsDataMap, hasNestedComments: legacyHasNestedComments, cacheUpdateFailed: cacheUpdateFailed }, { addNewCommentThreads: addNewCommentThreads, addReplyToCommentThread: addReplyToCommentThread, deleteParentComment: deleteParentComment, handleRemovingComments: handleRemovingComments }] = (0, $8i27m.useCommentsData)();
    const { setCacheUpdateFailed: setCacheUpdateFailed } = (0, $8i27m.useCommentsDataActions)();
    // Get cache operations for new comments data manager
    const { deleteCommentInCache: deleteCommentInCache } = (0, $NYiei.useAllCommentsData)({
        contentId: contentId,
        options: {
            skip: true // Only using write operations, no need to fetch data
        }
    });
    // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    // Use new or legacy data based on experiment
    const commentsDataMap = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? processedCommentsData.commentsDataMap : legacyCommentsDataMap;
    // Use new or legacy hasNestedComments based on experiment
    const hasNestedComments = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? processedCommentsData.hasNestedComments : legacyHasNestedComments;
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [{ currentlySelectedThreadKey: currentlySelectedThreadKey, footerEditCommentIds: footerEditCommentIds }, { setCurrentView: setCurrentView, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setReplyToCommentId: setReplyToCommentId, addFooterEditCommentId: addFooterEditCommentId, removeFooterEditCommentId: removeFooterEditCommentId }] = (0, $3mVfX.useCommentsPanel)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { focusedCommentId: focusedCommentId } = (0, $liGyh.useInlineCommentQueryParams)();
    const { isCommentsPanelShown: isCommentsPanelShown, showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const allowComments = (0, $7aw3q.useEmbeddedComments)();
    const [resolveCommentFn] = (0, $308Wd.useMutationInterop)($972174ea64671f70$var$ObjectCommentResolveCommentMutation, {
        ...(0, $6tkbf.buildMutationContextForNoNetworkError)(),
        __callerPackage__: "@confluence/object-comments"
    });
    const resolveCommentMutationFn = resolveCommentFn;
    const [reopenCommentFn] = (0, $308Wd.useMutationInterop)($972174ea64671f70$var$ObjectCommentReopenCommentMutation, {
        refetchQueries: // Copied from the existing dialog flow to support standalone experience
        pageMode === (0, $cD1qu.PageMode).VIEW && !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? [
            {
                query: (0, $3s9yq.InlineCommentsQuery),
                variables: {
                    pageId: contentId
                }
            }
        ] : [],
        ...(0, $6tkbf.buildMutationContextForNoNetworkError)(),
        __callerPackage__: "@confluence/object-comments"
    });
    // Get the update functions for the comments data manager - aliased to support the different
    // mutation's different result types
    const { updateCommentInCache: updateResolveCommentInCache } = (0, $jbF1h.useUpdateCommentInCache)();
    const { updateCommentInCache: updateReopenCommentInCache } = (0, $jbF1h.useUpdateCommentInCache)();
    const [deleteGeneralCommentFn] = (0, $308Wd.useMutationInterop)($972174ea64671f70$var$ObjectCommentDeleteGeneralCommentMutation, {
        ...(0, $6tkbf.buildMutationContextForNoNetworkError)(),
        __callerPackage__: "@confluence/object-comments"
    });
    const userId = comment?.author?.accountId;
    const topCommentUserAvatar = comment?.author?.profilePicture?.path;
    const topCommentDisplayName = comment?.author?.displayName ?? formatMessage((0, $3ejfs.commentsi18n).anonymous);
    const commentId = comment?.id;
    const date = comment?.version?.when;
    const createdAt = comment?.createdAt?.value;
    const createdAtNonLocalized = comment?.createdAtNonLocalized;
    const versionByDisplayName = comment?.version?.by?.displayName;
    const versionDate = comment?.version?.when;
    const permissions = comment?.permissions;
    const content = comment?.body?.value;
    const permissionType = comment?.author?.permissionType ?? undefined;
    const parentCommentId = comment?.parentId;
    const isReply = !!parentCommentId;
    const isEdited = (comment?.version?.number || 0) > 1;
    const numReplies = comment?.replies?.length || 0;
    const commentUrl = comment?.links.webui ?? undefined;
    const inheritedReactionsData = comment?.reactionsSummary;
    const footerCommentLocation = comment?.location;
    const getResolvedProperties = (0, $42omo.useCallback)(()=>{
        const properties = footerCommentLocation?.commentResolveProperties;
        if (!isReply) return properties || undefined;
        return undefined;
    }, [
        footerCommentLocation,
        isReply
    ]);
    const resolveProperties = getResolvedProperties();
    const isCommentRemovedByAnotherUser = comment?.wasRemovedByAnotherUser;
    const isResolvedByAnotherUser = isCommentRemovedByAnotherUser && isCommentRemovedByAnotherUser === (0, $8i27m.CommentActionType).RESOLVE_COMMENT_THREAD;
    const isDeletedByAnotherUser = isCommentRemovedByAnotherUser && isCommentRemovedByAnotherUser === (0, $8i27m.CommentActionType).DELETE_COMMENT;
    const deleteCommentInCacheOnUpdate = (0, $42omo.useCallback)((removalCommentId)=>deleteCommentInCache({
            commentId: removalCommentId,
            onError: (err)=>{
                (0, $8dA1U.handleMutationFailure)({
                    experienceTracker: experienceTracker,
                    experienceName: (0, $irVI7.DELETE_PAGE_COMMENT_EXPERIENCE),
                    error: err,
                    commentId: removalCommentId
                });
            }
        }), [
        deleteCommentInCache,
        experienceTracker
    ]);
    const isOptimisticDeleteEnabled = // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && (0, $6mKj3.expVal)('confluence_fe_delete_comment_optimistic', 'isEnabled', false);
    const nonMemoizedHandleDeleteGeneralComment = ()=>{
        let deleteLocation;
        const deleteVariables = {
            variables: {
                commentIdToDelete: commentId,
                deleteFrom: deleteLocation
            },
            update: (0, $kgNLQ.selectUpdateFunction)((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false), ()=>deleteCommentInCacheOnUpdate(commentId), ()=>isReply ? (0, $87CZC.updateApolloCacheReplyCallback)('delete', {
                    pageId: contentId,
                    contentStatus: [
                        'DRAFT',
                        'CURRENT'
                    ],
                    type: [
                        'FOOTER'
                    ]
                }, parentCommentId, isReactionsEnabled, commentId) : (0, $87CZC.updateApolloCacheParentCallback)('delete', {
                    pageId: contentId,
                    contentStatus: [
                        'DRAFT',
                        'CURRENT'
                    ],
                    type: [
                        'FOOTER'
                    ]
                }, isReactionsEnabled, commentId)),
            optimisticResponse: isOptimisticDeleteEnabled ? {
                deleteComment: true
            } : undefined
        };
        // Optimistically delete the comment thread, if it is not a reply.
        const deletedParentComment = !isReply && isOptimisticDeleteEnabled && !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? (0, $fy5yb.deleteParentCommentOptimistically)({
            threadKey: threadKey,
            commentType: (0, $8i27m.CommentType).GENERAL,
            commentsDataMap: commentsDataMap,
            deleteParentComment: deleteParentComment
        }) : null;
        // Optimistically delete the reply, if it is a reply.
        const deletedReplyComment = isReply && isOptimisticDeleteEnabled && !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? (0, $fy5yb.deleteReplyCommentOptimistically)({
            threadKey: threadKey,
            commentId: commentId,
            commentType: (0, $8i27m.CommentType).GENERAL,
            commentsDataMap: commentsDataMap,
            handleRemovingComments: handleRemovingComments
        }) : null;
        deleteGeneralCommentFn({
            ...deleteVariables
        }).then(({ data: data })=>{
            if (!data || !data.deleteComment) throw new Error('No data returned from mutation');
            resetContentChanged();
            if (!isOptimisticDeleteEnabled && !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                if (isReply) handleRemovingComments({
                    threadKey: threadKey,
                    commentId: commentId,
                    action: (0, $8i27m.CommentActionType).DELETE_COMMENT,
                    commentType: (0, $8i27m.CommentType).GENERAL
                });
                else deleteParentComment({
                    threadKey: threadKey,
                    commentType: (0, $8i27m.CommentType).GENERAL
                });
            }
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'deleted',
                    actionSubject: 'comment',
                    actionSubjectId: commentId,
                    objectType: 'page',
                    objectId: contentId,
                    source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                    attributes: {
                        ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                        commentType: (0, $en1dX.CommentType).PAGE,
                        source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                        pageMode: pageMode,
                        isReply: isReply
                    }
                }
            }).fire();
            experienceTracker.succeed({
                name: (0, $irVI7.DELETE_PAGE_COMMENT_EXPERIENCE)
            });
        }).catch((err_0)=>{
            const parsedError = (0, $isdzP.parseError)(err_0);
            const translatedError = (0, $isdzP.getTranslatedError)(parsedError.message, commentId);
            if ((0, $isdzP.isAlreadyDeletedError)(translatedError)) {
                flags?.showWarningFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $9CnRS.i18n).commentAlreadyDeletedTitle),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), translatedError)
                });
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'alreadyDeleted',
                        actionSubject: 'comment',
                        actionSubjectId: commentId,
                        objectType: 'page',
                        objectId: contentId,
                        source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                        attributes: {
                            ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                            commentType: (0, $8i27m.CommentType).GENERAL,
                            source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                            mode: pageMode,
                            isReply: isReply
                        }
                    }
                }).fire();
            } else if (isOptimisticDeleteEnabled) // show an error flag to the user when optimistic deletion fails
            flags?.showErrorFlag({
                id: commentId,
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $9CnRS.i18n).deleteErrorTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $9CnRS.i18n).deleteError)
            });
            // add back the optimistically deleted comment or reply
            if (deletedParentComment && isOptimisticDeleteEnabled && !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) addNewCommentThreads(deletedParentComment);
            if (deletedReplyComment && isOptimisticDeleteEnabled && !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) addReplyToCommentThread(threadKey, deletedReplyComment, (0, $8i27m.CommentType).GENERAL, true);
            (0, $8dA1U.handleMutationFailure)({
                experienceTracker: experienceTracker,
                experienceName: (0, $irVI7.DELETE_PAGE_COMMENT_EXPERIENCE),
                error: err_0,
                commentId: commentId
            });
        });
    };
    const memoizedHandleDeleteGeneralComment = (0, $42omo.useCallback)(nonMemoizedHandleDeleteGeneralComment, [
        commentId,
        createAnalyticsEvent,
        deleteGeneralCommentFn,
        deleteParentComment,
        deleteCommentInCacheOnUpdate,
        experienceTracker,
        flags,
        handleRemovingComments,
        isReactionsEnabled,
        isReply,
        contentId,
        pageMode,
        parentCommentId,
        resetContentChanged,
        threadKey,
        isOptimisticDeleteEnabled,
        addNewCommentThreads,
        addReplyToCommentThread,
        commentsDataMap
    ]);
    /**
   * editComment, deleteComment, and resolveComment cause instability in CommentBody when rendering. Although
   * useStableCallback would be more ideal to simplify the overhead for consumers of CommentBody, these functions
   * as props are used as proxies for permissions meaning they could be undefined which violates the typing for useStableCallback
   */ const handleDeleteGeneralComment = (0, $6mKj3.expValEquals)('cc_fe_performance_page_comments_stability', 'cohort', 'experiment') ? memoizedHandleDeleteGeneralComment : nonMemoizedHandleDeleteGeneralComment;
    const nonMemoHandleEditComment = ()=>{
        addFooterEditCommentId(commentId);
    };
    const memoizedHandleEditComment = (0, $42omo.useCallback)(nonMemoHandleEditComment, [
        addFooterEditCommentId,
        commentId
    ]);
    const handleEditComment = (0, $6mKj3.expValEquals)('cc_fe_performance_page_comments_stability', 'cohort', 'experiment') ? memoizedHandleEditComment : nonMemoHandleEditComment;
    const exitCommentEditor = ()=>{
        removeFooterEditCommentId(commentId);
    };
    const handleReplyToComment = (id)=>{
        setReplyToCommentId({
            // If we allow nested comments, reply directly to the comment (set in CommentActions)
            // Otherwise, reply to the to the parent comment
            parentCommentId: hasNestedComments ? id : topLevelParentCommentId || id,
            location: (0, $i6UMJ.LocationValue).FOOTER,
            user: {
                // This field controls who we auto mention in the reply
                displayName: comment?.author?.displayName,
                accountId: comment?.author?.accountId
            }
        });
    };
    const handleReopenMutationFailure = (0, $42omo.useCallback)(({ isCacheUpdateFailed: isCacheUpdateFailed })=>{
        // TODO: Add experience tracking for reopening, which will allow us to differentiate and
        // detect cache errors vs mutation errors by the error value in the stopOnError() experience
        // call.  When that is added, we can go back to having a single flag message.
        flags?.showErrorFlag({
            id: commentId,
            title: formatMessage(isCacheUpdateFailed ? $972174ea64671f70$var$i18n.commentReopenCacheUpdateFailedFlagTitle : $972174ea64671f70$var$i18n.commentReopenFailedFlagTitle),
            isAutoDismiss: true,
            actions: [
                {
                    content: formatMessage($972174ea64671f70$var$i18n.retryCTA),
                    onClick: ()=>{
                        flags.hideFlag(flags.state.flags[0]?.id);
                        handleReopenCommentRef.current?.();
                    }
                }
            ]
        });
    }, [
        commentId,
        flags,
        formatMessage
    ]);
    const reopenCommentUpdateFn = (0, $42omo.useCallback)((_dataProxy, mutationResult)=>updateReopenCommentInCache({
            mutationResult: mutationResult,
            commentId: commentId,
            updateCallback: (0, $kgNLQ.reopenCommentInCacheCallback),
            onError: ()=>handleReopenMutationFailure({
                    isCacheUpdateFailed: true
                })
        }), [
        commentId,
        handleReopenMutationFailure,
        updateReopenCommentInCache
    ]);
    const nonMemoHandleReopenComment = ()=>{
        // NOTE: The reopen experience is started in CommentActions.tsx
        reopenCommentFn({
            variables: {
                commentId: commentId,
                cloudId: cloudId
            },
            update: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? reopenCommentUpdateFn : undefined
        }).then(()=>{
            // Update the state for panel experience
            if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                if ((0, $6mKj3.expVal)('confluence_fe_resolve_reopen_comment_refactor', 'isEnabled', false)) (0, $3ZsvI.reopenCommentInDataMap)(commentsDataMap, (0, $8i27m.CommentType).GENERAL, threadKey, addNewCommentThreads);
                else {
                    const commentsDataMapClone = {
                        ...commentsDataMap
                    };
                    const commentInMap = commentsDataMapClone[(0, $8i27m.CommentType).GENERAL][threadKey];
                    if (commentInMap) {
                        commentInMap.isOpen = true;
                        commentInMap.wasRemovedByAnotherUser = false;
                        addNewCommentThreads(commentsDataMapClone);
                        const commentLocation = commentInMap.location;
                        if (commentLocation && 'commentResolveProperties' in commentLocation && commentLocation.commentResolveProperties) commentLocation.commentResolveProperties.resolved = false;
                    }
                }
            }
            // Show the reopen flag
            flags?.showSuccessCircleFlag({
                id: commentId,
                title: formatMessage($972174ea64671f70$var$i18n.commentReopenedFlagTitle),
                isAutoDismiss: true,
                actions: [
                    {
                        content: formatMessage((0, $9CnRS.i18n).goToCommentCTA),
                        onClick: ()=>{
                            if (!isCommentsPanelShown) showCommentsPanel({
                                openWithView: (0, $3mVfX.ViewValues).OPEN
                            });
                            else setCurrentView((0, $3mVfX.ViewValues).OPEN);
                            if ((0, $6mKj3.expValEquals)('confluence_comments_scrollto_resolve', 'isEnabled', true)) (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
                                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                                context: (0, $9FoVw.NavigationContext).PANEL,
                                block: 'center',
                                annotationId: threadKey,
                                commentType: 'FOOTER',
                                annotationClicked: true,
                                expectedView: (0, $3mVfX.ViewValues).OPEN,
                                commentId: commentId
                            });
                            flags.hideFlag(flags.state.flags[0]?.id);
                        }
                    },
                    {
                        content: formatMessage((0, $9CnRS.i18n).undoCTA),
                        onClick: ()=>{
                            handleResolveCommentRef.current?.();
                            flags.hideFlag(flags.state.flags[0]?.id);
                        }
                    }
                ]
            });
        }).catch(()=>{
            handleReopenMutationFailure({
                isCacheUpdateFailed: false
            });
        });
    };
    const memoHandleReopenComment = (0, $42omo.useCallback)(nonMemoHandleReopenComment, [
        addNewCommentThreads,
        cloudId,
        commentId,
        commentsDataMap,
        flags,
        formatMessage,
        handleReopenMutationFailure,
        isCommentsPanelShown,
        reopenCommentFn,
        reopenCommentUpdateFn,
        setCurrentView,
        showCommentsPanel,
        threadKey
    ]);
    const handleResolveMutationFailure = (0, $42omo.useCallback)((resolveError)=>{
        (0, $8dA1U.handleMutationFailure)({
            experienceTracker: experienceTracker,
            experienceName: (0, $irVI7.RESOLVE_PAGE_COMMENT_EXPERIENCE),
            error: resolveError
        });
    }, [
        experienceTracker
    ]);
    const resolveCommentsUpdateFn = (0, $42omo.useCallback)((_dataProxy_0, mutationResult_0)=>updateResolveCommentInCache({
            mutationResult: mutationResult_0,
            commentId: commentId,
            updateCallback: (0, $kgNLQ.resolveCommentInCacheCallback),
            onError: handleResolveMutationFailure
        }), [
        updateResolveCommentInCache,
        commentId,
        handleResolveMutationFailure
    ]);
    const nonMemoHandleResolveComment = ()=>{
        if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) && (0, $6mKj3.expVal)('confluence_fe_resolve_comment_optimistic', 'isEnabled', false)) // Optimistically mark the comment as resolved in the data map & update UI early
        (0, $3ZsvI.resolveCommentInDataMap)(commentsDataMap, (0, $8i27m.CommentType).GENERAL, threadKey, addNewCommentThreads);
        const mutationVariables = {
            commentIds: [
                commentId
            ],
            cloudId: cloudId
        };
        const query = (0, $b1hSc.default);
        const queryVariables = (0, $9rE3H.buildConsistentActiveCommentsQueryVariables)({
            pageId: contentId,
            type: 'FOOTER' // If we have footer, always write to footer. Panel works either way
        });
        // NOTE: The RESOLVED experience is started in CommentActions.tsx
        resolveCommentMutationFn({
            variables: mutationVariables,
            update: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? resolveCommentsUpdateFn : (cache)=>{
                (0, $3ZsvI.updateCommentsQueryCacheForResolve)({
                    cache: cache,
                    commentId: commentId,
                    query: query,
                    queryVariables: queryVariables,
                    cacheUpdateFailed: cacheUpdateFailed,
                    setCacheUpdateFailed: setCacheUpdateFailed,
                    source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                    logger: $972174ea64671f70$var$logger
                });
            },
            // When a `optimisticResponse` is set, useMutation invokes the update function twice:
            // first immediately, and after mutation succeeds, a second time. If mutation fails,
            // the cache updated by the update function is rolled back. Thus, this optimistic
            // resolve works both when cc_comments_new_comments_data_manager is ON and OFF.
            optimisticResponse: (0, $6mKj3.expVal)('confluence_fe_resolve_comment_optimistic', 'isEnabled', false) ? {
                confluence_resolveComments: {
                    commentResolutionStates: [
                        {
                            commentId: commentId,
                            status: true,
                            resolveProperties: {
                                // These 2 values will be updated to the correct value after mutation succeeds.
                                // - `resolvedUser` is only displayed in comments panel Resolved view,
                                //   inside a tooltip when hovered.
                                // - `resolvedFriendlyDate` is only used when confluence_frontend_content_wrapper
                                //   is off; otherwise `resolvedTime` is used.
                                // So setting them as empty optimistically won't affect the static UI.
                                resolvedUser: null,
                                resolvedFriendlyDate: '',
                                resolvedTime: Date.now(),
                                __typename: 'InlineCommentResolveProperties'
                            },
                            __typename: 'ConfluenceCommentResolutionState'
                        }
                    ],
                    success: true,
                    errors: [],
                    __typename: 'ConfluenceResolveCommentsPayload'
                }
            } : undefined
        }).then(()=>{
            if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) && !(0, $6mKj3.expVal)('confluence_fe_resolve_comment_optimistic', 'isEnabled', false)) {
                // Update the state for panel experience when optimistic resolve is disabled
                // If enabled, this has been done before the mutation succeeds.
                if ((0, $6mKj3.expVal)('confluence_fe_resolve_reopen_comment_refactor', 'isEnabled', false)) (0, $3ZsvI.resolveCommentInDataMap)(commentsDataMap, (0, $8i27m.CommentType).GENERAL, threadKey, addNewCommentThreads);
                else {
                    const commentsDataMapClone_0 = {
                        ...commentsDataMap
                    };
                    const commentInMap_0 = commentsDataMapClone_0[(0, $8i27m.CommentType).GENERAL][threadKey];
                    if (commentInMap_0) {
                        commentsDataMapClone_0[(0, $8i27m.CommentType).GENERAL][threadKey].isOpen = false;
                        const commentLocation_0 = commentsDataMapClone_0[(0, $8i27m.CommentType).GENERAL][threadKey].location;
                        if (commentLocation_0 && commentLocation_0.commentResolveProperties) commentLocation_0.commentResolveProperties.resolved = true;
                        addNewCommentThreads(commentsDataMapClone_0);
                    }
                }
            }
            (0, $8dA1U.handleResolveSuccess)({
                commentId: commentId,
                parentCommentMarkerRef: threadKey,
                pageId: contentId,
                pageMode: pageMode,
                source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                commentType: (0, $8i27m.CommentType).GENERAL,
                createAnalyticsEvent: createAnalyticsEvent
            });
            if (allowComments) flags?.showSuccessCircleFlag({
                id: commentId,
                title: formatMessage((0, $9CnRS.i18n).resolvedFlagText),
                isAutoDismiss: true,
                actions: [
                    {
                        content: formatMessage((0, $9CnRS.i18n).goToCommentCTA),
                        onClick: ()=>{
                            if (!isCommentsPanelShown) showCommentsPanel({
                                openWithView: (0, $3mVfX.ViewValues).RESOLVED
                            });
                            else setCurrentView((0, $3mVfX.ViewValues).RESOLVED);
                            if ((0, $6mKj3.expValEquals)('confluence_comments_scrollto_resolve', 'isEnabled', true)) (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
                                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                                context: (0, $9FoVw.NavigationContext).PANEL,
                                block: 'center',
                                annotationId: threadKey,
                                commentType: 'FOOTER',
                                annotationClicked: true,
                                expectedView: (0, $3mVfX.ViewValues).RESOLVED,
                                commentId: commentId
                            });
                            flags.hideFlag(flags.state.flags[0]?.id);
                        }
                    },
                    {
                        content: formatMessage((0, $9CnRS.i18n).undoCTA),
                        onClick: ()=>{
                            handleReopenCommentRef.current?.();
                            flags.hideFlag(flags.state.flags[0]?.id);
                        }
                    }
                ]
            });
            experienceTracker.succeed({
                name: (0, $irVI7.RESOLVE_PAGE_COMMENT_EXPERIENCE)
            });
        }).catch((err_1)=>{
            if ((0, $6mKj3.expVal)('confluence_fe_resolve_comment_optimistic', 'isEnabled', false)) {
                if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) // Undo resolving the comment when optimistic resolve is enabled
                (0, $3ZsvI.reopenCommentInDataMap)(commentsDataMap, (0, $8i27m.CommentType).GENERAL, threadKey, addNewCommentThreads);
                // Show an error flag to user when resolve fails
                flags?.showErrorFlag({
                    id: commentId,
                    title: formatMessage((0, $9CnRS.i18n).resolveErrorTitle),
                    description: formatMessage((0, $9CnRS.i18n).resolveError)
                });
            }
            handleResolveMutationFailure(err_1);
        });
    };
    const memoizedHandleResolveComment = (0, $42omo.useCallback)(nonMemoHandleResolveComment, [
        addNewCommentThreads,
        allowComments,
        cacheUpdateFailed,
        cloudId,
        commentId,
        commentsDataMap,
        createAnalyticsEvent,
        experienceTracker,
        flags,
        formatMessage,
        handleResolveMutationFailure,
        isCommentsPanelShown,
        contentId,
        pageMode,
        resolveCommentMutationFn,
        resolveCommentsUpdateFn,
        setCacheUpdateFailed,
        setCurrentView,
        showCommentsPanel,
        threadKey
    ]);
    const handleResolveComment = (0, $6mKj3.expValEquals)('cc_fe_performance_page_comments_stability', 'cohort', 'experiment') ? memoizedHandleResolveComment : nonMemoHandleResolveComment;
    const handleReopenComment = (0, $6mKj3.expValEquals)('cc_fe_performance_page_comments_stability', 'cohort', 'experiment') ? memoHandleReopenComment : nonMemoHandleReopenComment;
    // Update refs to break circular dependency
    handleResolveCommentRef.current = handleResolveComment;
    handleReopenCommentRef.current = handleReopenComment;
    const pageType = pageInfo?.type ?? '';
    // Editor setup
    const spaceId = pageInfo?.space?.id ?? '';
    // User page permissions
    const operations = pageInfo?.operations || [];
    // User space permissions - only access when feature gate is on
    const spaceOperations = (0, $9wGTI.fg)('confluence_comments_space_operations_permissions') ? pageInfo?.space?.operations || [] : [];
    const canAddComment = operations.some((op)=>op?.operation === 'create' && op?.targetType === 'comment');
    const canAddAttachment = operations.some((op_1)=>op_1?.operation === 'create' && op_1?.targetType === 'attachment') || spaceOperations.some((op_0)=>op_0?.operation === 'create' && op_0?.targetType === 'attachment');
    // The user can upload media only if they have update permissions for the page if confluence_comment_use_comment_media_endpoint FG is off
    const hasMediaUploadPermissions = (0, $9wGTI.fg)('confluence_comment_use_comment_media_endpoint') ? canAddComment && canAddAttachment : operations.some((op_2)=>op_2?.operation === 'update' && op_2?.targetType === pageType);
    // We only want to focus resolved comments because the 'active' comments have
    // their own treatment for when one is hovered/selected and could cause weird behavior
    const isCommentFocused = resolveProperties?.resolved && commentId === focusedCommentId;
    const supportedActions = !isReply && isCommentRemovedByAnotherUser ? [
        'reopen'
    ] : supportedTopLevelActions;
    return footerEditCommentIds?.has(commentId) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auGhu.EditComment), {
        pageId: contentId,
        date: date ?? '',
        createdAtNonLocalized: createdAtNonLocalized,
        pageType: pageType,
        commentId: commentId,
        annotationId: threadKey,
        spaceId: spaceId,
        content: content ?? '',
        isReply: isReply,
        displayCommentInViewMode: exitCommentEditor,
        avatarUrl: topCommentUserAvatar ?? '',
        displayName: topCommentDisplayName,
        dateUrl: commentUrl ?? '',
        versionByDisplayName: versionByDisplayName ?? '',
        versionDate: versionDate ?? '',
        mode: pageMode === (0, $cD1qu.PageMode).VIEW ? 'view' : 'edit',
        hasMediaUploadPermissions: hasMediaUploadPermissions,
        isFooterComment: true,
        commentType: (0, $8i27m.CommentType).GENERAL,
        adjustForFooterReplies: (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? commentHasChildren || !isReply && numReplies > 0 : commentHasChildren || !isReply,
        isLastNestedFooterReply: isLastNestedFooterReply,
        isOffline: isOffline
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kEmgx.CommentBody), {
        mode: "view",
        annotationId: threadKey,
        userId: userId,
        avatarUrl: topCommentUserAvatar,
        displayName: topCommentDisplayName,
        date: date ?? '',
        dateUrl: commentUrl ?? '',
        createdAt: createdAt ?? '',
        createdAtNonLocalized: createdAtNonLocalized ?? '',
        versionByDisplayName: versionByDisplayName ?? '',
        versionDate: versionDate ?? '',
        pageId: contentId,
        pageType: pageType,
        commentId: commentId ?? '',
        isReply: isReply,
        isEdited: isEdited,
        parentCommentId: parentCommentId,
        permissions: permissions,
        content: content ?? '',
        permissionType: permissionType ?? undefined,
        supportedActions: supportedActions,
        deleteComment: handleDeleteGeneralComment,
        editComment: handleEditComment,
        resolveComment: handleResolveComment,
        numReplies: numReplies,
        isUnread: isUnread,
        isCommentActive: true,
        isCommentsPanel: true,
        isHovered: isHovered,
        isResolvedByAnotherUser: isResolvedByAnotherUser,
        isFocused: isCommentFocused,
        resolveProperties: resolveProperties,
        replyToComment: handleReplyToComment,
        inheritedReactionsData: inheritedReactionsData,
        isDeletedByAnotherUser: isDeletedByAnotherUser,
        currentlySelectedThreadKey: currentlySelectedThreadKey,
        setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey,
        commentType: (0, $8i27m.CommentType).GENERAL,
        adjustForNestedReplies: adjustForNestedReplies,
        hideBranchingStyle: hideBranchingStyle,
        canAddComments: canAddComments,
        isThreadHovered: isThreadHovered,
        isParentCommentOpen: isParentCommentOpen,
        isFooterComment: true,
        adjustForFooterNestedReplies: adjustForFooterNestedReplies,
        isOffline: isOffline,
        showRepliesWithCurvedBorders: showRepliesWithCurvedBorders,
        replyHasNestedObjects: replyHasNestedObjects
    });
};












var $ccHMk = parcelRequire("ccHMk");








var $6faGq = parcelRequire("6faGq");


var $8aF6s = parcelRequire("8aF6s");


var $cMvMc = parcelRequire("cMvMc");


var $1Sjzs = parcelRequire("1Sjzs");











var $58Zuw = parcelRequire("58Zuw");


var $lLpk8 = parcelRequire("lLpk8");


var $8gR6k = parcelRequire("8gR6k");










/* ObjectCommentNestableReplies.tsx generated by @compiled/babel-plugin v0.36.1 */ 




































/**
 * @generated SignedSource<<11689bf090d8c2f8165575bf8f23e0d1>>
 * @relayHash 1d9e1b43849e3df74cbece7106034480
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8a458ec6be112cd3ededf79466ea5c9786377fac3a29e8eb8df551b7938512f4
const $8e983492bd7543de$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v3 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "createFooterComment",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "profilePicture",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "accountId"
                                }
                            ],
                            "type": "KnownUser"
                        }
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "representation",
                            "value": "ATLAS_DOC_FORMAT"
                        }
                    ],
                    "concreteType": "DocumentBody",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": v3 /*: any*/ ,
                    "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
                },
                {
                    "kind": "ScalarField",
                    "name": "contentStatus"
                },
                {
                    "concreteType": "ConfluenceDate",
                    "kind": "LinkedField",
                    "name": "createdAt",
                    "plural": false,
                    "selections": v3 /*: any*/ 
                },
                {
                    "kind": "ScalarField",
                    "name": "createdAtNonLocalized"
                },
                {
                    "concreteType": "Map_LinkType_String",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "webui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "editui"
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "name": "location",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "InlineCommentResolveProperties",
                                    "kind": "LinkedField",
                                    "name": "commentResolveProperties",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "resolvedTime"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "resolvedFriendlyDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "resolvedUser"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "resolved"
                                        }
                                    ]
                                }
                            ],
                            "type": "FooterComment"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "parentId"
                },
                {
                    "concreteType": "CommentPermissions",
                    "kind": "LinkedField",
                    "name": "permissions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEditable"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isRemovable"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isResolvable"
                        }
                    ]
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "by",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "when"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ObjectCommentReplyEditorCreateGeneralReplyMutation",
            "selections": v4 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ObjectCommentReplyEditorCreateGeneralReplyMutation",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "1d9e1b43849e3df74cbece7106034480",
            "id": "8a458ec6be112cd3ededf79466ea5c9786377fac3a29e8eb8df551b7938512f4",
            "metadata": {},
            "name": "ObjectCommentReplyEditorCreateGeneralReplyMutation",
            "operationKind": "mutation",
            "text": "mutation ObjectCommentReplyEditorCreateGeneralReplyMutation($cloudId:ID!,$input:CreateCommentInput!){createFooterComment(cloudId:$cloudId,input:$input){id,author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on FooterComment{commentResolveProperties{resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number}}}"
        }
    };
}();
$8e983492bd7543de$var$node.hash = "bf58f0a383f4e192dfb098a8d5ea1e6c";
var $8e983492bd7543de$export$2e2bcd8739ae039 = $8e983492bd7543de$var$node;











var $lesF8 = parcelRequire("lesF8");








var $hXzKU = parcelRequire("hXzKU");








var $ag51I = parcelRequire("ag51I");























var $hl1Kw = parcelRequire("hl1Kw");

















var $emtVP = parcelRequire("emtVP");

const $7c5ea6bb1ec976c9$var$ObjectCommentReplyEditorCreateGeneralReplyMutation = (0, $8e983492bd7543de$export$2e2bcd8739ae039);
const $7c5ea6bb1ec976c9$var$commentEditorWrapperStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});
const $7c5ea6bb1ec976c9$var$commentEditorCustomStyles = {
    marginLeft: "var(--ds-space-300, 24px)",
    // Be careful updating this, it can cause the branch to jump slightly when switching from the button to the editor
    height: '24px',
    marginRight: "var(--ds-space-050, 4px)"
};
const $7c5ea6bb1ec976c9$export$25e4139e54938aaf = ({ pageInfo: pageInfo, pageMode: pageMode, setReplyView: setReplyView, parentComment: parentComment, threadKey: threadKey, replyToId: replyToId, isOffline: isOffline, customBeforeLeftForNestedReply: customBeforeLeftForNestedReply })=>{
    const replyEditorContainerId = `object-comment-reply-editor-${replyToId}`;
    const [createGeneralReplyFn] = (0, $308Wd.useMutationInterop)($7c5ea6bb1ec976c9$var$ObjectCommentReplyEditorCreateGeneralReplyMutation, {
        ...(0, $6tkbf.buildMutationContextForNoNetworkError)(),
        __callerPackage__: "@confluence/object-comments"
    });
    const pageId = pageInfo?.id ?? '';
    const pageType = pageInfo?.type ?? '';
    const spaceId = pageInfo?.space?.id ?? '';
    const commentType = parentComment.type;
    const { addCommentInCache: addCommentInCache } = (0, $NYiei.useAllCommentsData)({
        contentId: pageId,
        options: {
            skip: true // Only using write operations, no need to fetch data
        }
    });
    const createObjectCommentMutationFn = (0, $ag51I.useCreateObjectCommentMutation)();
    const { isReactionsEnabled: isReactionsEnabled } = (0, $42omo.useContext)((0, $8SCD6.ReactionsContext));
    const { onChange: onChange, resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { cloudId: cloudId, userId: userId, displayName: displayName } = (0, $bQm3c.useSessionData)();
    const [{ searchSessionId: searchSessionId }] = (0, $hl1Kw.useSearchSessionId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { addReplyToCommentThread: addReplyToCommentThread } = (0, $8i27m.useCommentsDataActions)();
    const [{ replyToCommentId: replyToCommentId, replyToCommentUser: replyToCommentUser }, { setReplyToCommentId: setReplyToCommentId }] = (0, $3mVfX.useCommentsPanel)();
    const [, setCommentForEdit] = (0, $42omo.useState)('');
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    // User page permissions
    const operations = pageInfo?.operations || [];
    // User space permissions - only access when feature gate is on
    const spaceOperations = (0, $9wGTI.fg)('confluence_comments_space_operations_permissions') ? pageInfo?.space?.operations || [] : [];
    const canAddComment = operations.some((op)=>op?.operation === 'create' && op?.targetType === 'comment');
    const canAddAttachment = operations.some((op_1)=>op_1?.operation === 'create' && op_1?.targetType === 'attachment') || spaceOperations.some((op_0)=>op_0?.operation === 'create' && op_0?.targetType === 'attachment');
    // The user can upload media only if they have update permissions for the page if confluence_comment_use_comment_media_endpoint FG is off
    const hasMediaUploadPermissions = (0, $9wGTI.fg)('confluence_comment_use_comment_media_endpoint') ? canAddComment && canAddAttachment : operations.some((op_2)=>op_2?.operation === 'update' && op_2?.targetType === pageType);
    const onEditorReady = (0, $42omo.useCallback)((editorActions)=>{
        let experienceName = (0, $irVI7.REPLY_TO_INLINE_COMMENT_LOAD_EXPERIENCE);
        if (commentType === (0, $8i27m.CommentType).GENERAL) experienceName = (0, $irVI7.REPLY_TO_PAGE_COMMENT_LOAD_EXPERIENCE);
        experienceTracker.succeed({
            name: experienceName
        });
        const commentReplyContainer = document.getElementById(replyEditorContainerId);
        if (!commentReplyContainer) return;
        // Check whether the bottom of the comment reply container is visible
        const isBottomOutOfView = commentReplyContainer.getBoundingClientRect().bottom > window.innerHeight;
        // Only scroll if we currently can't see the bottom of the comment reply container. It's annoying to always scroll
        if (isBottomOutOfView) commentReplyContainer.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
            inline: 'nearest'
        });
        // Focus the editor to position cursor after the @mention
        if (editorActions?.focus && (0, $9wGTI.fg)('confluence_fe_page_comment_reply_focus')) editorActions.focus();
    }, [
        commentType,
        experienceTracker,
        replyEditorContainerId
    ]);
    const handleCancelComment = (0, $42omo.useCallback)(({ destroy: destroy = false } = {})=>{
        if (!destroy || replyToCommentId !== replyToId) setReplyToCommentId();
    }, [
        replyToCommentId,
        replyToId,
        setReplyToCommentId
    ]);
    const handleSaveComment = (0, $42omo.useCallback)((adf, onSuccess)=>{
        // Wrap createFooterReplyFn to intercept the raw mutation result before
        // onSaveReply consumes it (onSaveReply's .then() returns undefined).
        // This lets us extract the new comment ID for the agent-mention tag.
        const wrappedCreateFooterReplyFn = (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true) ? (...args)=>{
            const promise = createGeneralReplyFn(...args);
            promise?.then(({ data: data })=>{
                const commentId = data?.createFooterComment?.id ?? data?.replyInlineComment?.id ?? replyToId;
                (0, $emtVP.handleAgentMentionInComment)(adf, cloudId, pageId, commentId);
            });
            return promise;
        } : createGeneralReplyFn;
        // Also wrap createObjectReplyFn — used when cc_comments_new_comments_data_manager
        // is enabled and takes precedence over createFooterReplyFn.
        // Using explicit if/else to avoid nested ternary (Sonar S3358).
        let wrappedCreateObjectReplyFn;
        if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) && (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true)) wrappedCreateObjectReplyFn = (...args_0)=>{
            const promise_0 = createObjectCommentMutationFn(...args_0);
            promise_0?.then(({ data: data_0 })=>{
                const commentId_0 = data_0?.createFooterComment?.id ?? data_0?.createObjectComment?.id ?? replyToId;
                (0, $emtVP.handleAgentMentionInComment)(adf, cloudId, pageId, commentId_0);
            });
            return promise_0;
        };
        else if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) wrappedCreateObjectReplyFn = createObjectCommentMutationFn;
        else wrappedCreateObjectReplyFn = undefined;
        return (0, $7qvmT.onSaveReply)({
            pageId: pageId,
            parentCommentId: replyToId,
            cloudId: cloudId,
            adf: adf,
            onSuccess: onSuccess,
            pageMode: pageMode,
            setCommentForEdit: setCommentForEdit,
            createAnalyticsEvent: createAnalyticsEvent,
            pageType: pageType,
            experienceTracker: experienceTracker,
            createFooterReplyFn: wrappedCreateFooterReplyFn,
            createObjectReplyFn: wrappedCreateObjectReplyFn,
            addCommentInCommentsDataManagerCacheFn: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? addCommentInCache : undefined,
            addReplyToCommentThread: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? ()=>{} : addReplyToCommentThread,
            threadKey: threadKey,
            commentType: commentType,
            searchSessionId: searchSessionId,
            isReactionsEnabled: isReactionsEnabled,
            setReplyView: setReplyView,
            setReplyToCommentId: setReplyToCommentId,
            resetContentChanged: resetContentChanged,
            analyticsSource: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
            isFooterComment: true,
            userId: userId,
            displayName: displayName
        });
    }, [
        threadKey,
        setReplyToCommentId,
        setReplyView,
        searchSessionId,
        resetContentChanged,
        replyToId,
        addReplyToCommentThread,
        cloudId,
        commentType,
        createAnalyticsEvent,
        createGeneralReplyFn,
        addCommentInCache,
        createObjectCommentMutationFn,
        experienceTracker,
        isReactionsEnabled,
        pageId,
        pageMode,
        pageType,
        userId,
        displayName
    ]);
    const commentEditorCommentType = commentType === (0, $8i27m.CommentType).GENERAL ? 'page' : commentType;
    const commentEditorPageMode = pageMode === 'edit' ? 'edit' : 'view';
    const editorContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: !(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && $7c5ea6bb1ec976c9$var$commentEditorWrapperStyles,
        id: replyEditorContainerId,
        testId: replyEditorContainerId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hXzKU.LazyCommentEditor), {
        pageId: pageId,
        pageType: pageType,
        content: (0, $7qvmT.getAdfForQuickReplyMention)(replyToCommentUser),
        appearance: "comment",
        EditorComponent: (0, $lesF8.CommentEditor),
        onSaveComment: handleSaveComment,
        onContentChange: onChange,
        onEditorReady: onEditorReady,
        commentMode: "reply",
        commentType: commentEditorCommentType,
        spaceId: spaceId,
        showCancelButton: true,
        useNewWarningModal: true,
        hideWatchCheckbox: true,
        expandEditor: true,
        pageMode: commentEditorPageMode,
        hasMediaUploadPermissions: hasMediaUploadPermissions,
        topLevelCommentId: parentComment.id,
        shouldWarnOnInternalNavigation: true,
        onCancelComment: handleCancelComment,
        isCommentsPanel: false,
        isFooterComment: true,
        wasRemovedByAnotherUser: parentComment.wasRemovedByAnotherUser,
        isOffline: isOffline
    }));
    if (!replyToCommentId) return null;
    return (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? editorContainer : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1Sjzs.WithCurvedBranchingStyle), {
        showDefaultStyles: true,
        customStyles: {
            ...$7c5ea6bb1ec976c9$var$commentEditorCustomStyles,
            ...customBeforeLeftForNestedReply && {
                left: '-25px'
            }
        }
    }, editorContainer);
};


'use no memo';
const $535a8f2c4921cd54$var$replyBoxStyles = null;
const $535a8f2c4921cd54$var$replyBoxStylesV2 = null;
const $535a8f2c4921cd54$var$objectCommentWrapperStyles = null;
const $535a8f2c4921cd54$var$nestedReplyThreadBoxStyles = null;
const $535a8f2c4921cd54$var$nestedReplyThreadBoxStylesV2 = null;
const $535a8f2c4921cd54$var$topLevelReplyThreadBoxStyles = null;
const $535a8f2c4921cd54$var$withLeftBorderStyle = null;
const $535a8f2c4921cd54$var$withLeftBorderStyleUpdated = null;
const $535a8f2c4921cd54$var$withLeftBoxShadow = null;
const $535a8f2c4921cd54$var$footerReplyContainerStyle = null;
const $535a8f2c4921cd54$var$footerReplyContainerStyleUpdated = null; // Curved branch styles for connecting replies
const $535a8f2c4921cd54$var$replyBranchStyles = null;
const $535a8f2c4921cd54$var$replyBranchStylesUpdated = null;
const $535a8f2c4921cd54$var$i18n = (0, $aXWIB.defineMessages)({
    replyAriaLabel: {
        id: "object-comments.reply.aria-label",
        defaultMessage: "Reply by {authorName}, {timestamp}"
    }
});
const $535a8f2c4921cd54$export$4c583da0a4f30f74 = ({ parentReplyId: parentReplyId, parentToRepliesMap: parentToRepliesMap, handleMouseEnter: handleMouseEnter, handleMouseLeave: handleMouseLeave, canAddComments: canAddComments, pageInfo: pageInfo, pageMode: pageMode, threadKey: threadKey, supportedTopLevelActions: supportedTopLevelActions, hoveredCommentId: hoveredCommentId, isTopLevelReply: isTopLevelReply, parentComment: parentComment, parentReplyButtonAllowed: parentReplyButtonAllowed, setReplyView: setReplyView, isOffline: isOffline, flags: flags, isEditorExpanded: isEditorExpanded })=>{
    const { replyToCommentId: replyToCommentId, location: location, footerEditCommentIds: footerEditCommentIds } = (0, $3mVfX.useCommentsPanelState)();
    const { hasNestedComments: legacyHasNestedComments } = (0, $8i27m.useCommentsDataState)();
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    const hasNestedComments = (0, $6mKj3.expValEquals)('cc_comments_new_comments_data_manager', 'isEnabled', true) ? processedCommentsData.hasNestedComments : legacyHasNestedComments;
    const [commentIsFocused, setCommentIsFocused] = (0, $42omo.useState)(null);
    const intl = (0, $aXWIB.useIntl)();
    const { formatMessage: formatMessage } = intl;
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    const isParentCommentOpen = parentComment.isOpen;
    const repliesToRender = parentToRepliesMap[parentReplyId];
    const handleFocus = (0, $42omo.useCallback)((event, replyId)=>{
        event.stopPropagation();
        setCommentIsFocused(replyId);
    }, [
        setCommentIsFocused
    ]);
    const handleBlur = (0, $42omo.useCallback)((event_0)=>{
        // Only clear focus if we're not focusing a child element
        if (!event_0.relatedTarget || !event_0.currentTarget.contains(event_0.relatedTarget)) setCommentIsFocused(null);
    }, [
        setCommentIsFocused
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testId": "footer-reply-container",
        role: "list",
        className: (0, $gMc0m.default)([
            isTopLevelReply ? "_1e0c1txw _2lx21bp4" : "_1e0c1txw _2lx21bp4 _18u0pxbi",
            isTopLevelReply && !(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && "_kqswh2mm _1n1j11qs _1kt9b3bt _1cs8stnw _qnecidpf _1aukidpf _19woidpf",
            isTopLevelReply && !(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && (0, $9wGTI.fg)('confluence_comment_border_migration') && "_1n1j1h4i"
        ])
    }, repliesToRender.map((reply, idx)=>{
        // These all control the visibility of the reply editor and left border
        // Generally speaking, we want to show the left border at the thread level rather than from comment body (showLeftBorder)
        // However, if one of the comment's will not have a left border (for example, if it's the last reply), we need to show at the comment level (!hideBranchingStyle)
        const replyHasChildren = parentToRepliesMap[reply.id]?.length > 0;
        const isLastReply = idx === repliesToRender.length - 1;
        const isFooterReplyMatchingReplyToCommentParameter = reply.id === replyToCommentId && location === (0, $i6UMJ.LocationValue).FOOTER;
        const showReplyEditor = hasNestedComments && isFooterReplyMatchingReplyToCommentParameter;
        const parentReplyButtonVisible = parentReplyButtonAllowed && isTopLevelReply;
        const replyHasNestedObjects = replyHasChildren || showReplyEditor;
        const replyIsBeingEdited = footerEditCommentIds?.has(reply.id);
        const showLeftBorder = parentReplyButtonVisible || replyHasNestedObjects && !isLastReply || replyIsBeingEdited && !isLastReply;
        const hideBranchingStyle = (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? isLastReply && (!isTopLevelReply || !isEditorExpanded) : parentReplyButtonVisible || replyHasNestedObjects || !parentReplyButtonVisible && isLastReply; // This moves the branching style 1px to the left to account for the 1px left border of the thread
        const adjustForFooterNestedReplies = hideBranchingStyle && (!isLastReply || parentReplyButtonVisible); // This accounts for the 1px missing border offset of the last reply in a deeply nested thread
        const isLastNestedFooterReply = isLastReply && !isTopLevelReply;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div" // Note: Cannot set `key` to `reply.id`, which, when optimistic save (COMMENTS-6792)
        , {
            // is enabled, is the fake optimistic id first and then gets updated to the actual
            // new comment id after mutation succeeds.
            // When mutation succeeds, DOM tree is updated. If `key` stays the same, the update
            // is recognized as multiple individual "mutation:attribute" for known attributes
            // excluded from VC calculation (e.g. data-testid); if key changes, the update is
            // recognized as a replacement of the entire element tree and counted in VC.
            // Unlike `reply.id`, `idx` is stable as long as the reply's position in the list
            // does not change.
            key: `${(0, $i6UMJ.LocationValue).FOOTER}-comment-thread-${parentComment.id}-replies-${idx}`,
            id: `${(0, $i6UMJ.LocationValue).FOOTER}-comment-thread-${reply.id}-replies`,
            "data-testid": `comment-thread-${parentReplyId}-replies-${reply.id}`,
            onMouseEnter: ()=>handleMouseEnter(reply.id),
            onMouseLeave: handleMouseLeave,
            onFocus: (event_1)=>handleFocus(event_1, reply.id),
            onBlur: handleBlur,
            role: "listitem",
            "aria-label": formatMessage($535a8f2c4921cd54$var$i18n.replyAriaLabel, {
                authorName: reply.author?.displayName || formatMessage((0, $3ejfs.commentsi18n).anonymous),
                timestamp: (0, $6faGq.formatTimestampForAriaLabel)({
                    intl: intl,
                    dateString: reply.createdAtNonLocalized,
                    isReply: true
                })
            }),
            className: (0, $gMc0m.default)([
                "_qtt8glyw _kqswh2mm _19bv1ejb",
                (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && "_19bvpxbi",
                "_kqswh2mm _1n1j11qs _4k1c11qs _1kt9b3bt _1cs8stnw _qnecidpf _1aukidpf _1mp41gif _kfgt1tcg _fik81mok _13y0usvi",
                (0, $9wGTI.fg)('confluence_comment_border_migration') && "_1n1j1h4i _4k1c1h4i",
                showLeftBorder && replyHasNestedObjects && (!isLastReply || isLastReply && isEditorExpanded || !(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true)) && "_16qsuq84",
                replyIsBeingEdited && !isLastReply && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && "_16qsuq84"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                !replyIsBeingEdited && "_n3tdu2gc"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $972174ea64671f70$export$f8aa7c43d6421d1d), {
            comment: reply,
            supportedTopLevelActions: supportedTopLevelActions,
            pageInfo: pageInfo,
            pageMode: pageMode,
            isUnread: unreadCommentIDSet.has(reply.id),
            isHovered: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? false : hoveredCommentId === reply.id || commentIsFocused === reply.id,
            threadKey: threadKey,
            hideBranchingStyle: hideBranchingStyle,
            adjustForNestedReplies: false,
            canAddComments: canAddComments,
            isParentCommentOpen: isParentCommentOpen,
            adjustForFooterNestedReplies: false,
            topLevelParentCommentId: parentComment.id,
            commentHasChildren: replyHasChildren,
            isLastNestedFooterReply: isLastNestedFooterReply,
            flags: flags,
            showRepliesWithCurvedBorders: false,
            replyHasNestedObjects: replyHasNestedObjects
        })), showReplyEditor && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_1e0c1txw _2lx21bp4 _18u0pxbi",
                replyHasChildren && "_1kl711qs",
                replyHasChildren && (0, $9wGTI.fg)('confluence_comment_border_migration') && "_1kl71h4i",
                replyHasChildren && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && "_19bvv47k"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7c5ea6bb1ec976c9$export$25e4139e54938aaf), {
            pageInfo: pageInfo,
            pageMode: pageMode,
            setReplyView: setReplyView,
            parentComment: parentComment,
            threadKey: threadKey,
            replyToId: reply.id,
            isOffline: isOffline,
            customBeforeLeftForNestedReply: adjustForFooterNestedReplies
        })), parentToRepliesMap[reply.id]?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($535a8f2c4921cd54$export$4c583da0a4f30f74, {
            parentReplyId: reply.id,
            parentToRepliesMap: parentToRepliesMap,
            handleMouseEnter: handleMouseEnter,
            handleMouseLeave: handleMouseLeave,
            canAddComments: canAddComments,
            pageInfo: pageInfo,
            pageMode: pageMode,
            threadKey: threadKey,
            supportedTopLevelActions: supportedTopLevelActions,
            hoveredCommentId: hoveredCommentId,
            isTopLevelReply: false,
            parentComment: parentComment,
            parentReplyButtonAllowed: false,
            setReplyView: setReplyView,
            isOffline: isOffline,
            flags: flags,
            isEditorExpanded: isEditorExpanded
        }));
    }));
};



const $b210b13432f2522a$var$replyActionButtonStyles = {
    marginLeft: "var(--ds-space-150, 12px)",
    width: '62px',
    height: '24px',
    left: '-12px',
    paddingTop: "var(--ds-space-100, 8px)",
    paddingBottom: "var(--ds-space-100, 8px)"
};
const $b210b13432f2522a$var$i18n = (0, $aXWIB.defineMessages)({
    replyAction: {
        id: "object-comments.reply.action",
        defaultMessage: "Reply"
    }
});
const $b210b13432f2522a$export$55de1ed49e182c87 = (t0)=>{
    const $ = (0, $frIzR.c)(108);
    const { parentComment: parentComment, pageInfo: pageInfo, hoveredCommentId: hoveredCommentId, pageMode: pageMode, parentCommentId: parentCommentId, handleMouseEnter: handleMouseEnter, handleMouseLeave: handleMouseLeave, canAddComments: canAddComments, isOffline: t1, flags: flags, isEditorExpanded: isEditorExpanded } = t0;
    const isOffline = t1 === undefined ? false : t1;
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    let t2;
    if ($[0] !== parentComment.replies) {
        t2 = parentComment.replies.filter($b210b13432f2522a$var$_temp);
        $[0] = parentComment.replies;
        $[1] = t2;
    } else t2 = $[1];
    const allReplies = t2;
    const numOfReplies = allReplies.length;
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    let t3;
    if ($[2] !== allReplies || $[3] !== unreadCommentIDSet) {
        let t4;
        if ($[5] !== unreadCommentIDSet) {
            t4 = (r_0)=>unreadCommentIDSet.has(r_0.id);
            $[5] = unreadCommentIDSet;
            $[6] = t4;
        } else t4 = $[6];
        t3 = allReplies.filter(t4).map($b210b13432f2522a$var$_temp2);
        $[2] = allReplies;
        $[3] = unreadCommentIDSet;
        $[4] = t3;
    } else t3 = $[4];
    const unreadReplyIds = t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = [];
        $[7] = t4;
    } else t4 = $[7];
    const [visibleReplies, setVisibleReplies] = (0, $42omo.useState)(t4);
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const commentType = parentComment.type;
    const isParentCommentOpen = parentComment.isOpen;
    const [currentReplyView, setReplyView] = (0, $42omo.useState)((0, $ibqdE.ViewReplyOptions).ALL);
    const threadKey = commentType === (0, $8i27m.CommentType).INLINE ? (parentComment?.location).inlineMarkerRef || "" : parentCommentId;
    let t5;
    if ($[8] !== isParentCommentOpen) {
        t5 = isParentCommentOpen ? [
            "edit",
            "resolve",
            "delete"
        ] : [
            "reopen"
        ];
        $[8] = isParentCommentOpen;
        $[9] = t5;
    } else t5 = $[9];
    const supportedTopLevelActions = t5;
    const expandReplyEditor = isEditorExpanded;
    let topLevelReplyToNestedChildrenMapInternal;
    if ($[10] !== allReplies || $[11] !== parentCommentId) {
        let t6;
        if ($[13] !== parentCommentId) {
            t6 = (reply)=>reply.parentId === parentCommentId;
            $[13] = parentCommentId;
            $[14] = t6;
        } else t6 = $[14];
        const topLevelReplyIds = new Set(allReplies.filter(t6).map($b210b13432f2522a$var$_temp3));
        topLevelReplyToNestedChildrenMapInternal = Array.from(topLevelReplyIds).reduce($b210b13432f2522a$var$_temp4, {});
        const replyIdToReplyMap = allReplies.reduce($b210b13432f2522a$var$_temp5, {});
        const filteredReplies = allReplies.filter((reply_2)=>!topLevelReplyIds.has(reply_2.id));
        for (const filteredReply of filteredReplies){
            let replyParentId = filteredReply.parentId;
            let circuitBreaker = 0;
            while(replyParentId && circuitBreaker < 100 && !topLevelReplyIds.has(replyParentId)){
                replyParentId = replyIdToReplyMap[replyParentId]?.parentId;
                circuitBreaker++;
            }
            if (replyParentId && replyParentId in topLevelReplyToNestedChildrenMapInternal) topLevelReplyToNestedChildrenMapInternal[replyParentId].push(filteredReply);
        }
        $[10] = allReplies;
        $[11] = parentCommentId;
        $[12] = topLevelReplyToNestedChildrenMapInternal;
    } else topLevelReplyToNestedChildrenMapInternal = $[12];
    const topLevelReplyToNestedChildrenMap = topLevelReplyToNestedChildrenMapInternal;
    let replies;
    if ($[15] !== allReplies || $[16] !== topLevelReplyToNestedChildrenMap) {
        replies = [];
        let t6;
        if ($[18] !== topLevelReplyToNestedChildrenMap) {
            t6 = (reply_3)=>reply_3.id in topLevelReplyToNestedChildrenMap;
            $[18] = topLevelReplyToNestedChildrenMap;
            $[19] = t6;
        } else t6 = $[19];
        const topLevelReplies = allReplies.filter(t6);
        topLevelReplies.sort($b210b13432f2522a$var$_temp6);
        for(let i = 0; i < (0, $ibqdE.DEFAULT_NUM_VISIBLE_REPLIES); i++)if (topLevelReplies.length > 0) {
            const reply_4 = topLevelReplies.pop();
            if (reply_4) replies.unshift(reply_4);
        }
        $[15] = allReplies;
        $[16] = topLevelReplyToNestedChildrenMap;
        $[17] = replies;
    } else replies = $[17];
    const latestReplies = replies;
    let latestAndNestedReplyIds;
    if ($[20] !== latestReplies || $[21] !== topLevelReplyToNestedChildrenMap) {
        latestAndNestedReplyIds = new Set();
        for (const reply_5 of latestReplies){
            latestAndNestedReplyIds.add(reply_5.id);
            for (const nestedReply of topLevelReplyToNestedChildrenMap[reply_5.id])latestAndNestedReplyIds.add(nestedReply.id);
        }
        $[20] = latestReplies;
        $[21] = topLevelReplyToNestedChildrenMap;
        $[22] = latestAndNestedReplyIds;
    } else latestAndNestedReplyIds = $[22];
    const latestReplyIds = latestAndNestedReplyIds;
    let parentToRepliesMapInternal;
    if ($[23] !== allReplies || $[24] !== parentCommentId) {
        parentToRepliesMapInternal = {
            [parentCommentId]: [],
            ...allReplies.reduce($b210b13432f2522a$var$_temp7, {})
        };
        for (const reply_7 of allReplies)if (reply_7.parentId && reply_7.parentId in parentToRepliesMapInternal) parentToRepliesMapInternal[reply_7.parentId].push(reply_7);
        $[23] = allReplies;
        $[24] = parentCommentId;
        $[25] = parentToRepliesMapInternal;
    } else parentToRepliesMapInternal = $[25];
    const parentToRepliesMap = parentToRepliesMapInternal;
    let t6;
    if ($[26] !== allReplies || $[27] !== currentReplyView || $[28] !== isParentCommentOpen || $[29] !== latestReplies || $[30] !== parentCommentId) {
        t6 = {
            allReplies: allReplies,
            isParentCommentOpen: isParentCommentOpen,
            currentReplyView: currentReplyView,
            latestReplies: latestReplies,
            parentCommentId: parentCommentId,
            setVisibleReplies: setVisibleReplies,
            allowNestedReplies: true
        };
        $[26] = allReplies;
        $[27] = currentReplyView;
        $[28] = isParentCommentOpen;
        $[29] = latestReplies;
        $[30] = parentCommentId;
        $[31] = t6;
    } else t6 = $[31];
    (0, $8gR6k.useUpdateVisibleReplies)(t6);
    let t7;
    if ($[32] !== hasContentChanged || $[33] !== parentCommentId || $[34] !== resetContentChanged || $[35] !== setReplyToCommentId || $[36] !== showModal) {
        t7 = ()=>{
            if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>{
                    resetContentChanged();
                    setReplyToCommentId({
                        parentCommentId: parentCommentId,
                        location: (0, $i6UMJ.LocationValue).FOOTER
                    });
                }
            });
            else setReplyToCommentId({
                parentCommentId: parentCommentId,
                location: (0, $i6UMJ.LocationValue).FOOTER
            });
        };
        $[32] = hasContentChanged;
        $[33] = parentCommentId;
        $[34] = resetContentChanged;
        $[35] = setReplyToCommentId;
        $[36] = showModal;
        $[37] = t7;
    } else t7 = $[37];
    const handleReplyButtonClick = t7;
    const canShowReplyButton = isParentCommentOpen && canAddComments;
    let t8;
    if ($[38] !== canShowReplyButton || $[39] !== expandReplyEditor || $[40] !== handleReplyButtonClick || $[41] !== isOffline || $[42] !== isParentCommentOpen || $[43] !== pageInfo || $[44] !== pageMode || $[45] !== parentComment || $[46] !== parentCommentId || $[47] !== threadKey) {
        t8 = ()=>expandReplyEditor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7c5ea6bb1ec976c9$export$25e4139e54938aaf), {
                pageInfo: pageInfo,
                pageMode: pageMode,
                setReplyView: setReplyView,
                parentComment: parentComment,
                threadKey: threadKey,
                replyToId: parentCommentId,
                isOffline: isOffline
            }) : canShowReplyButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1Sjzs.WithCurvedBranchingStyle), {
                showDefaultStyles: true,
                customStyles: $b210b13432f2522a$var$replyActionButtonStyles,
                testId: "comments-panel-reply-comment-action",
                onClick: handleReplyButtonClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                "data-cy": "comments-panel-reply-comment-action",
                appearance: "subtle",
                isDisabled: !isParentCommentOpen || isOffline,
                analyticsContext: {
                    attributes: {
                        name: "replyToCommentButton",
                        source: (0, $en1dX.AnalyticsSource).COMMENTS_PANEL
                    }
                },
                interactionName: "comments-panel-reply-comment-action"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $b210b13432f2522a$var$i18n.replyAction))) : null;
        $[38] = canShowReplyButton;
        $[39] = expandReplyEditor;
        $[40] = handleReplyButtonClick;
        $[41] = isOffline;
        $[42] = isParentCommentOpen;
        $[43] = pageInfo;
        $[44] = pageMode;
        $[45] = parentComment;
        $[46] = parentCommentId;
        $[47] = threadKey;
        $[48] = t8;
    } else t8 = $[48];
    const renderFooter = t8;
    let t9;
    if ($[49] !== allReplies || $[50] !== canAddComments || $[51] !== commentType || $[52] !== currentReplyView || $[53] !== expandReplyEditor || $[54] !== handleMouseEnter || $[55] !== handleMouseLeave || $[56] !== isParentCommentOpen || $[57] !== latestReplyIds || $[58] !== parentCommentId || $[59] !== unreadReplyIds) {
        t9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $58Zuw.RepliesToggler), {
                replies: allReplies,
                unreadReplyIds: unreadReplyIds,
                setReplyView: setReplyView,
                currentReplyView: currentReplyView,
                commentType: commentType,
                parentCommentId: parentCommentId,
                isParentOpen: isParentCommentOpen,
                canAddComments: canAddComments,
                latestReplyIds: latestReplyIds,
                onMouseEnter: handleMouseEnter,
                onMouseLeave: handleMouseLeave,
                analyticsSource: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                expandReplyEditor: expandReplyEditor
            });
        $[49] = allReplies;
        $[50] = canAddComments;
        $[51] = commentType;
        $[52] = currentReplyView;
        $[53] = expandReplyEditor;
        $[54] = handleMouseEnter;
        $[55] = handleMouseLeave;
        $[56] = isParentCommentOpen;
        $[57] = latestReplyIds;
        $[58] = parentCommentId;
        $[59] = unreadReplyIds;
        $[60] = t9;
    } else t9 = $[60];
    const renderRepliesToggler = t9;
    const wasRemovedByAnotherUser = parentComment ? parentComment.wasRemovedByAnotherUser === (0, $8i27m.CommentActionType).DELETE_COMMENT || parentComment.wasRemovedByAnotherUser === (0, $8i27m.CommentActionType).RESOLVE_COMMENT_THREAD : false;
    let baseStyle;
    if ($[61] !== wasRemovedByAnotherUser) {
        baseStyle = {
            display: "flex",
            flexDirection: "column",
            paddingLeft: "var(--ds-space-200, 16px)",
            paddingRight: "var(--ds-space-100, 8px)"
        };
        if (wasRemovedByAnotherUser) baseStyle.opacity = "50%";
        if ((0, $6mKj3.expValEquals)("confluence_comments_tuneup", "isEnabled", true)) baseStyle.paddingLeft = "var(--ds-space-150, 12px)";
        $[61] = wasRemovedByAnotherUser;
        $[62] = baseStyle;
    } else baseStyle = $[62];
    const repliesBoxStyle = baseStyle;
    let t10;
    if ($[63] !== numOfReplies || $[64] !== renderRepliesToggler) {
        t10 = numOfReplies > 0 && (0, $6mKj3.expValEquals)("confluence_comments_tuneup", "isEnabled", true) && renderRepliesToggler();
        $[63] = numOfReplies;
        $[64] = renderRepliesToggler;
        $[65] = t10;
    } else t10 = $[65];
    const t11 = `${(0, $i6UMJ.LocationValue).FOOTER}-comment-thread-${parentComment.id}-replies`;
    let t12;
    if ($[66] !== numOfReplies || $[67] !== renderRepliesToggler) {
        t12 = numOfReplies > 0 && !(0, $6mKj3.expValEquals)("confluence_comments_tuneup", "isEnabled", true) && renderRepliesToggler();
        $[66] = numOfReplies;
        $[67] = renderRepliesToggler;
        $[68] = t12;
    } else t12 = $[68];
    let t13;
    if ($[69] !== canAddComments || $[70] !== canShowReplyButton || $[71] !== flags || $[72] !== handleMouseEnter || $[73] !== handleMouseLeave || $[74] !== hoveredCommentId || $[75] !== isEditorExpanded || $[76] !== isOffline || $[77] !== pageInfo || $[78] !== pageMode || $[79] !== parentComment || $[80] !== parentCommentId || $[81] !== parentToRepliesMap || $[82] !== supportedTopLevelActions || $[83] !== threadKey || $[84] !== visibleReplies.length) {
        t13 = visibleReplies.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $535a8f2c4921cd54$export$4c583da0a4f30f74), {
            parentReplyId: parentCommentId,
            parentToRepliesMap: parentToRepliesMap,
            handleMouseEnter: handleMouseEnter,
            handleMouseLeave: handleMouseLeave,
            canAddComments: canAddComments,
            pageInfo: pageInfo,
            pageMode: pageMode,
            threadKey: threadKey,
            supportedTopLevelActions: supportedTopLevelActions,
            hoveredCommentId: hoveredCommentId,
            isTopLevelReply: true,
            parentComment: parentComment,
            parentReplyButtonAllowed: canShowReplyButton,
            setReplyView: setReplyView,
            isOffline: isOffline,
            flags: flags,
            isEditorExpanded: isEditorExpanded
        });
        $[69] = canAddComments;
        $[70] = canShowReplyButton;
        $[71] = flags;
        $[72] = handleMouseEnter;
        $[73] = handleMouseLeave;
        $[74] = hoveredCommentId;
        $[75] = isEditorExpanded;
        $[76] = isOffline;
        $[77] = pageInfo;
        $[78] = pageMode;
        $[79] = parentComment;
        $[80] = parentCommentId;
        $[81] = parentToRepliesMap;
        $[82] = supportedTopLevelActions;
        $[83] = threadKey;
        $[84] = visibleReplies.length;
        $[85] = t13;
    } else t13 = $[85];
    let t14;
    if ($[86] !== currentReplyView || $[87] !== handleReplyButtonClick || $[88] !== isEditorExpanded || $[89] !== isOffline || $[90] !== isParentCommentOpen || $[91] !== pageInfo || $[92] !== pageMode || $[93] !== parentComment || $[94] !== parentCommentId || $[95] !== renderFooter || $[96] !== threadKey || $[97] !== visibleReplies) {
        t14 = (0, $6mKj3.expValEquals)("confluence_comments_tuneup", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lLpk8.RepliesFooter), {
            replyView: currentReplyView,
            setReplyView: setReplyView,
            isEditorExpanded: isEditorExpanded,
            isParentCommentOpen: isParentCommentOpen,
            handleReplyButtonClick: handleReplyButtonClick,
            numOfVisibleReplies: visibleReplies ? visibleReplies.length : 0,
            isOffline: isOffline,
            scrollToId: parentCommentId,
            location: (0, $i6UMJ.LocationValue).FOOTER
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7c5ea6bb1ec976c9$export$25e4139e54938aaf), {
            pageInfo: pageInfo,
            pageMode: pageMode,
            setReplyView: setReplyView,
            parentComment: parentComment,
            threadKey: threadKey,
            replyToId: parentCommentId,
            isOffline: isOffline
        })) : renderFooter();
        $[86] = currentReplyView;
        $[87] = handleReplyButtonClick;
        $[88] = isEditorExpanded;
        $[89] = isOffline;
        $[90] = isParentCommentOpen;
        $[91] = pageInfo;
        $[92] = pageMode;
        $[93] = parentComment;
        $[94] = parentCommentId;
        $[95] = renderFooter;
        $[96] = threadKey;
        $[97] = visibleReplies;
        $[98] = t14;
    } else t14 = $[98];
    let t15;
    if ($[99] !== repliesBoxStyle || $[100] !== t11 || $[101] !== t12 || $[102] !== t13 || $[103] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": t11,
            style: repliesBoxStyle
        }, t12, t13, t14);
        $[99] = repliesBoxStyle;
        $[100] = t11;
        $[101] = t12;
        $[102] = t13;
        $[103] = t14;
        $[104] = t15;
    } else t15 = $[104];
    let t16;
    if ($[105] !== t10 || $[106] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t10, t15);
        $[105] = t10;
        $[106] = t15;
        $[107] = t16;
    } else t16 = $[107];
    return t16;
};
function $b210b13432f2522a$var$_temp(r) {
    return r !== null;
}
function $b210b13432f2522a$var$_temp2(r_1) {
    return r_1.id;
}
function $b210b13432f2522a$var$_temp3(reply_0) {
    return reply_0.id;
}
function $b210b13432f2522a$var$_temp4(acc, replyId) {
    acc[replyId] = [];
    return acc;
}
function $b210b13432f2522a$var$_temp5(acc_0, reply_1) {
    acc_0[reply_1.id] = reply_1;
    return acc_0;
}
function $b210b13432f2522a$var$_temp6(a, b) {
    const dateA = (0, $6faGq.getValidDate)(a?.createdAtNonLocalized);
    const dateB = (0, $6faGq.getValidDate)(b?.createdAtNonLocalized);
    return dateA.getTime() - dateB.getTime();
}
function $b210b13432f2522a$var$_temp7(acc_1, reply_6) {
    return {
        ...acc_1,
        [reply_6.id]: []
    };
}


const $e368ed9f3d927a75$var$commentThreadBoxStyles = (0, $ecnYn.xcss)({
    listStyle: 'none',
    position: 'relative',
    paddingLeft: 'space.200',
    paddingRight: 'space.250',
    paddingTop: 'space.100',
    // On figma this is 200 but the object comment have 100px padding on top
    paddingBottom: 'space.200',
    margin: '0',
    display: 'flex',
    flexDirection: 'column',
    // Focus styles with outline - better containment
    ':focus': {
        outlineOffset: 'space.negative.025'
    },
    ':focus-visible': {
        outlineOffset: 'space.negative.025'
    }
});
const $e368ed9f3d927a75$var$newCommentThreadBoxStyles = (0, $ecnYn.xcss)({
    cursor: 'pointer'
});
const $e368ed9f3d927a75$var$commentTypeSeperatorStyle = (0, $ecnYn.xcss)({
    display: 'flex',
    gap: 'space.050',
    paddingTop: 'space.300',
    paddingRight: 'space.300',
    paddingBottom: 'space.150',
    paddingLeft: 'space.200',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border'
});
const $e368ed9f3d927a75$var$commentBodyBoxStyles = (0, $ecnYn.xcss)({
    listStyle: 'none',
    position: 'relative',
    marginRight: 'space.100'
});
const $e368ed9f3d927a75$var$isCurrentUserSelectedCommentStyles = (0, $ecnYn.xcss)({
    background: "var(--ds-background-input-hovered, #F8F8F8)"
});
const $e368ed9f3d927a75$var$isThreadPressedStyles = (0, $ecnYn.xcss)({
    background: "var(--ds-background-input-hovered, #F8F8F8)"
});
const $e368ed9f3d927a75$var$i18n = (0, $aXWIB.defineMessages)({
    commentTypeSeperatorText: {
        id: "object-comments.comment.thread.type-seperator",
        defaultMessage: "General comments"
    },
    threadContentAriaLabelWithName: {
        id: "object-comments.thread.content.aria-label.with-name",
        defaultMessage: "{name}\u2019s comment thread"
    }
});
const $e368ed9f3d927a75$var$noop = ()=>{
// This is intentional
};
const $e368ed9f3d927a75$export$2ea19076574587a9 = (t0)=>{
    const $ = (0, $frIzR.c)(60);
    const { parentComment: parentComment, supportedTopLevelActions: supportedTopLevelActions, pageMode: pageMode, flags: flags, shouldRenderCommentTypeSeparator: shouldRenderCommentTypeSeparator, isLastThread: isLastThread, onLastThreadRendered: onLastThreadRendered, isOffline: isOffline } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [t1, t2] = (0, $3mVfX.useCommentsPanel)();
    const { currentlySelectedThreadKey: currentlySelectedThreadKey, isCurrentlySelectedThreadOptimisticallyAdded: isCurrentlySelectedThreadOptimisticallyAdded } = t1;
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey } = t2;
    const { pageInfo: pageInfo } = (0, $cAdj8.usePageInfo)();
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    const { isCommentsPanelShown: isCommentsPanelShown } = (0, $5fMeR.useShowCommentsPanel)();
    const threadKey = parentComment.id;
    const [isThreadHovered, setIsThreadHovered] = (0, $42omo.useState)(false);
    const [isThreadPressed, setIsThreadPressed] = (0, $42omo.useState)(false);
    const [hoveredCommentId, setHoveredCommentId] = (0, $42omo.useState)(undefined);
    const [commentIsFocused, setCommentIsFocused] = (0, $42omo.useState)(false);
    const isEditorExpanded = (0, $7wP5b.useIsEditorExpanded)(parentComment, (0, $i6UMJ.LocationValue).FOOTER);
    const commentRef = (0, $42omo.useRef)(null);
    const isCurrentSelectedComment = currentlySelectedThreadKey === threadKey || parentComment.type === (0, $8i27m.CommentType).GENERAL && !!isCurrentlySelectedThreadOptimisticallyAdded && threadKey === (0, $kgNLQ.OPTIMISTIC_SAVE_COMMENT_ID);
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(pageInfo?.id ?? "", true);
    let t3;
    if ($[0] !== pageMode || $[1] !== threadKey) {
        t3 = {
            threadKey: threadKey,
            setIsThreadHovered: setIsThreadHovered,
            setHoveredCommentId: setHoveredCommentId,
            pageMode: pageMode
        };
        $[0] = pageMode;
        $[1] = threadKey;
        $[2] = t3;
    } else t3 = $[2];
    const handleCommentThreadHoverProps = t3;
    let t4;
    if ($[3] !== handleCommentThreadHoverProps) {
        t4 = (id)=>{
            (0, $cZRYC.handleCommentThreadMouseEnter)({
                ...handleCommentThreadHoverProps,
                id: id
            });
        };
        $[3] = handleCommentThreadHoverProps;
        $[4] = t4;
    } else t4 = $[4];
    const handleMouseEnter = t4;
    let t5;
    if ($[5] !== handleCommentThreadHoverProps) {
        t5 = ()=>{
            (0, $cZRYC.handleCommentThreadMouseLeave)(handleCommentThreadHoverProps);
        };
        $[5] = handleCommentThreadHoverProps;
        $[6] = t5;
    } else t5 = $[6];
    const handleMouseLeave = t5;
    let t6;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (event)=>{
            event.stopPropagation();
            setCommentIsFocused(true);
        };
        $[7] = t6;
    } else t6 = $[7];
    const handleFocus = t6;
    let t7;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (event_0)=>{
            if (!event_0.relatedTarget || !event_0.currentTarget.contains(event_0.relatedTarget)) setCommentIsFocused(false);
        };
        $[8] = t7;
    } else t7 = $[8];
    const handleBlur = t7;
    let t8;
    if ($[9] !== isCurrentSelectedComment || $[10] !== setCurrentlySelectedThreadKey || $[11] !== threadKey) {
        t8 = ()=>{
            if (!isCurrentSelectedComment) {
                if (!(0, $6mKj3.expValEquals)("cc_comments_common_refactor", "isEnabled", true)) setIsThreadPressed(true);
                setCurrentlySelectedThreadKey(threadKey);
            }
        };
        $[9] = isCurrentSelectedComment;
        $[10] = setCurrentlySelectedThreadKey;
        $[11] = threadKey;
        $[12] = t8;
    } else t8 = $[12];
    const handleCommentThreadMouseDown = t8;
    let t9;
    if ($[13] !== currentlySelectedThreadKey || $[14] !== isCurrentSelectedComment || $[15] !== parentComment.replies) {
        t9 = ()=>{
            if (!(0, $6mKj3.expValEquals)("cc_comments_common_refactor", "isEnabled", true)) {
                const parentIdOfSelectedReply = parentComment?.replies?.find((reply)=>reply.id === currentlySelectedThreadKey);
                if (isCurrentSelectedComment || parentIdOfSelectedReply) setIsThreadPressed(true);
                else setIsThreadPressed(false);
            }
        };
        $[13] = currentlySelectedThreadKey;
        $[14] = isCurrentSelectedComment;
        $[15] = parentComment.replies;
        $[16] = t9;
    } else t9 = $[16];
    const t10 = parentComment?.replies;
    let t11;
    if ($[17] !== currentlySelectedThreadKey || $[18] !== isCurrentSelectedComment || $[19] !== t10) {
        t11 = [
            currentlySelectedThreadKey,
            isCurrentSelectedComment,
            t10
        ];
        $[17] = currentlySelectedThreadKey;
        $[18] = isCurrentSelectedComment;
        $[19] = t10;
        $[20] = t11;
    } else t11 = $[20];
    (0, $42omo.useEffect)(t9, t11);
    let t12;
    let t13;
    if ($[21] !== isLastThread || $[22] !== onLastThreadRendered) {
        t12 = ()=>{
            if (isLastThread && onLastThreadRendered) {
                if (typeof isLastThread === "boolean") onLastThreadRendered();
            }
        };
        t13 = [
            isLastThread,
            onLastThreadRendered
        ];
        $[21] = isLastThread;
        $[22] = onLastThreadRendered;
        $[23] = t12;
        $[24] = t13;
    } else {
        t12 = $[23];
        t13 = $[24];
    }
    (0, $42omo.useEffect)(t12, t13);
    let t14;
    if ($[25] !== isCommentsPanelShown || $[26] !== setCurrentlySelectedThreadKey || $[27] !== threadKey) {
        t14 = ()=>{
            setCurrentlySelectedThreadKey(threadKey);
            if (isCommentsPanelShown) (0, $9FoVw.handleCommentsPanelNavigation)({
                annotationId: threadKey,
                commentType: "FOOTER",
                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                block: "center",
                context: (0, $9FoVw.NavigationContext).PANEL
            });
        };
        $[25] = isCommentsPanelShown;
        $[26] = setCurrentlySelectedThreadKey;
        $[27] = threadKey;
        $[28] = t14;
    } else t14 = $[28];
    const objectCommentThreadHandler = t14;
    let t15;
    if ($[29] !== flags || $[30] !== isOffline || $[31] !== supportedTopLevelActions) {
        t15 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $972174ea64671f70$export$f8aa7c43d6421d1d), {
                ...props,
                supportedTopLevelActions: supportedTopLevelActions,
                flags: flags,
                isOffline: isOffline
            });
        $[29] = flags;
        $[30] = isOffline;
        $[31] = supportedTopLevelActions;
        $[32] = t15;
    } else t15 = $[32];
    const commentComponent = t15;
    let t16;
    if ($[33] !== flags || $[34] !== isOffline) {
        t16 = (props_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b210b13432f2522a$export$55de1ed49e182c87), {
                ...props_0,
                isOffline: isOffline,
                flags: flags
            });
        $[33] = flags;
        $[34] = isOffline;
        $[35] = t16;
    } else t16 = $[35];
    const commentRepliesComponent = t16;
    let t17;
    if ($[36] !== canAddComments || $[37] !== commentComponent || $[38] !== commentIsFocused || $[39] !== commentRepliesComponent || $[40] !== flags || $[41] !== formatMessage || $[42] !== handleCommentThreadMouseDown || $[43] !== handleMouseEnter || $[44] !== handleMouseLeave || $[45] !== hoveredCommentId || $[46] !== isCurrentSelectedComment || $[47] !== isEditorExpanded || $[48] !== isOffline || $[49] !== isThreadHovered || $[50] !== isThreadPressed || $[51] !== objectCommentThreadHandler || $[52] !== pageInfo || $[53] !== pageMode || $[54] !== parentComment || $[55] !== shouldRenderCommentTypeSeparator || $[56] !== supportedTopLevelActions || $[57] !== threadKey || $[58] !== unreadCommentIDSet) {
        t17 = (0, $6mKj3.expValEquals)("cc_comments_common_refactor", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i8TeS.BaseCommentThread), {
            commentThreadRef: commentRef,
            commentComponent: commentComponent,
            commentRepliesComponent: commentRepliesComponent,
            parentComment: parentComment,
            pageMode: pageMode,
            shouldRenderCommentTypeSeparator: shouldRenderCommentTypeSeparator,
            canAddComments: canAddComments,
            handleCommentThreadClick: objectCommentThreadHandler,
            handleCommentThreadMouseDown: handleCommentThreadMouseDown,
            testIdPrefix: (0, $i6UMJ.LocationValue).FOOTER,
            isEditorExpanded: isEditorExpanded
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, shouldRenderCommentTypeSeparator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            xcss: $e368ed9f3d927a75$var$commentTypeSeperatorStyle,
            as: "li",
            testId: "comment-section-separator",
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
            testId: "general-comment-page-icon",
            color: "var(--ds-icon-subtlest, #6B6E76)",
            label: formatMessage($e368ed9f3d927a75$var$i18n.commentTypeSeperatorText)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            color: "color.text.subtlest",
            weight: "medium"
        }, formatMessage($e368ed9f3d927a75$var$i18n.commentTypeSeperatorText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            ref: commentRef,
            id: `${(0, $i6UMJ.LocationValue).FOOTER}-comment-thread-${threadKey}-container`,
            testId: `${(0, $i6UMJ.LocationValue).FOOTER}-comment-thread-${threadKey}-container`,
            xcss: [
                $e368ed9f3d927a75$var$commentThreadBoxStyles,
                isCurrentSelectedComment && $e368ed9f3d927a75$var$isCurrentUserSelectedCommentStyles,
                !isCurrentSelectedComment && isThreadPressed && $e368ed9f3d927a75$var$isThreadPressedStyles,
                $e368ed9f3d927a75$var$newCommentThreadBoxStyles
            ],
            onClick: objectCommentThreadHandler,
            onMouseDown: handleCommentThreadMouseDown,
            onMouseUp: ()=>setIsThreadPressed(false),
            onFocus: (0, $6mKj3.expValEquals)("confluence_frontend_fix_comment_actions_visibility", "isEnabled", true) ? undefined : handleFocus,
            onBlur: (0, $6mKj3.expValEquals)("confluence_frontend_fix_comment_actions_visibility", "isEnabled", true) ? undefined : handleBlur,
            tabIndex: 0,
            "aria-label": formatMessage($e368ed9f3d927a75$var$i18n.threadContentAriaLabelWithName, {
                name: parentComment.author?.displayName || formatMessage((0, $3ejfs.commentsi18n).anonymous)
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            testId: `${(0, $i6UMJ.LocationValue).FOOTER}-comment-thread-${parentComment.id}-parent`,
            xcss: $e368ed9f3d927a75$var$commentBodyBoxStyles,
            onMouseEnter: (0, $6mKj3.expValEquals)("confluence_frontend_fix_comment_actions_visibility", "isEnabled", true) ? undefined : ()=>handleMouseEnter(parentComment.id),
            onMouseLeave: (0, $6mKj3.expValEquals)("confluence_frontend_fix_comment_actions_visibility", "isEnabled", true) ? undefined : handleMouseLeave
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $972174ea64671f70$export$f8aa7c43d6421d1d), {
            comment: parentComment,
            supportedTopLevelActions: supportedTopLevelActions,
            pageInfo: pageInfo,
            pageMode: pageMode,
            isUnread: unreadCommentIDSet.has(parentComment.id),
            isHovered: hoveredCommentId === parentComment.id || commentIsFocused,
            threadKey: threadKey,
            flags: flags,
            hideBranchingStyle: (0, $6mKj3.expValEquals)("confluence_comments_tuneup", "isEnabled", true) ? parentComment.replies.length === 0 && !isEditorExpanded : (!parentComment.isOpen || !canAddComments) && parentComment.replies.length === 0,
            canAddComments: canAddComments,
            isThreadHovered: isThreadHovered,
            isOffline: isOffline
        })), (0, $ibqdE.getShouldShowRepliesSection)({
            replies: parentComment.replies,
            isEditorExpanded: isEditorExpanded
        }) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b210b13432f2522a$export$55de1ed49e182c87), {
            parentComment: parentComment,
            pageInfo: pageInfo,
            hoveredCommentId: hoveredCommentId ?? "",
            pageMode: pageMode,
            parentCommentId: parentComment.id,
            handleMouseEnter: (0, $6mKj3.expValEquals)("confluence_frontend_fix_comment_actions_visibility", "isEnabled", true) ? $e368ed9f3d927a75$var$noop : handleMouseEnter,
            handleMouseLeave: (0, $6mKj3.expValEquals)("confluence_frontend_fix_comment_actions_visibility", "isEnabled", true) ? $e368ed9f3d927a75$var$noop : handleMouseLeave,
            canAddComments: canAddComments,
            isOffline: isOffline,
            flags: flags,
            isEditorExpanded: isEditorExpanded
        })));
        $[36] = canAddComments;
        $[37] = commentComponent;
        $[38] = commentIsFocused;
        $[39] = commentRepliesComponent;
        $[40] = flags;
        $[41] = formatMessage;
        $[42] = handleCommentThreadMouseDown;
        $[43] = handleMouseEnter;
        $[44] = handleMouseLeave;
        $[45] = hoveredCommentId;
        $[46] = isCurrentSelectedComment;
        $[47] = isEditorExpanded;
        $[48] = isOffline;
        $[49] = isThreadHovered;
        $[50] = isThreadPressed;
        $[51] = objectCommentThreadHandler;
        $[52] = pageInfo;
        $[53] = pageMode;
        $[54] = parentComment;
        $[55] = shouldRenderCommentTypeSeparator;
        $[56] = supportedTopLevelActions;
        $[57] = threadKey;
        $[58] = unreadCommentIDSet;
        $[59] = t17;
    } else t17 = $[59];
    return t17;
};


const $fd40026d890a9ac0$var$listStyles = null; // this component holds a list of comments
const $fd40026d890a9ac0$export$b05be82c52775010 = (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { commentThreads: commentThreads, supportedTopLevelActions: supportedTopLevelActions, flags: flags, onAllCommentsRendered: onAllCommentsRendered, onCommentBatchRendered: onCommentBatchRendered, isOffline: isOffline } = t0;
    let t1;
    if ($[0] !== commentThreads) {
        t1 = (index)=>index === commentThreads.length - 1;
        $[0] = commentThreads;
        $[1] = t1;
    } else t1 = $[1];
    const isLastThread = t1;
    let t2;
    if ($[2] !== flags || $[3] !== isLastThread || $[4] !== isOffline || $[5] !== onAllCommentsRendered || $[6] !== onCommentBatchRendered || $[7] !== supportedTopLevelActions) {
        t2 = {
            supportedTopLevelActions: supportedTopLevelActions,
            flags: flags,
            onLastThreadRendered: onAllCommentsRendered,
            onCommentBatchRendered: onCommentBatchRendered,
            isLastThread: isLastThread,
            isOffline: isOffline
        };
        $[2] = flags;
        $[3] = isLastThread;
        $[4] = isOffline;
        $[5] = onAllCommentsRendered;
        $[6] = onCommentBatchRendered;
        $[7] = supportedTopLevelActions;
        $[8] = t2;
    } else t2 = $[8];
    const passThroughProps = t2;
    let t3;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $gMc0m.default)([
            "_18m9ewfl _1reoewfl _16jlkb7n _1e0c1ule"
        ]);
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== commentThreads || $[11] !== passThroughProps) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            id: "object-comments-list-container",
            "data-testid": "object-comments-list-container",
            className: t3
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3cu4A.CommentBatchList), {
            commentsList: commentThreads,
            passThroughProps: passThroughProps,
            Component: (0, $e368ed9f3d927a75$export$2ea19076574587a9),
            getElementsToBatch: (0, $7qvmT.getCommentThreadsToBatch)
        }));
        $[10] = commentThreads;
        $[11] = passThroughProps;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
};

















var $cO1el = parcelRequire("cO1el");


const $f06f6da515cf7544$var$commentHeaderContainerStyles = (0, $ecnYn.xcss)({
    borderTop: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    background: 'color.text.inverse',
    height: '64px',
    width: '100%',
    display: 'flex',
    padding: 'space.200',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch'
});
const $f06f6da515cf7544$var$commentHeaderReactionsContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    alignSelf: 'stretch'
});
const $f06f6da515cf7544$var$i18n = (0, $aXWIB.defineMessages)({
    objectCommentHeaderText: {
        id: "object-comments.object-comment-header.text",
        defaultMessage: "Comments"
    }
});
const $f06f6da515cf7544$var$styles = {
    headerMessageStyle: "_11c81af2 _syazazsu _ect41oil _k48p1wq8"
};
const $f06f6da515cf7544$export$32c2c28e641d3a4f = (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { isOffline: t1, showReactions: showReactions } = t0;
    const isOffline = t1 === undefined ? false : t1;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t2;
    if ($[0] !== formatMessage) {
        t2 = formatMessage($f06f6da515cf7544$var$i18n.objectCommentHeaderText);
        $[0] = formatMessage;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            size: "medium",
            as: "h2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $f06f6da515cf7544$var$styles.headerMessageStyle
        }, t2));
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== isOffline || $[5] !== showReactions) {
        t4 = showReactions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $f06f6da515cf7544$var$commentHeaderReactionsContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2c779d914e38fe28$export$3b5f3f6ec721f20a), {
            isOffline: isOffline
        }));
        $[4] = isOffline;
        $[5] = showReactions;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== t3 || $[8] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $f06f6da515cf7544$var$commentHeaderContainerStyles
        }, t3, t4);
        $[7] = t3;
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
};





/**
 * @generated SignedSource<<12d32d4e19d8eeae009a5a5a6fc3dd66>>
 * @relayHash 14ad450aadc2eaa7e5c6f5015481bf9f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ed95e9a1bb77ef5ebd80639582429151b8f7f026f79d262a10ca1ac4bba1df6d
const $c93e7e4530bd519f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v3 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "createFooterComment",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "profilePicture",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "accountId"
                                }
                            ],
                            "type": "KnownUser"
                        }
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "representation",
                            "value": "ATLAS_DOC_FORMAT"
                        }
                    ],
                    "concreteType": "DocumentBody",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": v3 /*: any*/ ,
                    "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
                },
                {
                    "kind": "ScalarField",
                    "name": "contentStatus"
                },
                {
                    "concreteType": "ConfluenceDate",
                    "kind": "LinkedField",
                    "name": "createdAt",
                    "plural": false,
                    "selections": v3 /*: any*/ 
                },
                {
                    "kind": "ScalarField",
                    "name": "createdAtNonLocalized"
                },
                {
                    "concreteType": "Map_LinkType_String",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "webui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "editui"
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "name": "location",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "InlineCommentResolveProperties",
                                    "kind": "LinkedField",
                                    "name": "commentResolveProperties",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "resolvedTime"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "resolvedFriendlyDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "resolvedUser"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "resolved"
                                        }
                                    ]
                                }
                            ],
                            "type": "FooterComment"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "parentId"
                },
                {
                    "concreteType": "CommentPermissions",
                    "kind": "LinkedField",
                    "name": "permissions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEditable"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isRemovable"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isResolvable"
                        }
                    ]
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "by",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "when"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ObjectAddCommentEditorCreateGeneralCommentMutation",
            "selections": v4 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ObjectAddCommentEditorCreateGeneralCommentMutation",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "14ad450aadc2eaa7e5c6f5015481bf9f",
            "id": "ed95e9a1bb77ef5ebd80639582429151b8f7f026f79d262a10ca1ac4bba1df6d",
            "metadata": {},
            "name": "ObjectAddCommentEditorCreateGeneralCommentMutation",
            "operationKind": "mutation",
            "text": "mutation ObjectAddCommentEditorCreateGeneralCommentMutation($cloudId:ID!,$input:CreateCommentInput!){createFooterComment(cloudId:$cloudId,input:$input){id,author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on FooterComment{commentResolveProperties{resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number}}}"
        }
    };
}();
$c93e7e4530bd519f$var$node.hash = "e80b97780580b82dc806e5ea8dc09bff";
var $c93e7e4530bd519f$export$2e2bcd8739ae039 = $c93e7e4530bd519f$var$node;












var $aGjYc = parcelRequire("aGjYc");


var $b4BfG = parcelRequire("b4BfG");








var $aJPUt = parcelRequire("aJPUt");


var $kKAQX = parcelRequire("kKAQX");

















var $56QzY = parcelRequire("56QzY");














































const $2f75a8a3cc0f80c1$var$ObjectAddCommentEditorCreateGeneralCommentMutation = (0, $c93e7e4530bd519f$export$2e2bcd8739ae039);
const $2f75a8a3cc0f80c1$export$b65ed37f0eb1c56b = (t0)=>{
    const $ = (0, $frIzR.c)(58);
    const { isOffline: isOffline, setAutoFocusPromptRef: setAutoFocusPromptRef, handleCancel: handleCancel } = t0;
    const { isReactionsEnabled: isReactionsEnabled } = (0, $42omo.useContext)((0, $8SCD6.ReactionsContext));
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { closeCommentContainer: closeCommentContainer } = (0, $fNzRA.useObjectCommentDispatchContext)();
    const { footerEditorEntry: footerEditorEntry } = (0, $fNzRA.useObjectCommentContext)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [t1] = (0, $hl1Kw.useSearchSessionId)();
    const { searchSessionId: searchSessionId } = t1;
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setAddFooterCommentAdf: setAddFooterCommentAdf } = (0, $3mVfX.useCommentsPanelActions)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { onChange: onChange, resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { addNewCommentThreads: addNewCommentThreads } = (0, $8i27m.useCommentsDataActions)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const { cloudId: cloudId, userId: userId, displayName: displayName } = (0, $bQm3c.useSessionData)();
    const editorActionsRef = (0, $42omo.useRef)(null);
    let t2;
    let t3;
    if ($[0] !== footerEditorEntry) {
        t2 = ()=>{
            if (footerEditorEntry === (0, $3mVfX.AddFooterCommentMode).STICKY_DRAFT && editorActionsRef.current?.focus) editorActionsRef.current.focus();
        };
        t3 = [
            footerEditorEntry
        ];
        $[0] = footerEditorEntry;
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $6tkbf.buildMutationContextForNoNetworkError)();
        $[3] = t4;
    } else t4 = $[3];
    const [createGeneralCommentFn] = (0, $308Wd.useMutationInterop)($2f75a8a3cc0f80c1$var$ObjectAddCommentEditorCreateGeneralCommentMutation, {
        ...t4,
        __callerPackage__: "@confluence/object-comments"
    });
    const t5 = contentId || "";
    let t6;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = {
            skip: true
        };
        $[4] = t6;
    } else t6 = $[4];
    let t7;
    if ($[5] !== t5) {
        t7 = {
            contentId: t5,
            options: t6
        };
        $[5] = t5;
        $[6] = t7;
    } else t7 = $[6];
    const { addCommentInCache: addCommentInCache } = (0, $NYiei.useAllCommentsData)(t7);
    const createObjectCommentMutationFn = (0, $ag51I.useCreateObjectCommentMutation)();
    let t8;
    if ($[7] !== setAddFooterCommentAdf) {
        t8 = ()=>{
            setAddFooterCommentAdf(undefined);
        };
        $[7] = setAddFooterCommentAdf;
        $[8] = t8;
    } else t8 = $[8];
    const clearAddFooterCommentAdf = t8;
    let t9;
    if ($[9] !== experienceTracker) {
        t9 = (error)=>{
            experienceTracker.stopOnError({
                name: (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE),
                error: error
            });
        };
        $[9] = experienceTracker;
        $[10] = t9;
    } else t9 = $[10];
    const failPublishExperience = t9;
    let t10;
    if ($[11] !== addCommentInCache || $[12] !== failPublishExperience) {
        t10 = (_dataProxy, mutationResult)=>{
            addCommentInCache({
                newComment: (0, $ag51I.addEmptyObjectRepliesAndReactions)(mutationResult.data.createFooterComment),
                onError: failPublishExperience
            });
        };
        $[11] = addCommentInCache;
        $[12] = failPublishExperience;
        $[13] = t10;
    } else t10 = $[13];
    const updateNewCommentInCache = t10;
    let t11;
    if ($[14] !== addNewCommentThreads || $[15] !== clearAddFooterCommentAdf || $[16] !== closeCommentContainer || $[17] !== cloudId || $[18] !== contentId || $[19] !== contentType || $[20] !== createAnalyticsEvent || $[21] !== createGeneralCommentFn || $[22] !== createObjectCommentMutationFn || $[23] !== displayName || $[24] !== experienceTracker || $[25] !== failPublishExperience || $[26] !== footerEditorEntry || $[27] !== isReactionsEnabled || $[28] !== pageMode || $[29] !== resetContentChanged || $[30] !== searchSessionId || $[31] !== setCurrentlySelectedThreadKey || $[32] !== updateNewCommentInCache || $[33] !== userId) {
        t11 = (adfObject, onSuccess)=>{
            const pageId = contentId || "";
            const { adf: adf } = adfObject;
            (0, $8Ss4E.startEditorSubExperience)({
                name: (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).EDITOR_PUBLISH
            });
            const mutationVariables = {
                cloudId: cloudId,
                input: {
                    commentBody: {
                        value: JSON.stringify(adf),
                        representationFormat: (0, $kKAQX.ContentRepresentation).ATLAS_DOC_FORMAT
                    },
                    commentSource: (0, $kKAQX.Platform).WEB,
                    containerId: pageId
                }
            };
            const isOptimisticAddEnabled = (0, $aGjYc.shouldUseCommentDraftForOptimisticSave)("page", "create");
            const optimisticResponse = isOptimisticAddEnabled ? (0, $ag51I.getOptimisticResponse)({
                userId: userId ?? "",
                displayName: displayName ?? "",
                adf: adf,
                pageId: pageId,
                parentCommentId: null
            }) : undefined;
            const optimisticCommentId = optimisticResponse?.createFooterComment?.id;
            if (isOptimisticAddEnabled) {
                onSuccess && onSuccess();
                clearAddFooterCommentAdf();
                closeCommentContainer();
                optimisticCommentId && setCurrentlySelectedThreadKey(optimisticCommentId, (0, $8i27m.CommentType).GENERAL);
                optimisticCommentId && (0, $9FoVw.handleFooterCommentsNavigation)({
                    scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                    block: "center",
                    inline: "center",
                    commentId: optimisticCommentId
                });
            }
            const mutationPromise = (0, $6mKj3.expVal)("cc_comments_new_comments_data_manager", "isEnabled", false) ? createObjectCommentMutationFn({
                variables: {
                    ...mutationVariables,
                    pageId: pageId,
                    includeReactionsSummary: !(0, $6mKj3.expValEquals)("confluence_fe_use_create_comment_exclude_reactions", "isEnabled", true)
                },
                update: updateNewCommentInCache,
                optimisticResponse: optimisticResponse
            }) : createGeneralCommentFn({
                variables: mutationVariables,
                update: (0, $87CZC.updateApolloCacheParentCallback)("create", {
                    pageId: pageId,
                    contentStatus: [
                        "DRAFT",
                        "CURRENT"
                    ],
                    type: [
                        "FOOTER"
                    ]
                }, isReactionsEnabled)
            });
            return mutationPromise.then((t12)=>{
                const { data: data } = t12;
                const commentResult = data.createFooterComment;
                const comment = {
                    ...commentResult,
                    replies: [],
                    isOpen: true,
                    type: (0, $8i27m.CommentType).GENERAL
                };
                if (!(0, $6mKj3.expVal)("cc_comments_new_comments_data_manager", "isEnabled", false)) addNewCommentThreads({
                    inline: {},
                    general: {
                        [comment.id]: comment
                    }
                });
                if (!isOptimisticAddEnabled) {
                    onSuccess && onSuccess();
                    clearAddFooterCommentAdf();
                    closeCommentContainer();
                }
                resetContentChanged();
                createAnalyticsEvent({
                    type: "sendTrackEvent",
                    data: {
                        action: "created",
                        actionSubject: "comment",
                        actionSubjectId: comment.id,
                        objectType: contentType,
                        objectId: contentId,
                        source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                        attributes: {
                            commentType: (0, $en1dX.CommentType).PAGE,
                            source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                            pageMode: pageMode,
                            isReply: false,
                            pageType: contentType,
                            isLivePage: pageMode === (0, $cD1qu.PageMode).LIVE,
                            editor: "v2",
                            searchSessionId: searchSessionId,
                            navdexPointType: (0, $56QzY.END),
                            parentCommentId: null,
                            isStickyFooter: footerEditorEntry === (0, $3mVfX.AddFooterCommentMode).STICKY_DRAFT
                        }
                    }
                }).fire();
                experienceTracker.succeed({
                    name: (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE)
                });
                if (!isOptimisticAddEnabled) {
                    setCurrentlySelectedThreadKey(comment.id, (0, $8i27m.CommentType).GENERAL);
                    (0, $9FoVw.handleFooterCommentsNavigation)({
                        scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                        block: "center",
                        inline: "center",
                        commentId: comment.id
                    });
                } else setCurrentlySelectedThreadKey(comment.id, (0, $8i27m.CommentType).GENERAL, true);
                return {
                    id: comment.id
                };
            }).catch((error_0)=>{
                const translatedError = (0, $lFkRf.getTranslatedError)(error_0);
                if ((0, $9wGTI.fg)("confluence_fe_add_page_comment_exp_coverage")) {
                    const isAbortableError = (0, $lFkRf.isCommentAbortableError)(translatedError, (0, $9wGTI.fg)("confluence_comments_abort_on_container_not_found"));
                    if (isAbortableError) {
                        experienceTracker.abort({
                            name: (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE),
                            reason: translatedError.id
                        });
                        experienceTracker.abort({
                            name: (0, $irVI7.ADD_PAGE_COMMENT_EXPERIENCE),
                            reason: translatedError.id
                        });
                    } else failPublishExperience(error_0);
                }
                if ((0, $9wGTI.fg)("confluence_comments_error_handling_improvements")) return Promise.reject({
                    error: translatedError
                });
            });
        };
        $[14] = addNewCommentThreads;
        $[15] = clearAddFooterCommentAdf;
        $[16] = closeCommentContainer;
        $[17] = cloudId;
        $[18] = contentId;
        $[19] = contentType;
        $[20] = createAnalyticsEvent;
        $[21] = createGeneralCommentFn;
        $[22] = createObjectCommentMutationFn;
        $[23] = displayName;
        $[24] = experienceTracker;
        $[25] = failPublishExperience;
        $[26] = footerEditorEntry;
        $[27] = isReactionsEnabled;
        $[28] = pageMode;
        $[29] = resetContentChanged;
        $[30] = searchSessionId;
        $[31] = setCurrentlySelectedThreadKey;
        $[32] = updateNewCommentInCache;
        $[33] = userId;
        $[34] = t11;
    } else t11 = $[34];
    const handleCommentsPanelSave = t11;
    let t12;
    if ($[35] !== clearAddFooterCommentAdf || $[36] !== closeCommentContainer || $[37] !== experienceTracker || $[38] !== handleCancel || $[39] !== hasContentChanged || $[40] !== resetContentChanged || $[41] !== setAutoFocusPromptRef) {
        t12 = (t13)=>{
            const { isEditorAborted: isEditorAborted } = t13;
            const doCancel = ()=>{
                if (isEditorAborted) {
                    setAutoFocusPromptRef?.(true);
                    experienceTracker.abort({
                        name: (0, $irVI7.ADD_PAGE_COMMENT_EXPERIENCE),
                        reason: "aborted because comment was cancelled"
                    });
                }
                clearAddFooterCommentAdf();
                closeCommentContainer();
                handleCancel?.();
            };
            if (hasContentChanged) resetContentChanged();
            doCancel();
        };
        $[35] = clearAddFooterCommentAdf;
        $[36] = closeCommentContainer;
        $[37] = experienceTracker;
        $[38] = handleCancel;
        $[39] = hasContentChanged;
        $[40] = resetContentChanged;
        $[41] = setAutoFocusPromptRef;
        $[42] = t12;
    } else t12 = $[42];
    const handleCancelInternal = t12;
    let t13;
    if ($[43] !== experienceTracker) {
        t13 = ()=>{
            experienceTracker.succeed({
                name: (0, $irVI7.ADD_PAGE_COMMENT_LOAD_EXPERIENCE)
            });
            const footerCommentContainer = document.querySelector("[data-testId=\"footerCommentEditor\"]");
            if (!footerCommentContainer) return;
            footerCommentContainer.scrollIntoView({
                behavior: "smooth",
                block: "end",
                inline: "nearest"
            });
        };
        $[43] = experienceTracker;
        $[44] = t13;
    } else t13 = $[44];
    const handleOnEditorLoaded = t13;
    let t14;
    if ($[45] !== footerEditorEntry || $[46] !== handleOnEditorLoaded) {
        t14 = (editorActions)=>{
            handleOnEditorLoaded();
            editorActionsRef.current = editorActions;
            if (footerEditorEntry === (0, $3mVfX.AddFooterCommentMode).STICKY_DRAFT && editorActions?.focus) editorActions.focus();
        };
        $[45] = footerEditorEntry;
        $[46] = handleOnEditorLoaded;
        $[47] = t14;
    } else t14 = $[47];
    const handleEditorReady = t14;
    let t15;
    if ($[48] !== onChange || $[49] !== setAddFooterCommentAdf) {
        t15 = (hasContent, content)=>{
            if (hasContent && content) setAddFooterCommentAdf(content);
            else setAddFooterCommentAdf(undefined);
            onChange(hasContent);
        };
        $[48] = onChange;
        $[49] = setAddFooterCommentAdf;
        $[50] = t15;
    } else t15 = $[50];
    const handleEditorContentChangedWithData = t15;
    let t16;
    if ($[51] !== handleCancelInternal || $[52] !== handleCommentsPanelSave || $[53] !== handleEditorContentChangedWithData || $[54] !== handleEditorReady || $[55] !== handleOnEditorLoaded || $[56] !== isOffline) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b4BfG.PageCommentEditor), {
            mode: "create",
            saveHandler: handleCommentsPanelSave,
            cancelHandler: handleCancelInternal,
            onEditorLoaded: handleOnEditorLoaded,
            onEditorReady: handleEditorReady,
            onEditorContentChangedWithData: handleEditorContentChangedWithData,
            useNewExperienceAbort: true,
            expandEditor: true,
            isFooterComment: true,
            isOffline: isOffline
        });
        $[51] = handleCancelInternal;
        $[52] = handleCommentsPanelSave;
        $[53] = handleEditorContentChangedWithData;
        $[54] = handleEditorReady;
        $[55] = handleOnEditorLoaded;
        $[56] = isOffline;
        $[57] = t16;
    } else t16 = $[57];
    return t16;
};



var $dL5YQ = parcelRequire("dL5YQ");


var $MJaSd = parcelRequire("MJaSd");

// GraphQL query for preloading first 3 footer comments
// NOTE: If you update the return type of this query, you need to update the type
// definition in any others as well, until our tooling supports fragments and then we move to a
// more fragmented-based approach.  Note there are also comment queries or fragments in the
// following files that need to be kept in sync as well:
// - next/packages/comments-data-manager/src/useAllCommentsData.ts
// - next/packages/comments-data/src/hooks/useCommentById.ts
// - next/packages/comments-data-manager/src/updateCommentInCache.ts
// - next/packages/comments-data-manager/src/useCreateObjectCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineCommentMutation.ts
const $0606d9a810dabf91$var$ObjectCommentContainerPreloadObjectCommentsQuery = (0, $1ydBT.default);
const $0606d9a810dabf91$var$commentPanelContainerStyles = (0, $ecnYn.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    height: '100%',
    width: '100%'
});
const $0606d9a810dabf91$var$wrapperStyle = (0, $ecnYn.xcss)({
    position: 'relative',
    visibility: 'visible',
    minHeight: '50px',
    margin: '0 auto'
});
const $0606d9a810dabf91$var$baseEditorStyles = (0, $ecnYn.xcss)({
    zIndex: 'modal',
    backgroundColor: 'elevation.surface',
    borderTopWidth: 'border.width',
    borderTopStyle: 'solid',
    borderColor: 'color.border',
    padding: 'space.200',
    position: 'relative'
});
const $0606d9a810dabf91$var$footerStickyWrapperStyle = (0, $ecnYn.xcss)({
    zIndex: 'navigation',
    backgroundColor: 'elevation.surface',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    bottom: 'space.0'
});
const $0606d9a810dabf91$var$viewPageFooterStyle = (0, $ecnYn.xcss)({
    zIndex: '1',
    transform: 'unset',
    bottom: 'space.0'
});
const $0606d9a810dabf91$var$footerEditorStyle = (0, $ecnYn.xcss)({
    left: 'space.0'
});
const $0606d9a810dabf91$var$fixedEditorStyles = (0, $ecnYn.xcss)({
    position: 'fixed'
});
const $0606d9a810dabf91$var$stickyEditorStyles = (0, $ecnYn.xcss)({
    position: 'sticky'
});
const $0606d9a810dabf91$var$placeholderStyle = (0, $ecnYn.xcss)({
    width: '60%'
});
const $0606d9a810dabf91$var$incrementalLoadingPlaceholderStyle = (0, $ecnYn.xcss)({
    width: '60%'
});
const $0606d9a810dabf91$var$addCommentContainerStyles = (0, $ecnYn.xcss)({
    transition: 'transform 0.3s ease-out, opacity 0.3s ease-out',
    transformOrigin: 'top',
    position: 'sticky',
    bottom: 'space.0',
    zIndex: '1' // Required for create comment editor overflow to show on top of page content
});
const $0606d9a810dabf91$var$addCommentContainerAnimationHiddenStyles = (0, $ecnYn.xcss)({
    transform: 'translateY(100%)',
    opacity: 0,
    pointerEvents: 'none'
});
const $0606d9a810dabf91$var$addCommentContainerAnimationShowStyles = (0, $ecnYn.xcss)({
    transform: 'translateY(0)',
    opacity: 1,
    pointerEvents: 'auto'
});
const $0606d9a810dabf91$var$useFocusedCommentIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('focusedCommentId');
const $0606d9a810dabf91$var$useReplyToCommentQueryParam = (0, $dPJCf.createSingleQueryParamHook)('replyToComment');
const $0606d9a810dabf91$var$ObjectCommentContainerComponent = (0, $7aRa9.withFlags)(({ flags: flags, pageWidthType: pageWidthType, showLabels: showLabels, hasReactions: hasReactions, editorIsUserOffline: editorIsUserOffline })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const wrapperRef = (0, $42omo.useRef)(null);
    const [commentSectionTop, setCommentSectionTop] = (0, $42omo.useState)(0);
    const [isInViewport, setIsInViewport] = (0, $42omo.useState)(false);
    const [allCommentsRendered, setAllCommentsRendered] = (0, $42omo.useState)(false);
    const [commentBatchRendered, setCommentBatchRendered] = (0, $42omo.useState)(false);
    const [commentBatchCount, setCommentBatchCount] = (0, $42omo.useState)(0);
    const [forceLoadComments, setForceLoadComments] = (0, $42omo.useState)(false);
    const [shouldShowAddComment, setShouldShowAddComment] = (0, $42omo.useState)(true);
    const [state] = (0, $isEtk.useContentState)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const isServer = (0, $e4o8D.useRenderServerPlaceholder)();
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    const { expanded: expanded, width: width, footerEditorEntry: footerEditorEntry } = (0, $fNzRA.useObjectCommentContext)();
    const { closeCommentContainer: closeCommentContainer } = (0, $fNzRA.useObjectCommentDispatchContext)();
    // Hide OmniBar when the footer comment component is open (e.g. Comment button clicked)
    const { requestHideOmniBar: requestHideOmniBar, releaseHideOmniBar: releaseHideOmniBar } = (0, $b0EGa.useOmniBarVisibilityActions)();
    (0, $42omo.useLayoutEffect)(()=>{
        if (expanded) {
            requestHideOmniBar();
            return ()=>releaseHideOmniBar();
        }
    }, [
        expanded,
        requestHideOmniBar,
        releaseHideOmniBar
    ]);
    // Track page-content-only dimensions for layout alignment and blue background sizing
    const { width: pageContentWidth, left: pageContentLeft, right: pageContentRight } = (0, $aOKRX.usePageContentDimensions)();
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, commentsDataMap: legacyCommentsDataMap, removedThreadsMap: removedThreadsMap, footerCommentsLoadingState: footerCommentsLoadingState } = (0, $8i27m.useCommentsDataState)();
    const contentStatusFilters = (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode);
    // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    // Read preload data from cache synchronously
    // Query for all content statuses, filtering happens after the fact
    let preloadCacheData = null;
    if (contentId && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) try {
        preloadCacheData = (0, $l1uFv.readQueryInterop)({
            query: $0606d9a810dabf91$var$ObjectCommentContainerPreloadObjectCommentsQuery,
            variables: (0, $MJaSd.buildPreloadObjectCommentsQueryVariables)(contentId),
            __callerPackage__: "@confluence/object-comments"
        });
    } catch  {
        // Query not in cache yet, that's fine
        preloadCacheData = null;
    }
    const preloadAwareFooterDataResult = (0, $42omo.useMemo)(()=>(0, $MJaSd.getPreloadAwareObjectComments)(processedCommentsData, preloadCacheData, contentStatusFilters), [
        processedCommentsData,
        preloadCacheData,
        contentStatusFilters
    ]);
    const [shouldRequeryArchivedComments, setShouldRequeryArchivedComments] = (0, $42omo.useState)(false);
    const hasRequeriedArchivedComments = (0, $42omo.useRef)(false);
    const startedExperience = (0, $42omo.useRef)(false);
    const focusedCommentId = $0606d9a810dabf91$var$useFocusedCommentIdQueryParam();
    const replyToComment = $0606d9a810dabf91$var$useReplyToCommentQueryParam();
    const { showInlineComments: showInlineComments, showGeneralComments: showGeneralComments, replyToCommentId: replyToCommentId, commentType: commentType, currentlySelectedThreadKey: currentlySelectedThreadKey, location: commentLocation } = (0, $3mVfX.useCommentsPanelState)();
    const [{ isUnreadQueryLoading: isUnreadQueryLoading }] = (0, $fHAwL.useUnreadComments)();
    const [hasLoadedUnreadStatus, setHasLoadedUnreadStatus] = (0, $42omo.useState)(false);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const isContentReady = pageMode === (0, $cD1qu.PageMode).VIEW ? state.isContentReady : true;
    // Check if the page is archived
    const isArchived = contentStatus === (0, $aqBZ0.CONTENT_STATUS_ARCHIVED);
    // Hide add comment container on archived pages
    (0, $42omo.useEffect)(()=>{
        if (isArchived) {
            setShouldShowAddComment(false);
            setShouldRequeryArchivedComments(true);
        }
    }, [
        isArchived
    ]);
    // Close comment container when expanded and contentId changes
    (0, $42omo.useEffect)(()=>{
        if (expanded && contentId) closeCommentContainer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId
    ]);
    // AKA - has the user scrolled to the bottom of the page?
    const isContentInViewport = isInViewport && isContentReady;
    // Query setup - skip if not forcing load and not in viewport and not loaded yet
    const commentsQueryHook = (0, $dkkKv.useActiveCommentsQuery);
    // When preloading, we don't always have access to archived page state (depends on a race condition for cache hit / miss)
    // In those cases, we can incorrectly determine that the page is fully loaded with no comments, when really we just queried using the wrong vars
    // Given that archived are such a small percent of loads, just force a reload here (i.e. don't trust cache) to be safe
    const shouldForceReloadForArchivedComments = shouldRequeryArchivedComments && !hasRequeriedArchivedComments.current;
    const wasFullyLoaded = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? preloadAwareFooterDataResult.isUsingFullData || preloadAwareFooterDataResult.allDataPreloaded : footerCommentsLoadingState === (0, $8i27m.FooterCommentsLoadingStateType).FULLY_LOADED && !shouldForceReloadForArchivedComments;
    const wasPartiallyPreloaded = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? preloadAwareFooterDataResult.isPreloadDataProcessed : footerCommentsLoadingState === (0, $8i27m.FooterCommentsLoadingStateType).PARTIALLY_LOADED;
    const isPreloading = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? preloadAwareFooterDataResult.isPreloadLoading : footerCommentsLoadingState === (0, $8i27m.FooterCommentsLoadingStateType).PRELOADING;
    const shouldLoadFromNetwork = !wasFullyLoaded && !isPreloading && (isContentInViewport || forceLoadComments);
    const commentsQueryHookVariables = {
        pageId: contentId || '',
        skip: wasFullyLoaded || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false),
        // Skip once we have all data - essentially, we don't need to subscribe to apollo updates after this point since we get everything from sweet state
        type: 'FOOTER',
        returnNativeLoading: true,
        // required for `loading` to behave as expected
        useStableCommentsDataUpdates: true,
        fetchPolicy: shouldLoadFromNetwork ? 'network-only' : 'cache-only',
        isPreload: isServer
    };
    const { hasRecs: hasRecs } = (0, $jAfH5.usePageRecommendationData)();
    const legacyQueryResult = commentsQueryHook(commentsQueryHookVariables);
    // Use new or legacy data based on experiment
    const { error: error, data: data } = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? {
        data: {
            comments: {
                totalCount: preloadAwareFooterDataResult.commentCount,
                nodes: preloadAwareFooterDataResult.openFooterComments
            }
        },
        error: preloadAwareFooterDataResult.error
    } : legacyQueryResult;
    // Enhanced loading state that accounts for new data manager processing
    // When using new data manager, only show loading if we're actually loading OR if data isn't processed yet
    const loading = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? preloadAwareFooterDataResult.isPreloadLoading || !preloadAwareFooterDataResult.isDataProcessed : legacyQueryResult.loading;
    // In cases where the first paint will be correct (i.e. will match SPA version because nothing controlled by a useEffect / DOM action), immediately render
    // Otherwise, this will just happen on first paint in SPA once the useEffects run
    const renderOnServer = isServer && data?.comments?.totalCount === 0;
    const noOpenObjectComments = (0, $42omo.useMemo)(()=>{
        return data?.comments?.nodes?.length === 0 || true;
    }, [
        data
    ]);
    // If we're forcing a reload for archived comments, we need to set the flag to true so we don't try to reload again
    (0, $42omo.useEffect)(()=>{
        if (shouldForceReloadForArchivedComments && !loading && data) hasRequeriedArchivedComments.current = true;
    }, [
        data,
        loading,
        shouldForceReloadForArchivedComments
    ]);
    // AKA - are we done loading?
    const shouldShowComments = wasFullyLoaded || wasPartiallyPreloaded || renderOnServer;
    // Return null when we haven't loaded anything yet, we're not in the viewport, and we're not SSRed
    const shouldReturnNull = error && !(0, $i6UMJ.onlyHasReactionsSummaryErrors)(error) || !isContentInViewport && !shouldShowComments;
    // Show global placeholder (i.e. instead of comments header, etc) when we're in the viewport but are still loading, and we're not SSRed
    const shouldShowGlobalPlaceholder = isContentInViewport && !shouldShowComments;
    // Show incremental loading placeholder in SSR when preload is completed with comments
    // We can't show the comments themselves because commentThreads is set across multiple renders via sweet state
    // This also ensures that we either show the loading placeholder or the comment threads, never both
    // Without it, we can briefly show both threads & the placeholder, even if fully loaded
    const shouldShowIncrementalLoadingPlaceholderOnServer = isServer && preloadAwareFooterDataResult?.preloadCompletedWithComments && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false);
    // Show placeholder when we're in the viewport but are still loading the rest of the data
    const shouldShowIncrementalLoadingPlaceholder = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? shouldShowComments && loading && !wasFullyLoaded || shouldShowIncrementalLoadingPlaceholderOnServer : shouldShowComments && loading;
    // Set up IntersectionObserver
    (0, $42omo.useEffect)(()=>{
        if (isServer || !isContentReady) // Don't register observer if page content is not ready
        return;
        // eslint-disable-next-line no-restricted-syntax
        const observer = new IntersectionObserver(([entry])=>{
            const isIntersecting = entry.isIntersecting;
            if (isIntersecting) setIsInViewport(isIntersecting);
        }, {
            root: null,
            rootMargin: '10px',
            threshold: 0.1
        });
        if (wrapperRef.current) observer.observe(wrapperRef.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        isServer,
        pageMode,
        state.isContentReady,
        isContentReady
    ]);
    // Add MutationObserver to detect when comments are actually rendered --- old logic for checking all comment rendered or not
    (0, $42omo.useEffect)(()=>{
        if (isServer || !currentlySelectedThreadKey) return;
        const observer = new MutationObserver(()=>{
            const commentElementId = `footer-comment-thread-${currentlySelectedThreadKey}-container`;
            const commentElement = document.getElementById(commentElementId);
            if (commentElement) {
                setAllCommentsRendered(true);
                observer.disconnect(); // Disconnect once we find the element
            } else setAllCommentsRendered(false); // Reset if element not found
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        // Reset allCommentsRendered when unmounting or changing thread key
        return ()=>{
            setAllCommentsRendered(false);
            observer.disconnect();
        };
    }, [
        currentlySelectedThreadKey,
        isServer
    ]);
    // Update loaded state when data is received
    (0, $42omo.useEffect)(()=>{
        if (wasFullyLoaded) setForceLoadComments(false);
    }, [
        wasFullyLoaded
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isUnreadQueryLoading && !hasLoadedUnreadStatus) setHasLoadedUnreadStatus(true);
    }, [
        isUnreadQueryLoading,
        hasLoadedUnreadStatus
    ]);
    (0, $42omo.useEffect)(()=>{
        if (commentType === (0, $8i27m.CommentType).GENERAL) {
            const commentElementId = `footer-comment-thread-${currentlySelectedThreadKey}-container`;
            const isCommentExists = document.getElementById(commentElementId);
            if (!isCommentExists) setForceLoadComments(true);
        }
    }, [
        currentlySelectedThreadKey,
        commentType
    ]);
    // Handle spacing for Editor & LiveDoc modes by observing the size of editorTextArea
    (0, $42omo.useEffect)(()=>{
        const editorTextArea = document.getElementById('ak-editor-textarea');
        if (editorTextArea) {
            if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
            hasRecs && (0, $6mKj3.expValEquals)('confluence_ai_related_content_for_live_pages', 'isEnabled', true) && (0, $9wGTI.fg)('confluence_frontend_unify_footer_comment_space_ld')) {
                setCommentSectionTop(0);
                return;
            }
            const resizeObserver = new ResizeObserver((entries)=>{
                const newTop = (0, $aHcFH.getCommentPositionTopOfSectionEditor)(entries);
                (0, $jTxSS.flushSync)(()=>{
                    newTop !== undefined && setCommentSectionTop(newTop);
                });
            });
            // observe resize of editorTextArea to update spacing when content changes
            resizeObserver.observe(editorTextArea);
            // observe resize of document.body to update spacing when window height changes
            resizeObserver.observe(document.body);
            return ()=>resizeObserver.disconnect();
        }
    }, [
        hasRecs
    ]);
    // Handle spacing for Renderer mode based on content and window height
    (0, $42omo.useEffect)(()=>{
        const renderContentContainer = document.querySelector('[data-testid="content-container-component"]');
        if (pageMode === (0, $cD1qu.PageMode).VIEW && renderContentContainer && (0, $9wGTI.fg)('confluence_frontend_unify_footer_comment_space_old')) {
            const resizeObserver = new ResizeObserver((_entries)=>{
                const newTop = (0, $aHcFH.getCommentPositionTopOfSectionRenderer)();
                (0, $jTxSS.flushSync)(()=>{
                    setCommentSectionTop(newTop);
                });
            });
            // observe resize of content-container-component to update spacing when content changes
            // (the container includes page title, content, and end-of-page recommendations components, etc.)
            resizeObserver.observe(renderContentContainer);
            // observe resize of document.body to update spacing when window height changes
            resizeObserver.observe(document.body);
            return ()=>{
                resizeObserver.disconnect();
            };
        }
    }, [
        pageMode
    ]);
    // Create commentsDataMap from new data when experiment is enabled
    const commentsDataMap = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? preloadAwareFooterDataResult.commentsDataMap : legacyCommentsDataMap;
    const commentThreads = (0, $42omo.useMemo)(()=>{
        if (!wasFullyLoaded && !shouldShowComments) // no need to update if we haven't loaded, or aren't showing comments
        return [];
        return (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? (0, $6lAIr.getVisibleCommentThreads)({
            commentsDataMap: commentsDataMap,
            includeGeneralComments: true,
            includeInlineComments: false,
            orderedAnnotationIds: (0, $i6UMJ.getAnnotationThreadKeys)(orderedActiveAnnotationIdList),
            pageMode: pageMode
        }) : (0, $i6UMJ.getOpenCommentThreads)({
            commentsDataMap: commentsDataMap,
            showInlineComments: showInlineComments,
            showGeneralComments: showGeneralComments,
            location: (0, $i6UMJ.LocationValue).FOOTER,
            orderedActiveAnnotationIdList: orderedActiveAnnotationIdList,
            removedThreadsMap: removedThreadsMap
        });
    }, [
        wasFullyLoaded,
        shouldShowComments,
        commentsDataMap,
        orderedActiveAnnotationIdList,
        pageMode,
        showInlineComments,
        showGeneralComments,
        removedThreadsMap
    ]);
    const hasComments = commentThreads.length > 0;
    // Handle add comment container animation and mounting
    (0, $42omo.useEffect)(()=>{
        if (isArchived) return;
        const shouldHide = !!replyToCommentId && commentLocation === (0, $i6UMJ.LocationValue).FOOTER;
        if (shouldHide) // Start hiding animation
        setShouldShowAddComment(false);
        else {
            // Show component after a small delay to allow for animation
            const timer = setTimeout(()=>{
                setShouldShowAddComment(true);
            }, 50);
            return ()=>clearTimeout(timer);
        }
    }, [
        replyToCommentId,
        commentLocation,
        isArchived
    ]);
    // Track the start of comments loading and initialize performance metrics
    (0, $42omo.useEffect)(()=>{
        const shouldStartExperience = !startedExperience.current && (isContentInViewport && loading || wasFullyLoaded && hasComments);
        if (shouldStartExperience) {
            // Start tracking the page comments experience with initial attributes
            experienceTracker.start({
                name: (0, $irVI7.VIEW_PAGE_COMMENTS_EXPERIENCE),
                attributes: {
                    ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                    isConditionalRenderingOn: true,
                    isFocusedComment: Boolean(focusedCommentId || replyToComment),
                    contentId: contentId,
                    pageMode: pageMode
                }
            });
            startedExperience.current = true;
            // Initialize and mark the start of page comments rendering metrics
            (0, $6Hogt.PAGE_COMMENTS_METRIC).start();
            (0, $6Hogt.PAGE_COMMENTS_METRIC).mark('pageCommentsRenderStart');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        shouldShowIncrementalLoadingPlaceholder,
        shouldShowGlobalPlaceholder,
        loading,
        isContentInViewport,
        wasFullyLoaded,
        hasComments
    ]);
    // Track any errors that occur during comments loading
    (0, $42omo.useEffect)(()=>{
        if (error) {
            if ((0, $i6UMJ.onlyHasReactionsSummaryErrors)(error)) {
                experienceTracker.updateAttributes({
                    name: (0, $irVI7.VIEW_PAGE_COMMENTS_EXPERIENCE),
                    attributes: {
                        ignoredReactionsSummaryErrors: true
                    }
                });
                // Comments may still be displayed without reactions, so do not
                // fail or abort the experience but just return here.
                return;
            }
            const translatedError = (0, $lFkRf.getTranslatedError)(error);
            if ((0, $lFkRf.isViewNotPermittedError)(translatedError)) {
                // If the error is a 403 permission error, show a warning flag and abort the experience
                flags.showWarningFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $FBfum.i18n).unableToLoadCommentsTitle),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), translatedError)
                });
                experienceTracker.abort({
                    name: (0, $irVI7.VIEW_PAGE_COMMENTS_EXPERIENCE),
                    reason: (0, $FBfum.i18n).viewNotPermitted.id
                });
                (0, $6Hogt.PAGE_COMMENTS_METRIC).cancel();
                return;
            }
            if ((0, $lFkRf.isNetworkError)(translatedError)) // Show flag for network error
            flags.showWarningFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $FBfum.i18n).unableToLoadCommentsTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), translatedError)
            });
            // Mark the experience as failed/aborted and include the error details
            experienceTracker.stopOnError({
                name: (0, $irVI7.VIEW_PAGE_COMMENTS_EXPERIENCE),
                error: error
            });
            (0, $6Hogt.PAGE_COMMENTS_METRIC).cancel();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        error
    ]);
    // Track successful completion of comments rendering
    (0, $42omo.useEffect)(()=>{
        if (allCommentsRendered && wasFullyLoaded && hasComments) {
            // Mark the experience as successful and include total comments count
            experienceTracker.succeed({
                name: (0, $irVI7.VIEW_PAGE_COMMENTS_EXPERIENCE),
                attributes: {
                    totalComments: data?.comments?.totalCount,
                    totalCommentThreads: commentThreads.length
                }
            });
            // Mark key performance metrics:
            // - pageCommentsRenderEnd: End of comments rendering
            (0, $6Hogt.PAGE_COMMENTS_METRIC).mark('pageCommentsRenderEnd');
            // Stop the metric tracking and include final data
            (0, $6Hogt.PAGE_COMMENTS_METRIC).stop({
                customData: {
                    contentId: contentId || '',
                    totalComments: data?.comments?.totalCount || 0
                }
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        allCommentsRendered,
        wasFullyLoaded,
        hasComments
    ]);
    // Track successful completion of first comment batch rendering
    (0, $42omo.useEffect)(()=>{
        if (commentBatchRendered) {
            // Mark key performance metrics:
            // - fmp: First Meaningful Paint
            // - tti: Time to Interactive
            (0, $6Hogt.PAGE_COMMENTS_METRIC).markFMP();
            (0, $6Hogt.PAGE_COMMENTS_METRIC).mark('tti');
            const experienceState = experienceTracker.getExperienceState((0, $irVI7.VIEW_PAGE_COMMENTS_EXPERIENCE));
            if (experienceState?.startTime && typeof experienceState.startTime === 'number') experienceTracker.updateAttributes({
                name: (0, $irVI7.VIEW_PAGE_COMMENTS_EXPERIENCE),
                attributes: {
                    firstMeaningfulPaint: window.performance.now() - experienceState.startTime
                }
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        commentBatchRendered
    ]);
    // Handle case when there are no comments to render
    (0, $42omo.useEffect)(()=>{
        if (data?.comments?.totalCount === 0) {
            // Abort the experience tracking since there are no comments to render
            experienceTracker.abort({
                name: (0, $irVI7.VIEW_PAGE_COMMENTS_EXPERIENCE),
                reason: 'No page comments'
            });
            (0, $6Hogt.PAGE_COMMENTS_METRIC).cancel();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        data
    ]);
    const handleAllCommentsRendered = (0, $42omo.useCallback)(()=>setAllCommentsRendered(true), []);
    const computedWidths = (0, $aHcFH.getWidthAndMaxWidth)({
        pageMode: pageMode,
        pageWidthType: pageWidthType,
        hasEndOfPageRecommendations: hasRecs ?? false
    });
    const shouldRenderFixedStyle = (0, $42omo.useMemo)(()=>{
        if (expanded && footerEditorEntry === (0, $3mVfX.AddFooterCommentMode).STICKY_DRAFT) return true;
        return false;
    }, [
        expanded,
        footerEditorEntry
    ]);
    const pageContentDimensions = (0, $42omo.useMemo)(()=>({
            width: pageContentWidth,
            left: pageContentLeft,
            right: pageContentRight
        }), [
        pageContentWidth,
        pageContentLeft,
        pageContentRight
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        ref: wrapperRef,
        xcss: $0606d9a810dabf91$var$wrapperStyle,
        testId: "object-comment-wrapper",
        style: {
            top: commentSectionTop,
            width: computedWidths.width,
            maxWidth: computedWidths.maxWidth
        },
        "data-vc": `object-comment-wrapper-${pageMode}-${hasComments ? 'has-comments' : 'no-comments'}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $90365d58d6587547$export$1e65952d87b47593), {
        hasLoadedObjectComments: !!shouldShowComments,
        allObjectCommentsRendered: allCommentsRendered || noOpenObjectComments || wasFullyLoaded,
        commentBatchRendered: commentBatchRendered,
        commentBatchCount: commentBatchCount,
        setForceLoadComments: setForceLoadComments
    }), shouldReturnNull ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, shouldShowGlobalPlaceholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $0606d9a810dabf91$var$placeholderStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $deTj5.CommentPlaceholder), {
        showPlaceholder: true
    })), shouldShowComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8SCD6.ReactionsProvider), {
        contentId: contentId ?? ''
    }, hasComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f06f6da515cf7544$export$32c2c28e641d3a4f), {
        isOffline: editorIsUserOffline,
        showReactions: isEmbeddedConfluence ? hasReactions : true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $0606d9a810dabf91$var$commentPanelContainerStyles
    }, !shouldShowIncrementalLoadingPlaceholderOnServer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fd40026d890a9ac0$export$b05be82c52775010), {
        commentThreads: commentThreads,
        supportedTopLevelActions: [
            'edit',
            'resolve',
            'delete'
        ],
        flags: flags,
        onAllCommentsRendered: handleAllCommentsRendered,
        onCommentBatchRendered: ()=>{
            setCommentBatchRendered(true);
            setCommentBatchCount((prev)=>prev + 1);
        },
        isOffline: editorIsUserOffline
    }), shouldShowIncrementalLoadingPlaceholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $0606d9a810dabf91$var$incrementalLoadingPlaceholderStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $deTj5.CommentPlaceholder), {
        showPlaceholder: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $0606d9a810dabf91$var$addCommentContainerStyles,
            !!replyToCommentId && commentLocation === (0, $i6UMJ.LocationValue).FOOTER ? $0606d9a810dabf91$var$addCommentContainerAnimationHiddenStyles : $0606d9a810dabf91$var$addCommentContainerAnimationShowStyles
        ]
    }, !shouldShowGlobalPlaceholder && !shouldShowIncrementalLoadingPlaceholder && shouldShowAddComment && !isArchived && !expanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2998c7377d5266d6$export$f3a35a1c0e5d2996), {
        showReactions: !hasComments && (isEmbeddedConfluence ? hasReactions : true),
        showLabels: showLabels,
        isOffline: editorIsUserOffline,
        optimisticReactions: true
    }))))), expanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $0606d9a810dabf91$var$footerStickyWrapperStyle,
            shouldRenderFixedStyle ? $0606d9a810dabf91$var$fixedEditorStyles : $0606d9a810dabf91$var$stickyEditorStyles,
            pageMode === (0, $cD1qu.PageMode).VIEW && $0606d9a810dabf91$var$viewPageFooterStyle,
            pageMode !== (0, $cD1qu.PageMode).VIEW && $0606d9a810dabf91$var$footerEditorStyle
        ],
        testId: "footerCommentEditor",
        style: pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $niTts.hideWhiteSpace)({
            shouldRenderFixedStyle: shouldRenderFixedStyle,
            pageContentDimensions: pageContentDimensions,
            fallbackWidth: width
        }) : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $0606d9a810dabf91$var$baseEditorStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            width: width,
            maxWidth: computedWidths.maxWidth
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dL5YQ.ObjectAddCommentProfileWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2f75a8a3cc0f80c1$export$b65ed37f0eb1c56b), {
        isOffline: editorIsUserOffline
    }))))));
});
const $0606d9a810dabf91$export$82b49dda6ae20eb7 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).COMMENTS
})($0606d9a810dabf91$var$ObjectCommentContainerComponent);
module.exports["ObjectCommentContainer"] = $0606d9a810dabf91$export$82b49dda6ae20eb7;

});

parcelRegister("7aqgU", function(module, exports) {

let $537dd89cdadc3f40$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $537dd89cdadc3f40$var$load("BbB4M").then(()=>parcelRequire('JSoWM'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("hdxAi", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $2d2e882c9a90b3be$var$getInitialState = ()=>({
        deletedMentions: [],
        addedMentions: [],
        deletedTasks: [],
        addedTasks: [],
        unrestrictedMentions: [],
        //Added mentions which have access to the current page
        parentSpaceRestrictedMentions: [],
        //Added mentions which dont have access to the current page due to parent or space restrictions
        pageRestrictedMentions: [],
        //Added mentions which dont have access to the current page due to page restrictions
        unrestrictedTasks: [],
        //Added task mentions which have access to the current page
        parentSpaceRestrictedTasks: [],
        //Added task mentions which dont have access to the current page due to parent or space restrictions
        pageRestrictedTasks: [],
        //Added task mentions which dont have access to the current page due to page restrictions
        editorApi: undefined,
        mentionsAdded: {
            currentUser: [],
            //Mentions of current user added by the current user
            otherUsers: [] //Mentions of other users added by the current user
        },
        tasksAdded: {
            currentUser: [],
            //Task mentions of current user added by the current user
            otherUsers: [] //Task mentions of other users added by the current user
        }
    });
const $2d2e882c9a90b3be$var$actions = {
    setDeletedMentions: (mentions)=>({ setState: setState })=>{
            setState({
                deletedMentions: mentions
            });
        },
    setAddedMentions: (mentions)=>({ setState: setState })=>{
            setState({
                addedMentions: mentions
            });
        },
    setUnrestrictedMentions: (mentions)=>({ setState: setState })=>{
            setState({
                unrestrictedMentions: mentions
            });
        },
    addUnrestrictedMentions: (addedUnrestrictedMentions)=>({ setState: setState, getState: getState })=>{
            const { unrestrictedMentions: unrestrictedMentions } = getState();
            const updatedUnrestrictedMentions = [
                ...unrestrictedMentions,
                ...addedUnrestrictedMentions
            ];
            setState({
                unrestrictedMentions: updatedUnrestrictedMentions
            });
        },
    removeUnrestrictedMentions: (removedUnrestrictedMention)=>({ setState: setState, getState: getState })=>{
            const removedLocalIds = new Set(removedUnrestrictedMention.map((mention)=>mention.localId));
            const { unrestrictedMentions: unrestrictedMentions } = getState();
            const updatedUnrestrictedMentions = unrestrictedMentions.filter((mention)=>!removedLocalIds.has(mention.localId));
            setState({
                unrestrictedMentions: updatedUnrestrictedMentions
            });
        },
    setParentSpaceRestrictedMentions: (mentions)=>({ setState: setState })=>{
            setState({
                parentSpaceRestrictedMentions: mentions
            });
        },
    addParentSpaceRestrictedMentions: (addedParentSpaceRestrictedMentions)=>({ setState: setState, getState: getState })=>{
            const { parentSpaceRestrictedMentions: parentSpaceRestrictedMentions } = getState();
            const updatedParentSpaceRestrictedMentions = [
                ...parentSpaceRestrictedMentions,
                ...addedParentSpaceRestrictedMentions
            ];
            setState({
                parentSpaceRestrictedMentions: updatedParentSpaceRestrictedMentions
            });
        },
    removeParentSpaceRestrictedMentions: (removedParentSpaceRestrictedMentions)=>({ setState: setState, getState: getState })=>{
            const removedLocalIds = new Set(removedParentSpaceRestrictedMentions.map((mention)=>mention.localId));
            const { parentSpaceRestrictedMentions: parentSpaceRestrictedMentions } = getState();
            const updatedParentSpaceRestrictedMentions = parentSpaceRestrictedMentions.filter((mention)=>!removedLocalIds.has(mention.localId));
            setState({
                parentSpaceRestrictedMentions: updatedParentSpaceRestrictedMentions
            });
        },
    setPageRestrictedMentions: (mentions)=>({ setState: setState })=>{
            setState({
                pageRestrictedMentions: mentions
            });
        },
    addPageRestrictedMentions: (addedPageRestrictedMentions)=>({ setState: setState, getState: getState })=>{
            const { pageRestrictedMentions: pageRestrictedMentions } = getState();
            const updatedPageRestrictedMention = [
                ...pageRestrictedMentions,
                ...addedPageRestrictedMentions
            ];
            setState({
                pageRestrictedMentions: updatedPageRestrictedMention
            });
        },
    removePageRestrictedMentions: (removedPageRestrictedMentions)=>({ setState: setState, getState: getState })=>{
            const removedLocalIds = new Set(removedPageRestrictedMentions.map((mention)=>mention.localId));
            const { pageRestrictedMentions: pageRestrictedMentions } = getState();
            const updatedPageRestrictedMention = pageRestrictedMentions.filter((mention)=>!removedLocalIds.has(mention.localId));
            setState({
                pageRestrictedMentions: updatedPageRestrictedMention
            });
        },
    setDeletedTasks: (tasks)=>({ setState: setState })=>{
            setState({
                deletedTasks: tasks
            });
        },
    setAddedTasks: (tasks)=>({ setState: setState })=>{
            setState({
                addedTasks: tasks
            });
        },
    setPageRestrictedTasks: (tasks)=>({ setState: setState })=>{
            setState({
                pageRestrictedTasks: tasks
            });
        },
    addPageRestrictedTasks: (addedPageRestrictedTasks)=>({ setState: setState, getState: getState })=>{
            const { pageRestrictedTasks: pageRestrictedTasks } = getState();
            const updatedPageRestrictedTasks = [
                ...pageRestrictedTasks,
                ...addedPageRestrictedTasks
            ];
            setState({
                pageRestrictedTasks: updatedPageRestrictedTasks
            });
        },
    removePageRestrictedTasks: (removedPageRestrictedTasks)=>({ setState: setState, getState: getState })=>{
            const removedLocalIds = new Set(removedPageRestrictedTasks.map((tasks)=>tasks.localId));
            const { pageRestrictedTasks: pageRestrictedTasks } = getState();
            const updatedPageRestrictedTasks = pageRestrictedTasks.filter((tasks)=>!removedLocalIds.has(tasks.localId));
            setState({
                pageRestrictedTasks: updatedPageRestrictedTasks
            });
        },
    setParentSpaceRestrictedTasks: (tasks)=>({ setState: setState })=>{
            setState({
                parentSpaceRestrictedTasks: tasks
            });
        },
    addParentSpaceRestrictedTasks: (addedParentSpaceRestrictedTasks)=>({ setState: setState, getState: getState })=>{
            const { parentSpaceRestrictedTasks: parentSpaceRestrictedTasks } = getState();
            const updatedParentSpaceRestrictedTasks = [
                ...parentSpaceRestrictedTasks,
                ...addedParentSpaceRestrictedTasks
            ];
            setState({
                parentSpaceRestrictedTasks: updatedParentSpaceRestrictedTasks
            });
        },
    removeParentSpaceRestrictedTasks: (removedParentSpaceRestrictedTasks)=>({ setState: setState, getState: getState })=>{
            const removedLocalIds = new Set(removedParentSpaceRestrictedTasks.map((tasks)=>tasks.localId));
            const { parentSpaceRestrictedTasks: parentSpaceRestrictedTasks } = getState();
            const updatedParentSpaceRestrictedTasks = parentSpaceRestrictedTasks.filter((tasks)=>!removedLocalIds.has(tasks.localId));
            setState({
                parentSpaceRestrictedTasks: updatedParentSpaceRestrictedTasks
            });
        },
    setUnrestrictedTasks: (tasks)=>({ setState: setState })=>{
            setState({
                unrestrictedTasks: tasks
            });
        },
    addUnrestrictedTasks: (addedUnrestrictedTasks)=>({ setState: setState, getState: getState })=>{
            const { unrestrictedTasks: unrestrictedTasks } = getState();
            const updatedUnrestrictedTasks = [
                ...unrestrictedTasks,
                ...addedUnrestrictedTasks
            ];
            setState({
                unrestrictedTasks: updatedUnrestrictedTasks
            });
        },
    removeUnrestrictedTasks: (removedUnrestrictedTasks)=>({ setState: setState, getState: getState })=>{
            const removedLocalIds = new Set(removedUnrestrictedTasks.map((tasks)=>tasks.localId));
            const { unrestrictedTasks: unrestrictedTasks } = getState();
            const updatedUnrestrictedTasks = unrestrictedTasks.filter((tasks)=>!removedLocalIds.has(tasks.localId));
            setState({
                unrestrictedTasks: updatedUnrestrictedTasks
            });
        },
    setMentionsAdded: (mentionsToAdd)=>({ setState: setState, getState: getState })=>{
            const { mentionsAdded: mentionsAdded } = getState();
            const updatedMentionsAdded = mentionsAdded;
            if (mentionsToAdd.currentUser) {
                if (mentionsToAdd.currentUser.length > 0) {
                    const currentUserMentions = mentionsToAdd.currentUser;
                    updatedMentionsAdded.currentUser = [
                        ...currentUserMentions,
                        ...mentionsAdded.currentUser
                    ];
                } else updatedMentionsAdded.currentUser = [];
            }
            setState({
                mentionsAdded: updatedMentionsAdded
            });
        },
    setTasksAdded: (tasksToAdd)=>({ setState: setState, getState: getState })=>{
            const { tasksAdded: tasksAdded } = getState();
            const updatedTasksAdded = tasksAdded;
            if (tasksToAdd.currentUser) {
                if (tasksToAdd.currentUser.length > 0) {
                    const currentUserTasks = tasksToAdd.currentUser;
                    updatedTasksAdded.currentUser = [
                        ...currentUserTasks,
                        ...tasksAdded.currentUser
                    ];
                } else updatedTasksAdded.currentUser = [];
            }
            setState({
                tasksAdded: updatedTasksAdded
            });
        },
    clearMentionsFlags: ()=>({ setState: setState })=>{
            setState($2d2e882c9a90b3be$var$getInitialState());
        }
};
const $2d2e882c9a90b3be$var$MentionsNotificationsStore = (0, $1P1Tu.createStore)({
    initialState: $2d2e882c9a90b3be$var$getInitialState(),
    actions: $2d2e882c9a90b3be$var$actions,
    name: 'MentionsNotificationsStore'
});
const $2d2e882c9a90b3be$export$63a7b4a5d3248013 = (0, $9zUhf.createHook)($2d2e882c9a90b3be$var$MentionsNotificationsStore);
const $2d2e882c9a90b3be$export$e03e9325d0a65293 = (0, $9zUhf.createActionsHook)($2d2e882c9a90b3be$var$MentionsNotificationsStore);
module.exports["useMentionsNotifications"] = $2d2e882c9a90b3be$export$63a7b4a5d3248013;
module.exports["useMentionsNotificationsActions"] = $2d2e882c9a90b3be$export$e03e9325d0a65293;

});

parcelRegister("cmBjr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kyKWe = parcelRequire("kyKWe");


var $7aRa9 = parcelRequire("7aRa9");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $dPJCf = parcelRequire("dPJCf");


var $bqMNb = parcelRequire("bqMNb");


var $jv3O2 = parcelRequire("jv3O2");


var $i9VoI = parcelRequire("i9VoI");

const $1c71f3d63aae3f56$export$b0544c15da22323d = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    const showConvertToLivePageFlag = (0, $jv3O2.useShowConvertToLivePageFlag)({
        flags: flags
    });
    const onSubscriptionEvent = (0, $42omo.useCallback)((response)=>{
        const { accountId: accountId, pageUpdated: pageUpdated } = response || {};
        const trigger = pageUpdated?.trigger;
        if (trigger !== 'convertToLiveEdit') return;
        showConvertToLivePageFlag({
            converterWasCurrentUser: accountId === userId
        });
        // When another user converts the page to a live doc, we need to add a query param to avoid the double action bar bug.
        // Without this, the page may read stale SSR values indicating it's not a live page, causing UI weirdness.
        // The query param forces RouteState to increment transitionId, preventing it from using initial SSR values.
        setQueryParams({
            [(0, $bqMNb.FORCE_TRANSITION_QUERY_PARAM)]: (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()
        });
    }, [
        showConvertToLivePageFlag,
        userId,
        setQueryParams
    ]);
    (0, $i9VoI.useSubscriptionEvent)({
        subscriberId: 'convertToLivePageFlag',
        contentId: contentId,
        delta: 'pageUpdated',
        contentType: 'page',
        skip: !contentId,
        onDataReceived: (response)=>onSubscriptionEvent(response)
    });
    return null;
});
module.exports["ConvertToLivePageFlag"] = $1c71f3d63aae3f56$export$b0544c15da22323d;

});

parcelRegister("hrEV9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");

var $398ES = parcelRequire("398ES");


var $deTj5 = parcelRequire("deTj5");


const $c714317956c3d72c$var$CommentsSectionLoaderPaint = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "v-far",
    name: "CommentsSectionLoaderPaint",
    loading: ({ handlePageCommentsRender: handlePageCommentsRender })=>{
        return !handlePageCommentsRender ? (0, $deTj5.CommentPlaceholder) : null;
    },
    loader: async ()=>(await (parcelRequire("3CxZ7"))).CommentsSection
});

const $c714317956c3d72c$var$CommentsSectionLoaderAfterPaint = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "COkRl",
    name: "CommentsSectionLoaderAfterPaint",
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $deTj5.CommentPlaceholder), null),
    loader: async ()=>(await (parcelRequire("3CxZ7"))).CommentsSection
});
const $c714317956c3d72c$var$loaders = {
    [(0, $398ES.LoadingPriority).PAINT]: $c714317956c3d72c$var$CommentsSectionLoaderPaint,
    [(0, $398ES.LoadingPriority).AFTER_PAINT]: $c714317956c3d72c$var$CommentsSectionLoaderAfterPaint
};
const $c714317956c3d72c$export$2fa3aacacd7711f1 = ({ loadingPriority: loadingPriority, ...rest })=>{
    const PageCommentsLoader = $c714317956c3d72c$var$loaders[loadingPriority] || $c714317956c3d72c$var$CommentsSectionLoaderAfterPaint;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PageCommentsLoader, rest);
};
module.exports["CommentsSectionLoader"] = $c714317956c3d72c$export$2fa3aacacd7711f1;

});

parcelRegister("3CxZ7", function(module, exports) {

let $2a2f48657b968c55$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2a2f48657b968c55$var$load("3NlhD").then(()=>parcelRequire('8zun0'));

});

parcelRegister("fzhfU", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $JTIzG = parcelRequire("JTIzG");

const $e4992c54b0e0da53$export$ede5d3bbbf3ec238 = (0, $3u0dr.isReactCompilerActiveV2)() ? (isAIEnabledForContent)=>{
    const { isAIPolicyAndBrowserSupportEnabled: isAIPolicyAndBrowserSupportEnabled, isAudioV3Enabled: isAudioV3Enabled, isAudioBylineEntrypointEnabled: isAudioBylineEntrypointEnabled } = (0, $JTIzG.useAudioFeatureFlags)();
    return isAIEnabledForContent && isAIPolicyAndBrowserSupportEnabled && (!isAudioV3Enabled || !isAudioBylineEntrypointEnabled);
} : (isAIEnabledForContent)=>{
    const { isAIPolicyAndBrowserSupportEnabled: isAIPolicyAndBrowserSupportEnabled, isAudioV3Enabled: isAudioV3Enabled, isAudioBylineEntrypointEnabled: isAudioBylineEntrypointEnabled } = (0, $JTIzG.useAudioFeatureFlags)();
    // Only show audio entrypoint in sidebar if:
    // 1. AI is Enabled for content
    // 2. AI Policy and browser support are enabled AND
    // 3. [Audio V3 is disabled] OR [Audio Byline Entrypoint is disabled]
    //
    // Truthy cases:
    // - AI Enabled; Audio & AI Policy supported; Audio V3 disabled; Audio Byline Entrypoint disabled => Audio V2 experience
    // - AI Enabled; Audio & AI Policy supported; Audio V3 disabled; Audio Byline Entrypoint enabled  => Audio V2 experience
    // - AI Enabled; Audio & AI Policy supported; Audio V3 enabled; Audio Byline Entrypoint disabled  => Audio V3 experience
    //
    // Falsy cases:
    // - AI disabed;													  							  => No audio entrypoint
    // - Audio & AI Policy disabled;									  							  => No audio entrypoint
    // - AI Enabled; Audio & AI Policy supported; Audio V3 enabled; Audio Byline Entrypoint enabled   => Audio V3-Byline experience
    return isAIEnabledForContent && isAIPolicyAndBrowserSupportEnabled && (!isAudioV3Enabled || !isAudioBylineEntrypointEnabled);
};
module.exports["useHasAudioButton"] = $e4992c54b0e0da53$export$ede5d3bbbf3ec238;

});

parcelRegister("niTts", function(module, exports) {
const $829c98791d74b4c3$export$a9fce9e535ae2163 = ({ shouldRenderFixedStyle: shouldRenderFixedStyle, pageContentDimensions: pageContentDimensions, fallbackWidth: fallbackWidth = '100%' })=>{
    if (!shouldRenderFixedStyle) return {
        width: fallbackWidth
    };
    const { width: pageContentWidth, left: pageContentLeft, right: pageContentRight } = pageContentDimensions;
    // Handle case where dimensions might be undefined or width might be a string
    const width = typeof pageContentWidth === 'number' ? pageContentWidth : 0;
    const left = pageContentLeft ?? 0;
    const right = pageContentRight ?? 0;
    return {
        left: left > 0 ? `${left}px` : '0px',
        right: right > 0 ? `${window.innerWidth - right}px` : '0px',
        width: width > 0 ? `${width}px` : '100%'
    };
};
module.exports["hideWhiteSpace"] = $829c98791d74b4c3$export$a9fce9e535ae2163;

});

parcelRegister("dL5YQ", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $8lS8J = parcelRequire("8lS8J");


var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");


var $jMyy4 = parcelRequire("jMyy4");


var $9wGTI = parcelRequire("9wGTI");


var $fs6LW = parcelRequire("fs6LW");


var $bQm3c = parcelRequire("bQm3c");


var $e4o8D = parcelRequire("e4o8D");

const $f361dd7d6e4d9bdd$var$ObjectAddCommentProfileWrapperUserQuery = (0, $8lS8J.default);
const $f361dd7d6e4d9bdd$var$styles = {
    addCommentOpenContainerStyles: "_zulppxbi _1e0c1txw _2lx2vrvc _1bsb1osq _4cvr1y6m",
    addCommentEditorStyles: "_1bsb1osq",
    avatarStyles: "_1bsbzwfg _4t3izwfg"
};
const $f361dd7d6e4d9bdd$export$5a360c1cb6170ba8 = (t0)=>{
    const $ = (0, $frIzR.c)(21);
    const { children: children } = t0;
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const t1 = userId || "";
    let t2;
    if ($[0] !== t1) {
        t2 = {
            id: t1
        };
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const t3 = !userId;
    let t4;
    if ($[2] !== t2 || $[3] !== t3) {
        t4 = {
            variables: t2,
            fetchPolicy: (0, $9wGTI.fg)("confluence-comments-fix-avatar-flash") ? "cache-first" : "cache-and-network",
            skip: t3
        };
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
    } else t4 = $[4];
    const { data: userData, loading: loading } = (0, $jMyy4.useQueryInterop)($f361dd7d6e4d9bdd$var$ObjectAddCommentProfileWrapperUserQuery, {
        ...t4,
        __callerPackage__: "@confluence/object-comments"
    });
    const t5 = userData?.user?.photos?.[0]?.value || "";
    const t6 = userData?.user?.displayName || "";
    let t7;
    if ($[5] !== t5 || $[6] !== t6 || $[7] !== userId) {
        t7 = {
            avatarUrl: t5,
            accountId: userId,
            displayName: t6
        };
        $[5] = t5;
        $[6] = t6;
        $[7] = userId;
        $[8] = t7;
    } else t7 = $[8];
    const userInfo = t7;
    let t8;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = {
            float: "left"
        };
        $[9] = t8;
    } else t8 = $[9];
    let t9;
    if ($[10] !== loading || $[11] !== renderServerPlaceholder || $[12] !== userInfo) {
        t9 = loading || renderServerPlaceholder ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fs6LW.ProfileAvatar), {
            canViewProfile: true,
            src: userInfo.avatarUrl,
            userId: userInfo.accountId,
            isAnonymous: !userInfo.accountId,
            name: userInfo.displayName,
            testId: "profile-avatar-comment"
        });
        $[10] = loading;
        $[11] = renderServerPlaceholder;
        $[12] = userInfo;
        $[13] = t9;
    } else t9 = $[13];
    let t10;
    if ($[14] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $f361dd7d6e4d9bdd$var$styles.avatarStyles,
            style: t8
        }, t9);
        $[14] = t9;
        $[15] = t10;
    } else t10 = $[15];
    let t11;
    if ($[16] !== children) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $f361dd7d6e4d9bdd$var$styles.addCommentEditorStyles
        }, children);
        $[16] = children;
        $[17] = t11;
    } else t11 = $[17];
    let t12;
    if ($[18] !== t10 || $[19] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $f361dd7d6e4d9bdd$var$styles.addCommentOpenContainerStyles
        }, t10, t11);
        $[18] = t10;
        $[19] = t11;
        $[20] = t12;
    } else t12 = $[20];
    return t12;
};
module.exports["ObjectAddCommentProfileWrapper"] = $f361dd7d6e4d9bdd$export$5a360c1cb6170ba8;

});

parcelRegister("8lS8J", function(module, exports) {
/**
 * @generated SignedSource<<dd2571425eb77167b483f65452f9f152>>
 * @relayHash 0725da37403499b17b096784b15edae6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a6bddc3903f6a6922c0ab03a3ba2a65c67ef085bec5807493eace122485b54d1
const $a4f88c0b86e6c5fb$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ObjectAddCommentProfileWrapperUserQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ObjectAddCommentProfileWrapperUserQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "0725da37403499b17b096784b15edae6",
            "id": "a6bddc3903f6a6922c0ab03a3ba2a65c67ef085bec5807493eace122485b54d1",
            "metadata": {},
            "name": "ObjectAddCommentProfileWrapperUserQuery",
            "operationKind": "query",
            "text": "query ObjectAddCommentProfileWrapperUserQuery($id:ID!){user:confluence_atlassianUser(id:$id){id,displayName,photos{value}}}"
        }
    };
}();
$a4f88c0b86e6c5fb$var$node.hash = "d4c2e7d15525539be1b21ee5306d9088";
var $a4f88c0b86e6c5fb$export$2e2bcd8739ae039 = $a4f88c0b86e6c5fb$var$node;
module.exports["default"] = $a4f88c0b86e6c5fb$export$2e2bcd8739ae039;

});


//# sourceMappingURL=FullPageEditorComponent.a436355b.js.map
